/* tslint:disable */
/* eslint:disable */
/**
* @typedef {Object} dialogsApproveChangesParams
* @property {string} adiBuilderType - null
* @property {GUID} appId - app id
* @property {GUID} appInstanceId - app instance id
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} name - name of dialog: delete section / move section to page / delete page / signout / create new site
* @property {string} nodeId - unique number per node, in case this is a list - this is the sectionNodeId
* @property {string} origin - where this dialog was opened from
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {string} targetName - in case of mover section to page, what's the target page: pageId / new page
* @property {GUID} uuid - user id
**/
/**
 * Name: dialogs - Approve Changes. Evid: 48.
 * Event description: Module: dialogs. Flow: user approves changes in a dialog. .

 * adiBuilderType - Type: string.
 *
 * appId - Type: guid. Desc: app id
 *
 * appInstanceId - Type: guid. Desc: app instance id
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * name - Type: string. Desc: name of dialog: delete section / move section to page / delete page / signout / create new site
 *
 * nodeId - Type: string. Desc: unique number per node, in case this is a list - this is the sectionNodeId
 *
 * origin - Type: string. Desc: where this dialog was opened from
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * targetName - Type: string. Desc: in case of mover section to page, what's the target page: pageId / new page
 *
 * uuid - Type: guid. Desc: user id
 * @param {dialogsApproveChangesParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dialogsApproveChanges = function (params) {
    return { evid: 48, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} medHireAProfessionalClickParams
* @property {string} adiBuilderType - M
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} screenResolution - screenResolution
* @property {string} source - "more"
* @property {GUID} uuid - user id
**/
/**
 * Name: MED -  Hire a Professional click. Evid: 840.
 * Event description: click on Hire a Professional from "more" in MED.

 * adiBuilderType - Type: string. Desc: M
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string. Desc: screenResolution
 *
 * source - Type: string. Desc: "more"
 *
 * uuid - Type: guid. Desc: user id
 * @param {medHireAProfessionalClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var medHireAProfessionalClick = function (params) {
    return { evid: 840, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderGoToEditorContinueToProEditorClickParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} origin - migrate old blog homepage/migrate old blog design
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - Go to Editor - Continue to Pro Editor click. Evid: 157.
 * Event description: Module: builder. Flow: user chooses to leave ADI and go to Pro Editor. .

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * origin - Type: string. Desc: migrate old blog homepage/migrate old blog design
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderGoToEditorContinueToProEditorClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderGoToEditorContinueToProEditorClick = function (params) {
    return { evid: 157, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderTopBarBusinessPhoneNumberClickParams
* @property {string} adiBuilderType - desktop/MED/headless
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} origin - top bar/header/footer
* @property {string} screenResolution - user device screen resolution
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - Business Phone Number click. Evid: 284.
 * Event description: Module: builder. Flow: user clicks on Business Phone Number.

 * adiBuilderType - Type: string. Desc: desktop/MED/headless
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * origin - Type: string. Desc: top bar/header/footer
 *
 * screenResolution - Type: string. Desc: user device screen resolution
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderTopBarBusinessPhoneNumberClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderTopBarBusinessPhoneNumberClick = function (params) {
    return { evid: 284, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} loadingFirstTimeLoadCampaignLoadCampaignDataAsyncParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} intervalLoadTime - loading time diff from previous phase
* @property {number} loadTime - loading time till this phase
* @property {GUID} msid - metasite id
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: loading - first time - Load Campaign: Load campaign data (async). Evid: 506.
 * Event description: Module: builder. Flow: phase in opening the builder (first time) started..

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * intervalLoadTime - Type: numeric. Desc: loading time diff from previous phase
 *
 * loadTime - Type: numeric. Desc: loading time till this phase
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {loadingFirstTimeLoadCampaignLoadCampaignDataAsyncParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var loadingFirstTimeLoadCampaignLoadCampaignDataAsync = function (params) {
    return { evid: 506, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} introSiteConverterPhaseInImportStartParams
* @property {string} adiBuilderType - NA
* @property {string} details - e.g. num_of_images_to_import
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {boolean} isHomepage - true if importing the homepage
* @property {number} loadTime - load time from the beginning of the import
* @property {GUID} msid - metasite id
* @property {string} phaseName - phase name
* @property {string} screenResolution - screen resolution
* @property {string} structureId - structure id
* @property {number} totalPages - total number of pages to import
* @property {string} url - site url for conversion
* @property {GUID} uuid - user id
**/
/**
 * Name: intro - Site Converter - phase in import - start. Evid: 123.
 * Event description: Module: builder. Flow: a phase in Site Converter process - start.

 * adiBuilderType - Type: string. Desc: NA
 *
 * details - Type: string. Desc: e.g. num_of_images_to_import
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * isHomepage - Type: bool. Desc: true if importing the homepage
 *
 * loadTime - Type: numeric. Desc: load time from the beginning of the import
 *
 * msid - Type: guid. Desc: metasite id
 *
 * phaseName - Type: string. Desc: phase name
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * structureId - Type: string. Desc: structure id
 *
 * totalPages - Type: numeric. Desc: total number of pages to import
 *
 * url - Type: string. Desc: site url for conversion
 *
 * uuid - Type: guid. Desc: user id
 * @param {introSiteConverterPhaseInImportStartParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var introSiteConverterPhaseInImportStart = function (params) {
    return { evid: 123, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderConnectDomainNavigateToDomainSPagesParams
* @property {string} action - action type: undo/redo
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - Connect Domain - navigate to domain's pages. Evid: 152.
 * Event description: Module: builder. Flow: user navigates from connect domain. .

 * action - Type: string. Desc: action type: undo/redo
 *
 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderConnectDomainNavigateToDomainSPagesParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderConnectDomainNavigateToDomainSPages = function (params) {
    return { evid: 152, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} contentEditorChangeContentColorSuccessParams
* @property {string} adiBuilderType - desktop/mobile
* @property {string} colorLocation - D1, D2, D3, L1, L2, L3
* @property {string} colorType - readable/ unreadable
* @property {string} contentName - content updated: title,subtitle,body,image,button,link, list description,...
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} nodeId - unique number per node, in case this is a list - this is the sectionNodeId
* @property {string} origin - OSI / right click
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - screen resolution
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: contentEditor - change content color success. Evid: 238.
 * Event description: Module: contentEditor. Flow: user chooses a color on the OSI tooltip shown for a specific content in the section.

 * adiBuilderType - Type: string. Desc: desktop/mobile
 *
 * colorLocation - Type: string. Desc: D1, D2, D3, L1, L2, L3
 *
 * colorType - Type: string. Desc: readable/ unreadable
 *
 * contentName - Type: string. Desc: content updated: title,subtitle,body,image,button,link, list description,...
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * nodeId - Type: string. Desc: unique number per node, in case this is a list - this is the sectionNodeId
 *
 * origin - Type: string. Desc: OSI / right click
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {contentEditorChangeContentColorSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var contentEditorChangeContentColorSuccess = function (params) {
    return { evid: 238, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} mediaManagementMediaSettingsClosePanelParams
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id
* @property {string} galleryType - single item/external video/ gallery organizer
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {string} mediaType - single image/image gallery/clipart/shape/bgVideo/extVideo
* @property {GUID} msid - metasite id
* @property {string} nodeId - unique number per node, in case this is a list - this is the sectionNodeId
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: mediaManagement - Media Settings - Close panel. Evid: 413.
 * Event description: Module: mediaManagement. Flow: user closes the settings panel ..

 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id
 *
 * galleryType - Type: string. Desc: single item/external video/ gallery organizer
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * mediaType - Type: string. Desc: single image/image gallery/clipart/shape/bgVideo/extVideo
 *
 * msid - Type: guid. Desc: metasite id
 *
 * nodeId - Type: string. Desc: unique number per node, in case this is a list - this is the sectionNodeId
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {mediaManagementMediaSettingsClosePanelParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var mediaManagementMediaSettingsClosePanel = function (params) {
    return { evid: 413, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} sectionManagementSectionMenuMoveSectionToAnotherPageClickParams
* @property {string} adiBuilderType - null
* @property {string} appId - in case of tpa: app_id/blog
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} nodeId - unique number per node
* @property {string} origin - stage / right click
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: sectionManagement - Section menu - Move section to another page click. Evid: 262.
 * Event description: Module: sectionManagement. Flow: user clicks on 'move section to another page' from the section cog..

 * adiBuilderType - Type: string.
 *
 * appId - Type: string. Desc: in case of tpa: app_id/blog
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * nodeId - Type: string. Desc: unique number per node
 *
 * origin - Type: string. Desc: stage / right click
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {sectionManagementSectionMenuMoveSectionToAnotherPageClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionManagementSectionMenuMoveSectionToAnotherPageClick = function (params) {
    return { evid: 262, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} mediaManagementGalleryOrganizerCloseAddMoreMediaWindowParams
* @property {string} adiBuilderType - null
* @property {string} editMode - manual-tour / auto-tour / no-tour
* @property {GUID} esi - editor session id
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} nodeId - unique number per node, in case this is a list - this is the sectionNodeId
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: mediaManagement - Gallery Organizer - Close add more media window. Evid: 414.
 * Event description: Module: mediaManagement. Flow: user clicks on cancel or X in the media gallery (aka add more media window).

 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: manual-tour / auto-tour / no-tour
 *
 * esi - Type: guid. Desc: editor session id
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * nodeId - Type: string. Desc: unique number per node, in case this is a list - this is the sectionNodeId
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {mediaManagementGalleryOrganizerCloseAddMoreMediaWindowParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var mediaManagementGalleryOrganizerCloseAddMoreMediaWindow = function (params) {
    return { evid: 414, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} sectionDesignChangeSlideshowDurationStartParams
* @property {string} adiBuilderType - desktop / mobile/ MED....
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} name - slidshow duration. e.g 3sec
* @property {number} revision - builder version
* @property {string} screenResolution - screen_resolution
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: sectionDesign - change slideshow duration - start. Evid: 580.
 * Event description: Module: sectionDesign. Flow: user changes the slide show duration.

 * adiBuilderType - Type: string. Desc: desktop / mobile/ MED....
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * name - Type: string. Desc: slidshow duration. e.g 3sec
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string. Desc: screen_resolution
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {sectionDesignChangeSlideshowDurationStartParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionDesignChangeSlideshowDurationStart = function (params) {
    return { evid: 580, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderClickOnAssistantItemParams
* @property {string} adiBuilderType - ADI builder type
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} name - article id/tour name
* @property {string} origin - tours list/ main panel
* @property {number} revision - revision
* @property {string} screenResolution - screen_resolution
* @property {string} structureId - structure id
* @property {string} text - searched text if exists
* @property {string} type - article/tour
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - click on assistant item. Evid: 72.
 * Event description: Module: builder . Flow: user clicks on an item in the assia.

 * adiBuilderType - Type: string. Desc: ADI builder type
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * name - Type: string. Desc: article id/tour name
 *
 * origin - Type: string. Desc: tours list/ main panel
 *
 * revision - Type: numeric. Desc: revision
 *
 * screenResolution - Type: string. Desc: screen_resolution
 *
 * structureId - Type: string. Desc: structure id
 *
 * text - Type: string. Desc: searched text if exists
 *
 * type - Type: string. Desc: article/tour
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderClickOnAssistantItemParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderClickOnAssistantItem = function (params) {
    return { evid: 72, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} formEditorEditButtonParams
* @property {string} adiBuilderType - MED /desktop /headless
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {number} fieldLength - length of text in the field
* @property {string} fieldName - which field is updated: title,subtitle,body,image,button,link, list description
* @property {string} fieldType - text/ dropdown/ link / long text
* @property {string} fieldValue - value selected - only for dropdown fields / empty when user clears field
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} nodeId - unique number per node, in case this is a list - this is the sectionNodeId
* @property {string} origin - stage / panel
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - -
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: formEditor - edit button. Evid: 480.
 * Event description: Module: contentEditor. Flow: user edits a field in the form.

 * adiBuilderType - Type: string. Desc: MED /desktop /headless
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * fieldLength - Type: numeric. Desc: length of text in the field
 *
 * fieldName - Type: string. Desc: which field is updated: title,subtitle,body,image,button,link, list description
 *
 * fieldType - Type: string. Desc: text/ dropdown/ link / long text
 *
 * fieldValue - Type: string. Desc: value selected - only for dropdown fields / empty when user clears field
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * nodeId - Type: string. Desc: unique number per node, in case this is a list - this is the sectionNodeId
 *
 * origin - Type: string. Desc: stage / panel
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string. Desc: -
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {formEditorEditButtonParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var formEditorEditButton = function (params) {
    return { evid: 480, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} contentEditorDeleteSecondaryButtonParams
* @property {string} adiBuilderType - desktop / MED / ...
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {GUID} msid - metasite id
* @property {string} nodeId - unique number per node, in case this is a list - this is the sectionNodeId
* @property {string} origin - OSI / right click
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - screen resolution
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
**/
/**
 * Name: contentEditor - Delete Secondary Button. Evid: 426.
 * Event description: Module: contentEditor. Flow: user on delete a secondary button.

 * adiBuilderType - Type: string. Desc: desktop / MED / ...
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * nodeId - Type: string. Desc: unique number per node, in case this is a list - this is the sectionNodeId
 *
 * origin - Type: string. Desc: OSI / right click
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 * @param {contentEditorDeleteSecondaryButtonParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var contentEditorDeleteSecondaryButton = function (params) {
    return { evid: 426, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderPreviewSitePageViewParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - Preview Site - page view. Evid: 160.
 * Event description: Module: builder. Flow: preview site page view. .

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderPreviewSitePageViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderPreviewSitePageView = function (params) {
    return { evid: 160, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderAutosaveTryToParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} instanceId - instance_id, represents the story/msid
* @property {GUID} msid - meat site id
* @property {number} revision - structure id
* @property {boolean} saveToSanta - param=1, when trying to save to santa as well as to consumer
* @property {string} screenResolution - null
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - autosave - try to. Evid: 168.
 * Event description: Module: builder. Flow: try to autosave..

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * instanceId - Type: string. Desc: instance_id, represents the story/msid
 *
 * msid - Type: guid. Desc: meat site id
 *
 * revision - Type: numeric. Desc: structure id
 *
 * saveToSanta - Type: bool. Desc: param=1, when trying to save to santa as well as to consumer
 *
 * screenResolution - Type: string.
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderAutosaveTryToParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderAutosaveTryTo = function (params) {
    return { evid: 168, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} sectionDesignUploadBackgroundClickParams
* @property {string} adiBuilderType - null
* @property {string} designId - id of the design
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {string} mediaType - type of background: image,gallery,video...
* @property {GUID} msid - metasite id
* @property {string} name - regular/header/list background
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: sectionDesign - upload background click. Evid: 566.
 * Event description: Module: sectionDesign. Flow: user clicks on upload section background.

 * adiBuilderType - Type: string.
 *
 * designId - Type: string. Desc: id of the design
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * mediaType - Type: string. Desc: type of background: image,gallery,video...
 *
 * msid - Type: guid. Desc: metasite id
 *
 * name - Type: string. Desc: regular/header/list background
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {sectionDesignUploadBackgroundClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionDesignUploadBackgroundClick = function (params) {
    return { evid: 566, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} sectionManagementSeeAllLessSectionsClickParams
* @property {string} action - see all / see less
* @property {string} adiBuilderType - mobile / desktop
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} screenResolution - screen resolution
* @property {string} structureId - structure id
**/
/**
 * Name: sectionManagement - See all/less sections click. Evid: 273.
 * Event description: Module: sectionManagement. Flow: when user clicks "See all" or "See less" on Add Section panel.

 * action - Type: string. Desc: see all / see less
 *
 * adiBuilderType - Type: string. Desc: mobile / desktop
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * structureId - Type: string. Desc: structure id
 * @param {sectionManagementSeeAllLessSectionsClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionManagementSeeAllLessSectionsClick = function (params) {
    return { evid: 273, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderFullPageDesignBubbleShowParams
* @property {string} adiBuilderType - -
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} name - bubble text description
* @property {string} screenResolution - -
* @property {string} structureId - structure id
* @property {string} triggerName - fpd - second load / fpd - ugliness image on image
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - bubble show. Evid: 33.
 * Event description: Module: builder. Flow: when bubble appears in the builder.

 * adiBuilderType - Type: string. Desc: -
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * name - Type: string. Desc: bubble text description
 *
 * screenResolution - Type: string. Desc: -
 *
 * structureId - Type: string. Desc: structure id
 *
 * triggerName - Type: string. Desc: fpd - second load / fpd - ugliness image on image
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderFullPageDesignBubbleShowParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderFullPageDesignBubbleShow = function (params) {
    return { evid: 33, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} siteDesignDesignDropdownListOpenOnHoverParams
* @property {string} adiBuilderType - desktop / mobile
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - screen resolution
* @property {string} structureId - structure id
**/
/**
 * Name: siteDesign - Design dropdown list open on hover. Evid: 337.
 * Event description: Module: siteDesign. Flow: user hovers (for 2 seconds) on the design/site design  button and the dropdown list is open.

 * adiBuilderType - Type: string. Desc: desktop / mobile
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * structureId - Type: string. Desc: structure id
 * @param {siteDesignDesignDropdownListOpenOnHoverParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteDesignDesignDropdownListOpenOnHover = function (params) {
    return { evid: 337, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderLoadingExistingSiteStartParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editing session, generated on client
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {string} loadType - existing site / template
* @property {GUID} msid - metasite id
* @property {string} origin - from where the builder is opened: intro / home
* @property {GUID} originalEsi - ESI generated by the server or passed via query param
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - loading - existing site - start. Evid: 135.
 * Event description: Module: builder. Flow: builder is starting to load an existing site (NOT from the intro). .

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editing session, generated on client
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * loadType - Type: string. Desc: existing site / template
 *
 * msid - Type: guid. Desc: metasite id
 *
 * origin - Type: string. Desc: from where the builder is opened: intro / home
 *
 * originalEsi - Type: guid. Desc: ESI generated by the server or passed via query param
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderLoadingExistingSiteStartParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderLoadingExistingSiteStart = function (params) {
    return { evid: 135, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} tourWhatSNextShowMenuParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} name - tab opened: tours/smart assist
* @property {string} origin - go to quick actions button, click tab from smart assist, assistant main button...
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} state - for smart assist: array of item types, 0 if empty. for tours: num of tours that are done
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: tour - Assistant Menu Shown. Evid: 53.
 * Event description: Module: tour. Flow: Assistant menu is shown.

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * name - Type: string. Desc: tab opened: tours/smart assist
 *
 * origin - Type: string. Desc: go to quick actions button, click tab from smart assist, assistant main button...
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * state - Type: string. Desc: for smart assist: array of item types, 0 if empty. for tours: num of tours that are done
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {tourWhatSNextShowMenuParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tourWhatSNextShowMenu = function (params) {
    return { evid: 53, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderIntroQuestionsDialogBusinessTypeSelectedParams
* @property {string} adiBuilderType - ADI builder type
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} mainCategory - the category from the 'vertical selector' category that the user chose
* @property {string} name - selected  business type
* @property {string} origin - create from template/ builder
* @property {string} screenResolution - screen resolution
* @property {GUID} uuid - user id
* @property {string} value - category/name submitted
**/
/**
 * Name: builder - intro questions dialog - business type selected. Evid: 92.
 * Event description: Module: intro. Flow: users selects a business type in the questions from intro viewed as dialog in builder.

 * adiBuilderType - Type: string. Desc: ADI builder type
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * mainCategory - Type: string. Desc: the category from the 'vertical selector' category that the user chose
 *
 * name - Type: string. Desc: selected  business type
 *
 * origin - Type: string. Desc: create from template/ builder
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * uuid - Type: guid. Desc: user id
 *
 * value - Type: string. Desc: category/name submitted
 * @param {builderIntroQuestionsDialogBusinessTypeSelectedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderIntroQuestionsDialogBusinessTypeSelected = function (params) {
    return { evid: 92, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} sectionDesignChangeBackgroundClickParams
* @property {string} adiBuilderType - null
* @property {string} designId - id of the design
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {string} mediaType - type of background: image,gallery,color...
* @property {GUID} msid - metasite id
* @property {string} name - regular/header/list background
* @property {number} position - position of selected background in background type
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: sectionDesign - change background - click. Evid: 562.
 * Event description: Module: sectionDesign. Flow: user changes section background.

 * adiBuilderType - Type: string.
 *
 * designId - Type: string. Desc: id of the design
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * mediaType - Type: string. Desc: type of background: image,gallery,color...
 *
 * msid - Type: guid. Desc: metasite id
 *
 * name - Type: string. Desc: regular/header/list background
 *
 * position - Type: numeric. Desc: position of selected background in background type
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {sectionDesignChangeBackgroundClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionDesignChangeBackgroundClick = function (params) {
    return { evid: 562, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} sectionDesignFocalPointPanelOpenParams
* @property {string} adiBuilderType - mobile or desktop editor
* @property {string} designId - id of the design
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {GUID} msid - metasite id
* @property {number} revision - builder version
* @property {string} screenResolution - screen resolution
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
**/
/**
 * Name: sectionDesign - focal point panel open. Evid: 582.
 * Event description: Module: sectionDesign. Flow: user clicks on "position" in media settings panel and opens the Image Position panel.

 * adiBuilderType - Type: string. Desc: mobile or desktop editor
 *
 * designId - Type: string. Desc: id of the design
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 * @param {sectionDesignFocalPointPanelOpenParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionDesignFocalPointPanelOpen = function (params) {
    return { evid: 582, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} contentEditorUpdateEmbedSettingsParams
* @property {string} adiBuilderType - MED/ desktop
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {number} fieldLength - length of text in the field
* @property {string} fieldName - type / url / frame height /  frame width /
* @property {string} fieldValue - value selected
* @property {GUID} msid - metasite id
* @property {string} nodeId - unique number per node, in case this is a list - this is the sectionNodeId
* @property {string} origin - panel
* @property {number} revision - builder version
* @property {string} screenResolution - -
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - embed
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: contentEditor - update embed settings. Evid: 427.
 * Event description: Module: contentEditor. Flow: user edits a field inside a embed settings panel.

 * adiBuilderType - Type: string. Desc: MED/ desktop
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * fieldLength - Type: numeric. Desc: length of text in the field
 *
 * fieldName - Type: string. Desc: type / url / frame height /  frame width /
 *
 * fieldValue - Type: string. Desc: value selected
 *
 * msid - Type: guid. Desc: metasite id
 *
 * nodeId - Type: string. Desc: unique number per node, in case this is a list - this is the sectionNodeId
 *
 * origin - Type: string. Desc: panel
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string. Desc: -
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: embed
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {contentEditorUpdateEmbedSettingsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var contentEditorUpdateEmbedSettings = function (params) {
    return { evid: 427, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} loadingFirstTimeLoadCampaignLoadCampaignDataCompleteParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} intervalLoadTime - loading time diff from previous phase
* @property {number} loadTime - loading time till this phase
* @property {GUID} msid - metasite id
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: loading - first time - Load Campaign: Load campaign data complete. Evid: 507.
 * Event description: Module: builder. Flow: phase in opening the builder (first time) completed..

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * intervalLoadTime - Type: numeric. Desc: loading time diff from previous phase
 *
 * loadTime - Type: numeric. Desc: loading time till this phase
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {loadingFirstTimeLoadCampaignLoadCampaignDataCompleteParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var loadingFirstTimeLoadCampaignLoadCampaignDataComplete = function (params) {
    return { evid: 507, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderBusinessInfoEditBusinessInfoPageViewParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - Business Info - Edit business info page view. Evid: 144.
 * Event description: Module: builder. Flow: business info page is shown. .

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderBusinessInfoEditBusinessInfoPageViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderBusinessInfoEditBusinessInfoPageView = function (params) {
    return { evid: 144, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderTopBarNewsAndUpdatesClickParams
* @property {string} adiBuilderType - desktop/MED/headless
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} screenResolution - user device screen resolution
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - Top Bar - News and Updates click. Evid: 282.
 * Event description: Module: builder. Flow: user clicks on News and Updates in Site menu.

 * adiBuilderType - Type: string. Desc: desktop/MED/headless
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string. Desc: user device screen resolution
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderTopBarNewsAndUpdatesClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderTopBarNewsAndUpdatesClick = function (params) {
    return { evid: 282, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} medBuilderUpdateSectionSuccessParams
* @property {string} adiBuilderType - MED
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} loadTime - time elapsed from start
* @property {GUID} msid - metasite id
* @property {number} revision - builder version
* @property {string} screenResolution - screen resolution
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} selectedLayout - layout id
* @property {string} structureId - structure id
* @property {string} type - single / list/ item
* @property {GUID} uuid - user id
**/
/**
 * Name: MED - Builder - Update Section Success. Evid: 827.
 * Event description: Module: MED. Flow: When the user's changes (made in the section panel) are successfully done..

 * adiBuilderType - Type: string. Desc: MED
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * loadTime - Type: numeric. Desc: time elapsed from start
 *
 * msid - Type: guid. Desc: metasite id
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * selectedLayout - Type: string. Desc: layout id
 *
 * structureId - Type: string. Desc: structure id
 *
 * type - Type: string. Desc: single / list/ item
 *
 * uuid - Type: guid. Desc: user id
 * @param {medBuilderUpdateSectionSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var medBuilderUpdateSectionSuccess = function (params) {
    return { evid: 827, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} migrateOldBlogLearnMoreClickParams
* @property {string} adiBuilderType - desktop/MED
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} origin - homepage / design
* @property {string} screenResolution - resolution on user device screen
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - migrate old blog - Learn more click. Evid: 192.
 * Event description: Module: Migrate old Blog. Flow: user clicks 'Learn more' in a pop up window.

 * adiBuilderType - Type: string. Desc: desktop/MED
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * origin - Type: string. Desc: homepage / design
 *
 * screenResolution - Type: string. Desc: resolution on user device screen
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {migrateOldBlogLearnMoreClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var migrateOldBlogLearnMoreClick = function (params) {
    return { evid: 192, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} pagesManagerSeoPanelIsLoadedParams
* @property {string} adiBuilderType - null
* @property {string} appId - in case of tpa: app_id/blog
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} origin - OSI / right click
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: pagesManager - SEO panel is loaded. Evid: 362.
 * Event description: Module: pagesManager. Flow: user clicks on 'page seo' and the seo panel is loaded. .

 * adiBuilderType - Type: string.
 *
 * appId - Type: string. Desc: in case of tpa: app_id/blog
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * origin - Type: string. Desc: OSI / right click
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {pagesManagerSeoPanelIsLoadedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pagesManagerSeoPanelIsLoaded = function (params) {
    return { evid: 362, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} mediaManagementClosePhotoStudioWindowParams
* @property {string} action - save/cancel
* @property {string} adiBuilderType - -
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - -
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: mediaManagement - save/close photo studio window. Evid: 399.
 * Event description: Module: mediaManagement. Flow: save/close photo studio window.

 * action - Type: string. Desc: save/cancel
 *
 * adiBuilderType - Type: string. Desc: -
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string. Desc: -
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {mediaManagementClosePhotoStudioWindowParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var mediaManagementClosePhotoStudioWindow = function (params) {
    return { evid: 399, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} introBusinessLocationPagePasteAddressParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} lod - level of details of the location (exact / street / neighbourhood / city / state / country )
* @property {string} mainCategory - the category from the 'vertical selector' category that the user chose
* @property {number} noOfSuggestions - no of results from Google
* @property {string} screenResolution - null
* @property {string} text - searched text
* @property {GUID} uuid - user id
**/
/**
 * Name: intro - business location page - paste address. Evid: 116.
 * Event description: Module: intro. Flow: user pastes an address in the location page..

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * lod - Type: string. Desc: level of details of the location (exact / street / neighbourhood / city / state / country )
 *
 * mainCategory - Type: string. Desc: the category from the 'vertical selector' category that the user chose
 *
 * noOfSuggestions - Type: numeric. Desc: no of results from Google
 *
 * screenResolution - Type: string.
 *
 * text - Type: string. Desc: searched text
 *
 * uuid - Type: guid. Desc: user id
 * @param {introBusinessLocationPagePasteAddressParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var introBusinessLocationPagePasteAddress = function (params) {
    return { evid: 116, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} contentEditorChangeComponentFontSizeParams
* @property {string} adiBuilderType - desktop / mobile / MED...
* @property {string} direction - up / down
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} fieldName - which field is updated: title,subtitle,body,button
* @property {string} fontSize - font size
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} origin - OSI / right click
* @property {number} revision - builder version
* @property {string} screenResolution - screen resolution
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: contentEditor - Change component font size. Evid: 198.
 * Event description: Module: contentEditor. Flow: user changes font size of a single component.

 * adiBuilderType - Type: string. Desc: desktop / mobile / MED...
 *
 * direction - Type: string. Desc: up / down
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * fieldName - Type: string. Desc: which field is updated: title,subtitle,body,button
 *
 * fontSize - Type: string. Desc: font size
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * origin - Type: string. Desc: OSI / right click
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {contentEditorChangeComponentFontSizeParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var contentEditorChangeComponentFontSize = function (params) {
    return { evid: 198, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} contentEditorItemReorderSuccessParams
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} loadTime - time in ms
* @property {GUID} msid - metasite id
* @property {string} nodeId - unique number per node, in case this is a list - this is the sectionNodeId
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: contentEditor - Item reorder - success. Evid: 218.
 * Event description: Module: contentEditor. Flow: items order changed successfully on stage. .

 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * loadTime - Type: numeric. Desc: time in ms
 *
 * msid - Type: guid. Desc: metasite id
 *
 * nodeId - Type: string. Desc: unique number per node, in case this is a list - this is the sectionNodeId
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {contentEditorItemReorderSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var contentEditorItemReorderSuccess = function (params) {
    return { evid: 218, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderFullPageDesignScrollParams
* @property {string} adiBuilderType - -
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} mode - builder/welcome
* @property {GUID} msid - metasite id
* @property {number} position - position of the chosen option
* @property {string} screenResolution - -
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - full page design - scroll. Evid: 34.
 * Event description: Module: builder. Flow: when the user scrolls in full page design.

 * adiBuilderType - Type: string. Desc: -
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * mode - Type: string. Desc: builder/welcome
 *
 * msid - Type: guid. Desc: metasite id
 *
 * position - Type: numeric. Desc: position of the chosen option
 *
 * screenResolution - Type: string. Desc: -
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderFullPageDesignScrollParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderFullPageDesignScroll = function (params) {
    return { evid: 34, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} mediaManagementExternalVideoSwitchSearchSourceParams
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} nodeId - unique number per node, in case this is a list - this is the sectionNodeId
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} source - video source: vimeo / youtube
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: mediaManagement - External Video - switch search source. Evid: 408.
 * Event description: Module: mediaManagement. Flow: user switches between vimeo and youtube sources. .

 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * nodeId - Type: string. Desc: unique number per node, in case this is a list - this is the sectionNodeId
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * source - Type: string. Desc: video source: vimeo / youtube
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {mediaManagementExternalVideoSwitchSearchSourceParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var mediaManagementExternalVideoSwitchSearchSource = function (params) {
    return { evid: 408, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} tourLastStepSelectionKeepOrTryAnotherParams
* @property {string} adiBuilderType - null
* @property {string} button - button clicked: show me how / do it for me
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} name - name of tour: welcome / preview / design-entire website / design-fonts&colors / edit section / add section / add page
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: tour - last step selection (keep or try another). Evid: 58.
 * Event description: Module: tour. Flow: user finishes a tour in "do it for me" mode. .

 * adiBuilderType - Type: string.
 *
 * button - Type: string. Desc: button clicked: show me how / do it for me
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * name - Type: string. Desc: name of tour: welcome / preview / design-entire website / design-fonts&colors / edit section / add section / add page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {tourLastStepSelectionKeepOrTryAnotherParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tourLastStepSelectionKeepOrTryAnother = function (params) {
    return { evid: 58, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} loadingFirstTimeWizardServiceInitBFinalizeCoreInitParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} intervalLoadTime - loading time diff from previous phase
* @property {number} loadTime - loading time till this phase
* @property {GUID} msid - metasite id
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: loading - first time - WizardService init B: Finalize core init. Evid: 504.
 * Event description: Module: builder. Flow: phase in opening the builder (first time) started. WizardService init B, Finialize core init (waits for document services init).

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * intervalLoadTime - Type: numeric. Desc: loading time diff from previous phase
 *
 * loadTime - Type: numeric. Desc: loading time till this phase
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {loadingFirstTimeWizardServiceInitBFinalizeCoreInitParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var loadingFirstTimeWizardServiceInitBFinalizeCoreInit = function (params) {
    return { evid: 504, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} contentEditorImageCropZoomInZoomOutParams
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} nodeId - unique number per node, in case this is a list - this is the sectionNodeId
* @property {string} objectType - single / list / field
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
* @property {string} zoomType - zoom in / zoom out
**/
/**
 * Name: contentEditor - Image Crop - zoom in / zoom out. Evid: 209.
 * Event description: Module: contentEditor. Flow: user changes the zoom-in/out in the crop tool. .

 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * nodeId - Type: string. Desc: unique number per node, in case this is a list - this is the sectionNodeId
 *
 * objectType - Type: string. Desc: single / list / field
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 *
 * zoomType - Type: string. Desc: zoom in / zoom out
 * @param {contentEditorImageCropZoomInZoomOutParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var contentEditorImageCropZoomInZoomOut = function (params) {
    return { evid: 209, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderTopBarUpgradeClickParams
* @property {string} adiBuilderType - desktop/MED/headless
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {string} key - premium_banner_adi_header/premium_banner_adi_body/premium_banner_adi_cta1/premium_banner_adi_cta2/premium_banner_adi_sale_header/premium_banner_adi_sale_body/premium_banner_adi_sale_cta1/premium_banner_adi_sale_cta2
* @property {GUID} msid - metasite id
* @property {string} screenResolution - user device screen resolution
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - Top Bar - Upgrade click. Evid: 280.
 * Event description: Module: builder. Flow: user clicks on Upgrade.

 * adiBuilderType - Type: string. Desc: desktop/MED/headless
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * key - Type: string. Desc: premium_banner_adi_header/premium_banner_adi_body/premium_banner_adi_cta1/premium_banner_adi_cta2/premium_banner_adi_sale_header/premium_banner_adi_sale_body/premium_banner_adi_sale_cta1/premium_banner_adi_sale_cta2
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string. Desc: user device screen resolution
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderTopBarUpgradeClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderTopBarUpgradeClick = function (params) {
    return { evid: 280, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} introMoreServicesDropdownOpenedParams
* @property {string} adiBuilderType - -
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} mainCategory - the category from the 'vertical selector' category that the user chose
* @property {string} recommendedApps - recommended apps that are already presented
* @property {string} screenResolution - -
* @property {GUID} uuid - user id
**/
/**
 * Name: intro - more services dropdown opened. Evid: 96.
 * Event description: Module: intro. Flow: user opens the more features part in the services selection page in the intro.

 * adiBuilderType - Type: string. Desc: -
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * mainCategory - Type: string. Desc: the category from the 'vertical selector' category that the user chose
 *
 * recommendedApps - Type: string. Desc: recommended apps that are already presented
 *
 * screenResolution - Type: string. Desc: -
 *
 * uuid - Type: guid. Desc: user id
 * @param {introMoreServicesDropdownOpenedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var introMoreServicesDropdownOpened = function (params) {
    return { evid: 96, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} pagesManagerClickOnDesiredNewPageParams
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {boolean} is_columns - flag for columns in selected layout
* @property {GUID} msid - metasite id
* @property {number} noOfSuggestions - int number that represents the number of suggested layouts that the user saw
* @property {string} origin - pages panel / link dialog
* @property {string} pageId - number of page
* @property {string} place - where the group is placed: recommended / others / expanded list
* @property {number} placeOfSelected - int number that represents the place of the selected layout (1 for the first,…)
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} selectedLayout - layout id
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: pagesManager - Click on desired new page. Evid: 353.
 * Event description: Module: pagesManager. Flow: user chooses a layout of the new page. .

 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * is_columns - Type: bool. Desc: flag for columns in selected layout
 *
 * msid - Type: guid. Desc: metasite id
 *
 * noOfSuggestions - Type: numeric. Desc: int number that represents the number of suggested layouts that the user saw
 *
 * origin - Type: string. Desc: pages panel / link dialog
 *
 * pageId - Type: string. Desc: number of page
 *
 * place - Type: string. Desc: where the group is placed: recommended / others / expanded list
 *
 * placeOfSelected - Type: numeric. Desc: int number that represents the place of the selected layout (1 for the first,…)
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * selectedLayout - Type: string. Desc: layout id
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {pagesManagerClickOnDesiredNewPageParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pagesManagerClickOnDesiredNewPage = function (params) {
    return { evid: 353, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} sectionDesignChangeTextPositionClickParams
* @property {string} adiBuilderType - mobile or desktop editor
* @property {string} designId - id of the design
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {number} revision - builder version
* @property {string} screenResolution - screen resolution
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} setId - unique identifier of the font set
* @property {string} structureId - structure id
* @property {string} textPosition - text position: top_left,bottom_right,mid_right...
* @property {GUID} uuid - user id
**/
/**
 * Name: sectionDesign - change text position - click. Evid: 574.
 * Event description: Module: sectionDesign. Flow: user changes section text position.

 * adiBuilderType - Type: string. Desc: mobile or desktop editor
 *
 * designId - Type: string. Desc: id of the design
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * setId - Type: string. Desc: unique identifier of the font set
 *
 * structureId - Type: string. Desc: structure id
 *
 * textPosition - Type: string. Desc: text position: top_left,bottom_right,mid_right...
 *
 * uuid - Type: guid. Desc: user id
 * @param {sectionDesignChangeTextPositionClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionDesignChangeTextPositionClick = function (params) {
    return { evid: 574, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} introReCaptchaPageNavigationClickParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} navButton - name of navigation button: next / skip / back / escape
* @property {string} screenResolution - screen resolution
**/
/**
 * Name: intro - reCaptcha page - navigation click. Evid: 601.
 * Event description: Module: intro. Flow: user clicks on a navigation button on the reCaptcha page (anon flow).

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * navButton - Type: string. Desc: name of navigation button: next / skip / back / escape
 *
 * screenResolution - Type: string. Desc: screen resolution
 * @param {introReCaptchaPageNavigationClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var introReCaptchaPageNavigationClick = function (params) {
    return { evid: 601, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} siteDesignDesignWindowWasClosedParams
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} name - sub panel name: color set / font set
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: siteDesign - Design window was closed. Evid: 309.
 * Event description: Module: siteDesign. Flow: user closes the design panels..

 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * name - Type: string. Desc: sub panel name: color set / font set
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {siteDesignDesignWindowWasClosedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteDesignDesignWindowWasClosed = function (params) {
    return { evid: 309, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} contentEditorDataValidationMessageDisplayedParams
* @property {string} adiBuilderType - desktop / MED / ...
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} fieldName - field name for whom the messages relevant
* @property {string} industryId - industry id
* @property {string} message - messages description
* @property {GUID} msid - metasite id
* @property {string} origin - from which screen the validation sent
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - screen resolution
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
**/
/**
 * Name: contentEditor - Data validation Message Displayed. Evid: 429.
 * Event description: Module: contentEditor. Flow: validation message is shown.

 * adiBuilderType - Type: string. Desc: desktop / MED / ...
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * fieldName - Type: string. Desc: field name for whom the messages relevant
 *
 * industryId - Type: string. Desc: industry id
 *
 * message - Type: string. Desc: messages description
 *
 * msid - Type: guid. Desc: metasite id
 *
 * origin - Type: string. Desc: from which screen the validation sent
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 * @param {contentEditorDataValidationMessageDisplayedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var contentEditorDataValidationMessageDisplayed = function (params) {
    return { evid: 429, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} introFullStoryStartedParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} fullstoryurl - link to fullstory recording
* @property {string} industryId - industry id
* @property {string} mainCategory - the category from the 'vertical selector' category that the user chose
* @property {number} revision - revision
* @property {string} screenResolution - null
* @property {string} structureId - structure id
**/
/**
 * Name: intro -> Full Story Started. Evid: 11.
 * Event description: Module: intro. Flow: intro - full story started recording session..

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * fullstoryurl - Type: string. Desc: link to fullstory recording
 *
 * industryId - Type: string. Desc: industry id
 *
 * mainCategory - Type: string. Desc: the category from the 'vertical selector' category that the user chose
 *
 * revision - Type: numeric. Desc: revision
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 * @param {introFullStoryStartedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var introFullStoryStarted = function (params) {
    return { evid: 11, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderTopBarConnectDomainClickParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - Top Bar - Connect Domain click. Evid: 150.
 * Event description: Module: builder. Flow: user clicks on site > connect domain. .

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderTopBarConnectDomainClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderTopBarConnectDomainClick = function (params) {
    return { evid: 150, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} sectionDesignChangeElementAnimationSuccessParams
* @property {string} adiBuilderType - null
* @property {string} animationType - e.g.: slideshow
* @property {string} designId - id of the design
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} loadTime - time in ms for changing animation
* @property {GUID} msid - metasite id
* @property {string} name - name of animation
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: sectionDesign - change element animation - success. Evid: 558.
 * Event description: Module: sectionDesign. Flow: user changes section element animation - success.

 * adiBuilderType - Type: string.
 *
 * animationType - Type: string. Desc: e.g.: slideshow
 *
 * designId - Type: string. Desc: id of the design
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * loadTime - Type: numeric. Desc: time in ms for changing animation
 *
 * msid - Type: guid. Desc: metasite id
 *
 * name - Type: string. Desc: name of animation
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {sectionDesignChangeElementAnimationSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionDesignChangeElementAnimationSuccess = function (params) {
    return { evid: 558, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderIntroQuestionsDialogClickParams
* @property {string} action - next/dismiss
* @property {string} adiBuilderType - ADI builder type
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} mainCategory - the category from the 'vertical selector' category that the user chose
* @property {string} origin - create from template/ builder
* @property {string} screenResolution - screen resolution
* @property {GUID} uuid - user id
* @property {string} value - category/name submitted
* @property {string} view - name of page: business type / business name
**/
/**
 * Name: builder - intro questions dialog - click. Evid: 91.
 * Event description: Module: intro. Flow: users clicks next/dismiss in the questions from intro viewed as dialog in builder.

 * action - Type: string. Desc: next/dismiss
 *
 * adiBuilderType - Type: string. Desc: ADI builder type
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * mainCategory - Type: string. Desc: the category from the 'vertical selector' category that the user chose
 *
 * origin - Type: string. Desc: create from template/ builder
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * uuid - Type: guid. Desc: user id
 *
 * value - Type: string. Desc: category/name submitted
 *
 * view - Type: string. Desc: name of page: business type / business name
 * @param {builderIntroQuestionsDialogClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderIntroQuestionsDialogClick = function (params) {
    return { evid: 91, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderConnectDomainClosePageParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} name - {X,maybe later}
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - Connect Domain - Close page. Evid: 153.
 * Event description: Module: builder. Flow: user closes the connect domain page. .

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * name - Type: string. Desc: {X,maybe later}
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderConnectDomainClosePageParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderConnectDomainClosePage = function (params) {
    return { evid: 153, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderPublishSiteClosePageParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} referralAdditionalInfo - --
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - Publish Site - Close page. Evid: 165.
 * Event description: Module: builder. Flow: user closes the congrats page (x or continue editting). .

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * referralAdditionalInfo - Type: string. Desc: --
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderPublishSiteClosePageParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderPublishSiteClosePage = function (params) {
    return { evid: 165, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} sectionDesignChangeBackgroundSuccessParams
* @property {string} adiBuilderType - null
* @property {string} designId - id of the design
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} loadTime - time to change background
* @property {string} mediaType - type of background: image,gallery,color...
* @property {GUID} msid - metasite id
* @property {string} name - regular/header/list background
* @property {number} position - position of selected background in background type
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: sectionDesign - change background - success. Evid: 563.
 * Event description: Module: sectionDesign. Flow: user changes section background - success.

 * adiBuilderType - Type: string.
 *
 * designId - Type: string. Desc: id of the design
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * loadTime - Type: numeric. Desc: time to change background
 *
 * mediaType - Type: string. Desc: type of background: image,gallery,color...
 *
 * msid - Type: guid. Desc: metasite id
 *
 * name - Type: string. Desc: regular/header/list background
 *
 * position - Type: numeric. Desc: position of selected background in background type
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {sectionDesignChangeBackgroundSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionDesignChangeBackgroundSuccess = function (params) {
    return { evid: 563, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} siteDesignCustomizeDesignColorPaletteModeAdvancedEditingColorClickParams
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / no-tour
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: siteDesign - Customize Design - color palette mode - Advanced editing color click. Evid: 313.
 * Event description: Module: siteDesign. Flow: user chooses the advanced editing button.

 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / no-tour
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {siteDesignCustomizeDesignColorPaletteModeAdvancedEditingColorClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteDesignCustomizeDesignColorPaletteModeAdvancedEditingColorClick = function (params) {
    return { evid: 313, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} introInfoCardAddEditRemoveInfoParams
* @property {string} action - add / edit / remove
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {number} fieldLength - what is the length of the content that user entered
* @property {string} fieldName - which field is updated: business logo / company name / address / email / phone / facebook / twitter / linkedin / pinterest
* @property {string} fieldType - text/ social / logo
* @property {number} loadTime - loading time from approve to success
* @property {string} mainCategory - the category from the 'vertical selector' category that the user chose
* @property {string} origin - where the user edits: info-card / welcomeTour-before-extraction / welcomeTour-after extraction / clipart-settings-panel / header-panel
* @property {string} screenResolution - null
* @property {GUID} searchGuid - for search results page: every search a new guid is generated by wixwiz server
* @property {GUID} uuid - user id
**/
/**
 * Name: intro - Info Card - add/edit/remove info. Evid: 111.
 * Event description: Module: intro. Flow: user changes a value in the info card. It can be done in the intro funnel & later from welcome tour / top bar.

 * action - Type: string. Desc: add / edit / remove
 *
 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * fieldLength - Type: numeric. Desc: what is the length of the content that user entered
 *
 * fieldName - Type: string. Desc: which field is updated: business logo / company name / address / email / phone / facebook / twitter / linkedin / pinterest
 *
 * fieldType - Type: string. Desc: text/ social / logo
 *
 * loadTime - Type: numeric. Desc: loading time from approve to success
 *
 * mainCategory - Type: string. Desc: the category from the 'vertical selector' category that the user chose
 *
 * origin - Type: string. Desc: where the user edits: info-card / welcomeTour-before-extraction / welcomeTour-after extraction / clipart-settings-panel / header-panel
 *
 * screenResolution - Type: string.
 *
 * searchGuid - Type: guid. Desc: for search results page: every search a new guid is generated by wixwiz server
 *
 * uuid - Type: guid. Desc: user id
 * @param {introInfoCardAddEditRemoveInfoParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var introInfoCardAddEditRemoveInfo = function (params) {
    return { evid: 111, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} siteDesignCustomizeDesignChangeDarkLightModeSuccessParams
* @property {string} adiBuilderType - null
* @property {string} designId - id of the design
* @property {string} editMode - automatic / show me how / no-tour
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} loadTime - loading time between click to success
* @property {number} loading_time - loading time between click to Success
* @property {GUID} msid - metasite id
* @property {string} name - dark/light/...
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: siteDesign - Customize Design - change dark/light mode success. Evid: 319.
 * Event description: Module: siteDesign. Flow: user clicks onchange dark/light mode.

 * adiBuilderType - Type: string.
 *
 * designId - Type: string. Desc: id of the design
 *
 * editMode - Type: string. Desc: automatic / show me how / no-tour
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * loadTime - Type: numeric. Desc: loading time between click to success
 *
 * loading_time - Type: numeric. Desc: loading time between click to Success
 *
 * msid - Type: guid. Desc: metasite id
 *
 * name - Type: string. Desc: dark/light/...
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {siteDesignCustomizeDesignChangeDarkLightModeSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteDesignCustomizeDesignChangeDarkLightModeSuccess = function (params) {
    return { evid: 319, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderMobileMenuShowMenuToggleClickParams
* @property {string} action - on / off
* @property {string} actionType - manual / auto
* @property {string} adiBuilderType - desktop / MED / ...
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {number} revision - builder version
* @property {string} screenResolution - screen resolution
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - mobile menu - show menu toggle click. Evid: 42.
 * Event description: Module: builder. Flow: when user clicks on 'show menu' toggle.

 * action - Type: string. Desc: on / off
 *
 * actionType - Type: string. Desc: manual / auto
 *
 * adiBuilderType - Type: string. Desc: desktop / MED / ...
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderMobileMenuShowMenuToggleClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderMobileMenuShowMenuToggleClick = function (params) {
    return { evid: 42, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} siteDesignCustomizeDesignColorPaletteModeColorSelectParams
* @property {string} adiBuilderType - null
* @property {boolean} advancedEdit - did the pallete open from advanced settings mode or not
* @property {string} editMode - automatic / show me how / no-tour
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} name - which panel the color from: regular,color picker, hex
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: siteDesign - Customize Design - color palette mode - color select. Evid: 312.
 * Event description: Module: siteDesign. Flow: user chooses to change color.

 * adiBuilderType - Type: string.
 *
 * advancedEdit - Type: bool. Desc: did the pallete open from advanced settings mode or not
 *
 * editMode - Type: string. Desc: automatic / show me how / no-tour
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * name - Type: string. Desc: which panel the color from: regular,color picker, hex
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {siteDesignCustomizeDesignColorPaletteModeColorSelectParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteDesignCustomizeDesignColorPaletteModeColorSelect = function (params) {
    return { evid: 312, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} medBuilderPanelCancelParams
* @property {string} adiBuilderType - MED
* @property {GUID} esi - editor session id, for every site editing session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} name - pages / add page / design / more / add section
* @property {string} nodeId - unique number per node, in case this is a list - this is the sectionNodeId
* @property {string} origin - where the panel was loaded from
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - screen resolution
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
**/
/**
 * Name: MED - Builder - Panel Cancel. Evid: 821.
 * Event description: Module: MED. user clicks close.

 * adiBuilderType - Type: string. Desc: MED
 *
 * esi - Type: guid. Desc: editor session id, for every site editing session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * name - Type: string. Desc: pages / add page / design / more / add section
 *
 * nodeId - Type: string. Desc: unique number per node, in case this is a list - this is the sectionNodeId
 *
 * origin - Type: string. Desc: where the panel was loaded from
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 * @param {medBuilderPanelCancelParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var medBuilderPanelCancel = function (params) {
    return { evid: 821, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} contentEditorGalleryLayoutChangedSuccessEventIsCancelledParams
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} galleryType - **deprecated**
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {string} layoutType - **deprecated**
* @property {GUID} msid - metasite id
* @property {number} noOfSuggestions - number of texts in the panel
* @property {number} noOfUserSuggestions - number of texts originates in user's site in the panel
* @property {string} nodeId - unique number per node, in case this is a list - this is the sectionNodeId
* @property {string} origin - OSI / right click
* @property {string} pageId - number of page
* @property {number} placeOfSelected - **deprecated**
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {string} textType - what triggered the text manager: description / title / ....
* @property {GUID} uuid - user id
**/
/**
 * Name: contentEditor - Text Manager is loaded. Evid: 223.
 * Event description: Module: contentEditor. Flow: text manager is loaded..

 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * galleryType - Type: string. Desc: **deprecated**
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * layoutType - Type: string. Desc: **deprecated**
 *
 * msid - Type: guid. Desc: metasite id
 *
 * noOfSuggestions - Type: numeric. Desc: number of texts in the panel
 *
 * noOfUserSuggestions - Type: numeric. Desc: number of texts originates in user's site in the panel
 *
 * nodeId - Type: string. Desc: unique number per node, in case this is a list - this is the sectionNodeId
 *
 * origin - Type: string. Desc: OSI / right click
 *
 * pageId - Type: string. Desc: number of page
 *
 * placeOfSelected - Type: numeric. Desc: **deprecated**
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * textType - Type: string. Desc: what triggered the text manager: description / title / ....
 *
 * uuid - Type: guid. Desc: user id
 * @param {contentEditorGalleryLayoutChangedSuccessEventIsCancelledParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var contentEditorGalleryLayoutChangedSuccessEventIsCancelled = function (params) {
    return { evid: 223, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} stillLoadingSiteParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editing session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} interval - 5 is the default, as this event is sent every 5 seconds
* @property {number} loadTime - cumulative loading time since start event:  evid 125 for new site, evid 135 for existing site
* @property {GUID} msid - metasite id
* @property {string} screenResolution - null
* @property {string} siteMode - existing/new.
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: Still loading site. Evid: 175.
 * Event description: Module: builder. Flow: Sent after every 5 seconds from start loading till site is loaded successfully.

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editing session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * interval - Type: numeric. Desc: 5 is the default, as this event is sent every 5 seconds
 *
 * loadTime - Type: numeric. Desc: cumulative loading time since start event:  evid 125 for new site, evid 135 for existing site
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string.
 *
 * siteMode - Type: string. Desc: existing/new.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {stillLoadingSiteParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var stillLoadingSite = function (params) {
    return { evid: 175, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} tourSmartAssistCardMuteParams
* @property {string} adiBuilderType - mobile / desktop
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} name - name of card
* @property {number} revision - builder version
* @property {string} screenResolution - screen resolution
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: tour - smart assist card mute. Evid: 65.
 * Event description: Module: tour. Flow: user mutes a smart assist card.

 * adiBuilderType - Type: string. Desc: mobile / desktop
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * name - Type: string. Desc: name of card
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {tourSmartAssistCardMuteParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tourSmartAssistCardMute = function (params) {
    return { evid: 65, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} contentEditorChangeButtonStyleSuccessParams
* @property {string} adiBuilderType - desktop/mobile
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} nodeId - unique number per node, in case this is a list - this is the sectionNodeId
* @property {string} objectType - single / list...
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - screen resolution
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {number} styleIndex - position on panel
* @property {GUID} uuid - user id
**/
/**
 * Name: contentEditor - change button style success. Evid: 244.
 * Event description: Module: contentEditor. Flow: user chooses another style for a button.

 * adiBuilderType - Type: string. Desc: desktop/mobile
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * nodeId - Type: string. Desc: unique number per node, in case this is a list - this is the sectionNodeId
 *
 * objectType - Type: string. Desc: single / list...
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * styleIndex - Type: numeric. Desc: position on panel
 *
 * uuid - Type: guid. Desc: user id
 * @param {contentEditorChangeButtonStyleSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var contentEditorChangeButtonStyleSuccess = function (params) {
    return { evid: 244, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} tourTimeoutParams
* @property {string} adiBuilderType - null
* @property {string} button - button clicked: show me how / do it for me
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} lastPhase - last phase of the welcome tour after which timeout occured
* @property {GUID} msid - metasite id
* @property {string} name - name of tour: welcome / preview / design-entire website / design-fonts&colors / edit section / add section / add page
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {number} secondsSinceLastPhase - how many seconds passed since last phase of the tour
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: tour - Timeout. Evid: 59.
 * Event description: Module: tour. Flow: event sent when session timed out for the user during a tour..

 * adiBuilderType - Type: string.
 *
 * button - Type: string. Desc: button clicked: show me how / do it for me
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * lastPhase - Type: numeric. Desc: last phase of the welcome tour after which timeout occured
 *
 * msid - Type: guid. Desc: metasite id
 *
 * name - Type: string. Desc: name of tour: welcome / preview / design-entire website / design-fonts&colors / edit section / add section / add page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * secondsSinceLastPhase - Type: numeric. Desc: how many seconds passed since last phase of the tour
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {tourTimeoutParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tourTimeout = function (params) {
    return { evid: 59, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} contentEditorClickOnHideUnhideParams
* @property {string} action - hide/unhide
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} fieldName - which field is updated: title,subtitle,body,image,button,link, list description
* @property {string} fieldType - text/ dropdown/ link / long text
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} nodeId - unique number per node, in case this is a list - this is the sectionNodeId
* @property {string} origin - where the action was made from (edit panel,OSI dropdown)
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: contentEditor - Click on hide/unhide. Evid: 204.
 * Event description: Module: contentEditor. Flow: user clicks on 'hide/unhide from section'. When user clears the value from a cell it also hides it.  Also, when hiding the top menu. .

 * action - Type: string. Desc: hide/unhide
 *
 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * fieldName - Type: string. Desc: which field is updated: title,subtitle,body,image,button,link, list description
 *
 * fieldType - Type: string. Desc: text/ dropdown/ link / long text
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * nodeId - Type: string. Desc: unique number per node, in case this is a list - this is the sectionNodeId
 *
 * origin - Type: string. Desc: where the action was made from (edit panel,OSI dropdown)
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {contentEditorClickOnHideUnhideParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var contentEditorClickOnHideUnhide = function (params) {
    return { evid: 204, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} loadingExistingSiteInitContentParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} intervalLoadTime - loading time diff from previous phase
* @property {number} loadTime - loading time till this phase
* @property {GUID} msid - metasite id
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: loading - existing site - Init Content. Evid: 138.
 * Event description: Module: builder. Flow: phase in opening the builder (existing site) started..

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * intervalLoadTime - Type: numeric. Desc: loading time diff from previous phase
 *
 * loadTime - Type: numeric. Desc: loading time till this phase
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {loadingExistingSiteInitContentParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var loadingExistingSiteInitContent = function (params) {
    return { evid: 138, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} contentEditorCropImageDialogIsShownParams
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} nodeId - unique number per node, in case this is a list - this is the sectionNodeId
* @property {string} objectType - single / list / field
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} source - media_settings_panel,osi
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: contentEditor - Crop Image dialog is shown. Evid: 208.
 * Event description: Module: contentEditor. Flow: media - user clicks on the crop button and the crop dialog is loaded. .

 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * nodeId - Type: string. Desc: unique number per node, in case this is a list - this is the sectionNodeId
 *
 * objectType - Type: string. Desc: single / list / field
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * source - Type: string. Desc: media_settings_panel,osi
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {contentEditorCropImageDialogIsShownParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var contentEditorCropImageDialogIsShown = function (params) {
    return { evid: 208, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} medGatewayAllocationRequestSuccessParams
* @property {string} adiBuilderType - MED
* @property {GUID} esi - editor session id, for every site editing session
* @property {string} instanceId - instance id
* @property {number} loadTime - time elapsed from trial
* @property {GUID} msid - metasite id
* @property {string} name - mapped already / allocated new / allocate after deallocation
* @property {string} screenResolution - null
**/
/**
 * Name: MED - Gateway Allocation Request Success. Evid: 1801.
 * Event description: Module: MED. Flow: Gateway allocation request returns successfully (allocation occurred).

 * adiBuilderType - Type: string. Desc: MED
 *
 * esi - Type: guid. Desc: editor session id, for every site editing session
 *
 * instanceId - Type: string. Desc: instance id
 *
 * loadTime - Type: numeric. Desc: time elapsed from trial
 *
 * msid - Type: guid. Desc: metasite id
 *
 * name - Type: string. Desc: mapped already / allocated new / allocate after deallocation
 *
 * screenResolution - Type: string.
 * @param {medGatewayAllocationRequestSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var medGatewayAllocationRequestSuccess = function (params) {
    return { evid: 1801, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderCoreLoadingLoadIframeCompleteParams
* @property {string} adiBuilderType - null
* @property {string} colorationLevel - plain, tinted, colorful,...
* @property {string} colorationMode - light, dark, mix
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} intervalLoadTime - **deprecated**
* @property {number} loadTime - **deprecated**
* @property {string} mode - builder/welcome tour
* @property {GUID} msid - metasite id
* @property {string} navigationClick - edit site / skip / preview
* @property {number} position - position of the chosen option
* @property {string} presetList - list of all presets in selected design
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
* @property {string} view - presets preview /  preview
**/
/**
 * Name: builder - full page design - navigation click. Evid: 23.
 * Event description: Module: builder. Flow: when the user chooses one of the options or clicks skip.

 * adiBuilderType - Type: string.
 *
 * colorationLevel - Type: string. Desc: plain, tinted, colorful,...
 *
 * colorationMode - Type: string. Desc: light, dark, mix
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * intervalLoadTime - Type: numeric. Desc: **deprecated**
 *
 * loadTime - Type: numeric. Desc: **deprecated**
 *
 * mode - Type: string. Desc: builder/welcome tour
 *
 * msid - Type: guid. Desc: metasite id
 *
 * navigationClick - Type: string. Desc: edit site / skip / preview
 *
 * position - Type: numeric. Desc: position of the chosen option
 *
 * presetList - Type: string. Desc: list of all presets in selected design
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 *
 * view - Type: string. Desc: presets preview /  preview
 * @param {builderCoreLoadingLoadIframeCompleteParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderCoreLoadingLoadIframeComplete = function (params) {
    return { evid: 23, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} sectionDesignChangeTextAlignmentSuccessParams
* @property {string} adiBuilderType - mobile or desktop editor
* @property {string} designId - id of the design
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} loadTime - time to complete action
* @property {GUID} msid - metasite id
* @property {number} revision - builder version
* @property {string} screenResolution - screen resolution
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} setId - unique identifier of the font set
* @property {string} structureId - structure id
* @property {string} textAlign - text alignment (left,right.center)
* @property {GUID} uuid - user id
**/
/**
 * Name: sectionDesign - change text alignment - success. Evid: 571.
 * Event description: Module: sectionDesign. Flow: user changes section text alignment - success.

 * adiBuilderType - Type: string. Desc: mobile or desktop editor
 *
 * designId - Type: string. Desc: id of the design
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * loadTime - Type: numeric. Desc: time to complete action
 *
 * msid - Type: guid. Desc: metasite id
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * setId - Type: string. Desc: unique identifier of the font set
 *
 * structureId - Type: string. Desc: structure id
 *
 * textAlign - Type: string. Desc: text alignment (left,right.center)
 *
 * uuid - Type: guid. Desc: user id
 * @param {sectionDesignChangeTextAlignmentSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionDesignChangeTextAlignmentSuccess = function (params) {
    return { evid: 571, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} formEditorValueWasDeletedParams
* @property {string} adiBuilderType - -
* @property {string} component - edit-form /edit-form-fields
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} fieldName - which field is updated: title,subtitle,body,image,button,link, list description
* @property {string} fieldType - text/ dropdown/ link / long text
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} nodeId - unique number per node, in case this is a list - this is the sectionNodeId
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - -
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: formEditor - value was deleted. Evid: 482.
 * Event description: Module: contentEditor. Flow: user deletes a value.

 * adiBuilderType - Type: string. Desc: -
 *
 * component - Type: string. Desc: edit-form /edit-form-fields
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * fieldName - Type: string. Desc: which field is updated: title,subtitle,body,image,button,link, list description
 *
 * fieldType - Type: string. Desc: text/ dropdown/ link / long text
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * nodeId - Type: string. Desc: unique number per node, in case this is a list - this is the sectionNodeId
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string. Desc: -
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {formEditorValueWasDeletedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var formEditorValueWasDeleted = function (params) {
    return { evid: 482, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} medBuilderAddPagesSuccessParams
* @property {string} adiBuilderType - MED
* @property {GUID} esi - editor session id, for every site editing session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} loadTime - time elapsed from Add Pages Start
* @property {GUID} msid - metasite id
* @property {number} numOfPages - number of pages
* @property {string} pageNames - page chosen (comma separated)
* @property {number} revision - builder version
* @property {string} screenResolution - screen resolution
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: MED - Builder - Add Pages Success. Evid: 823.
 * Event description: Module: MED. Flow: all pages were successfully added.

 * adiBuilderType - Type: string. Desc: MED
 *
 * esi - Type: guid. Desc: editor session id, for every site editing session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * loadTime - Type: numeric. Desc: time elapsed from Add Pages Start
 *
 * msid - Type: guid. Desc: metasite id
 *
 * numOfPages - Type: numeric. Desc: number of pages
 *
 * pageNames - Type: string. Desc: page chosen (comma separated)
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {medBuilderAddPagesSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var medBuilderAddPagesSuccess = function (params) {
    return { evid: 823, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} introBusinessTypeTypingClientEventParams
* @property {string} adiBuilderType - null
* @property {string} contentLanguage - The content Language used for the intro
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} flow - main funnel/adi intro/marketing templates
* @property {string} mainCategory - the category from the 'vertical selector' category that the user chose
* @property {number} returnedResults - how many resuslts the user sees, 0 for zero matches
* @property {string} screenResolution - null
* @property {string} text - searched text
* @property {GUID} uuid - user id
**/
/**
 * Name: intro - Business type - typing client event. Evid: 102.
 * Event description: Module: intro. Flow: user typed a business type.

 * adiBuilderType - Type: string.
 *
 * contentLanguage - Type: string. Desc: The content Language used for the intro
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * flow - Type: string. Desc: main funnel/adi intro/marketing templates
 *
 * mainCategory - Type: string. Desc: the category from the 'vertical selector' category that the user chose
 *
 * returnedResults - Type: numeric. Desc: how many resuslts the user sees, 0 for zero matches
 *
 * screenResolution - Type: string.
 *
 * text - Type: string. Desc: searched text
 *
 * uuid - Type: guid. Desc: user id
 * @param {introBusinessTypeTypingClientEventParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var introBusinessTypeTypingClientEvent = function (params) {
    return { evid: 102, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} contentEditorFieldWasUpdatedSuccessParams
* @property {string} adiBuilderType - null
* @property {boolean} bestMatchExists - text manager:  true if best match exists in the suggestions
* @property {string} editMode - automatic / show me how / manual
* @property {string} editType - text manager: append / replace
* @property {GUID} esi - editor session id, for every site editting session
* @property {number} fieldLength - length of text in the field
* @property {string} fieldName - which field is updated: title,subtitle,body,image,button,link, list description
* @property {string} fieldPrevValue - text value before update
* @property {string} fieldType - text/ dropdown/ link / long text
* @property {string} fieldValue - value selected - only for dropdown fields / empty when user clears field (starting x/12/20 also includes data for text field
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {boolean} isBestMatch - text manager:  true if best match
* @property {number} loadTime - time it took in ms
* @property {GUID} msid - metasite id
* @property {number} noOfFaces - for images only - no of recognized faces
* @property {string} nodeId - unique number per node, in case this is a list - this is the sectionNodeId
* @property {string} origin - panel / stage
* @property {string} pageId - number of page
* @property {number} position - text manager: index of the text
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {string} textOrigin - cms, user import (imported from facebook page / site/...)
* @property {GUID} uuid - user id
**/
/**
 * Name: contentEditor - Field was updated - success. Evid: 228.
 * Event description: Module: contentEditor. Flow: field was updated successfully. .

 * adiBuilderType - Type: string.
 *
 * bestMatchExists - Type: bool. Desc: text manager:  true if best match exists in the suggestions
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * editType - Type: string. Desc: text manager: append / replace
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * fieldLength - Type: numeric. Desc: length of text in the field
 *
 * fieldName - Type: string. Desc: which field is updated: title,subtitle,body,image,button,link, list description
 *
 * fieldPrevValue - Type: string. Desc: text value before update
 *
 * fieldType - Type: string. Desc: text/ dropdown/ link / long text
 *
 * fieldValue - Type: string. Desc: value selected - only for dropdown fields / empty when user clears field (starting x/12/20 also includes data for text field
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * isBestMatch - Type: bool. Desc: text manager:  true if best match
 *
 * loadTime - Type: numeric. Desc: time it took in ms
 *
 * msid - Type: guid. Desc: metasite id
 *
 * noOfFaces - Type: numeric. Desc: for images only - no of recognized faces
 *
 * nodeId - Type: string. Desc: unique number per node, in case this is a list - this is the sectionNodeId
 *
 * origin - Type: string. Desc: panel / stage
 *
 * pageId - Type: string. Desc: number of page
 *
 * position - Type: numeric. Desc: text manager: index of the text
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * textOrigin - Type: string. Desc: cms, user import (imported from facebook page / site/...)
 *
 * uuid - Type: guid. Desc: user id
 * @param {contentEditorFieldWasUpdatedSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var contentEditorFieldWasUpdatedSuccess = function (params) {
    return { evid: 228, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} sectionDesignChangeElementAnimationClickParams
* @property {string} adiBuilderType - null
* @property {string} animationType - e.g.: slideshow
* @property {string} designId - id of the design
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} name - name of animation
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: sectionDesign - change element animation - click. Evid: 557.
 * Event description: Module: sectionDesign. Flow: user changes section element animation.

 * adiBuilderType - Type: string.
 *
 * animationType - Type: string. Desc: e.g.: slideshow
 *
 * designId - Type: string. Desc: id of the design
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * name - Type: string. Desc: name of animation
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {sectionDesignChangeElementAnimationClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionDesignChangeElementAnimationClick = function (params) {
    return { evid: 557, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} sectionDesignChangeColorClickParams
* @property {string} adiBuilderType - null
* @property {string} designId - id of the design
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} origin - OSI / right click
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: sectionDesign - change color - click. Evid: 551.
 * Event description: Module: sectionDesign. Flow: user changes section color.

 * adiBuilderType - Type: string.
 *
 * designId - Type: string. Desc: id of the design
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * origin - Type: string. Desc: OSI / right click
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {sectionDesignChangeColorClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionDesignChangeColorClick = function (params) {
    return { evid: 551, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} contentEditorImageResolutionImproveToggleSuccessParams
* @property {string} action - on / off
* @property {string} adiBuilderType - desktop / MED / ...
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} improvedImageUrl - url of the improved image
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} loadTime - time elapsed from start
* @property {GUID} msid - metasite id
* @property {string} nodeId - unique number per node, in case this is a list - this is the sectionNodeId
* @property {string} originalImageSize - w X h
* @property {string} originalImageUrl - url of the image uploaded by the user
* @property {string} pageId - number of page
* @property {string} placeholderSize - w X h
* @property {number} revision - builder version
* @property {string} screenResolution - screen resolution
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: contentEditor - Image Resolution Improve toggle success. Evid: 424.
 * Event description: Module: contentEditor. Flow: user clicks the toggle that improves / reset the image quality and then the image changes.

 * action - Type: string. Desc: on / off
 *
 * adiBuilderType - Type: string. Desc: desktop / MED / ...
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * improvedImageUrl - Type: string. Desc: url of the improved image
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * loadTime - Type: numeric. Desc: time elapsed from start
 *
 * msid - Type: guid. Desc: metasite id
 *
 * nodeId - Type: string. Desc: unique number per node, in case this is a list - this is the sectionNodeId
 *
 * originalImageSize - Type: string. Desc: w X h
 *
 * originalImageUrl - Type: string. Desc: url of the image uploaded by the user
 *
 * pageId - Type: string. Desc: number of page
 *
 * placeholderSize - Type: string. Desc: w X h
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {contentEditorImageResolutionImproveToggleSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var contentEditorImageResolutionImproveToggleSuccess = function (params) {
    return { evid: 424, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} contentEditorImageCropCropClickParams
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} name - media size: crop, background, show entire image, box....
* @property {string} nodeId - unique number per node, in case this is a list - this is the sectionNodeId
* @property {string} objectType - single / list / field
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: contentEditor - Switch Media Size click. Evid: 234.
 * Event description: Module: contentEditor. Flow: user clicked on one of the Media Size options in media settings panel.

 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * name - Type: string. Desc: media size: crop, background, show entire image, box....
 *
 * nodeId - Type: string. Desc: unique number per node, in case this is a list - this is the sectionNodeId
 *
 * objectType - Type: string. Desc: single / list / field
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {contentEditorImageCropCropClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var contentEditorImageCropCropClick = function (params) {
    return { evid: 234, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} introClickOnSearchButtonInSelectUserPageParams
* @property {string} address - address typed by user
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} lod - level of details of the location (exact / street / neighbourhood / city / state / country )
* @property {string} mainCategory - the category from the 'vertical selector' category that the user chose
* @property {string} navButton - name of navigation button: next / skip / back / escape
* @property {string} nextView - name of next page: business type / services selection / business name / location / search confirm / search results / edit info card / builder / pro editor
* @property {string} screenResolution - null
* @property {string} text - searched text
* @property {GUID} uuid - user id
**/
/**
 * Name: intro - click on search button in select-user page. Evid: 115.
 * Event description: Module: intro. Flow: user clicks on a search button in select-user page (Wiz event).

 * address - Type: string. Desc: address typed by user
 *
 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * lod - Type: string. Desc: level of details of the location (exact / street / neighbourhood / city / state / country )
 *
 * mainCategory - Type: string. Desc: the category from the 'vertical selector' category that the user chose
 *
 * navButton - Type: string. Desc: name of navigation button: next / skip / back / escape
 *
 * nextView - Type: string. Desc: name of next page: business type / services selection / business name / location / search confirm / search results / edit info card / builder / pro editor
 *
 * screenResolution - Type: string.
 *
 * text - Type: string. Desc: searched text
 *
 * uuid - Type: guid. Desc: user id
 * @param {introClickOnSearchButtonInSelectUserPageParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var introClickOnSearchButtonInSelectUserPage = function (params) {
    return { evid: 115, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} contentEditorChangeContentColorClickParams
* @property {string} adiBuilderType - desktop/mobile
* @property {string} colorLocation - D1, D2, D3, L1, L2, L3
* @property {string} colorType - readable/ unreadable
* @property {string} contentName - which content is updated: title,subtitle,body,image,button,link, list description
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} nodeId - unique number per node, in case this is a list - this is the sectionNodeId
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - screen resolution
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: contentEditor - change content color click. Evid: 237.
 * Event description: Module: contentEditor. Flow: user chooses a color for a specific content in a section.

 * adiBuilderType - Type: string. Desc: desktop/mobile
 *
 * colorLocation - Type: string. Desc: D1, D2, D3, L1, L2, L3
 *
 * colorType - Type: string. Desc: readable/ unreadable
 *
 * contentName - Type: string. Desc: which content is updated: title,subtitle,body,image,button,link, list description
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * nodeId - Type: string. Desc: unique number per node, in case this is a list - this is the sectionNodeId
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {contentEditorChangeContentColorClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var contentEditorChangeContentColorClick = function (params) {
    return { evid: 237, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} loadingFirstTimeAssistantInitAssistantParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} intervalLoadTime - loading time diff from previous phase
* @property {number} loadTime - loading time till this phase
* @property {GUID} msid - metasite id
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: loading - first time - Assistant: Init Assistant. Evid: 503.
 * Event description: Module: builder. Flow: phase in opening the builder (first time) started.

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * intervalLoadTime - Type: numeric. Desc: loading time diff from previous phase
 *
 * loadTime - Type: numeric. Desc: loading time till this phase
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {loadingFirstTimeAssistantInitAssistantParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var loadingFirstTimeAssistantInitAssistant = function (params) {
    return { evid: 503, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} introPlatformsScreenInteractiveParams
* @property {string} action - type / click
* @property {string} adiBuilderType - desktop
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} mainCategory - the category from the 'vertical selector' category that the user chose
* @property {string} platformName - facebook, youtube, website , google places
* @property {string} screenResolution - -
* @property {string} userSubscription - deprecated
* @property {GUID} uuid - user id
**/
/**
 * Name: intro - platforms screen interactive. Evid: 43.
 * Event description: Module: intro. Flow: user clicked / typed anything in platform screen intro page.

 * action - Type: string. Desc: type / click
 *
 * adiBuilderType - Type: string. Desc: desktop
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * mainCategory - Type: string. Desc: the category from the 'vertical selector' category that the user chose
 *
 * platformName - Type: string. Desc: facebook, youtube, website , google places
 *
 * screenResolution - Type: string. Desc: -
 *
 * userSubscription - Type: string. Desc: deprecated
 *
 * uuid - Type: guid. Desc: user id
 * @param {introPlatformsScreenInteractiveParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var introPlatformsScreenInteractive = function (params) {
    return { evid: 43, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} contentEditorFailoverReArrangeLayoutParams
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} nodeId - unique number per node, in case this is a list - this is the sectionNodeId
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: contentEditor - Failover / Re-arrange Layout. Evid: 226.
 * Event description: Module: contentEditor. Flow: user added more content, the solution cannot be generated and a new layout is shown. .

 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * nodeId - Type: string. Desc: unique number per node, in case this is a list - this is the sectionNodeId
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {contentEditorFailoverReArrangeLayoutParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var contentEditorFailoverReArrangeLayout = function (params) {
    return { evid: 226, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} siteDesignCustomizeDesignChangeScrollAnimationSuccessParams
* @property {string} adiBuilderType - null
* @property {string} alias - label (name seen by user) of animation:  none, parallax, reveal ...
* @property {string} designId - null
* @property {string} editMode - null
* @property {GUID} esi - null
* @property {string} industryId - null
* @property {string} instanceId - null
* @property {number} loadTime - null
* @property {GUID} msid - null
* @property {string} name - null
* @property {number} revision - null
* @property {string} screenResolution - null
* @property {string} structureId - null
* @property {GUID} uuid - null
**/
/**
 * Name: siteDesign - Customize Design - Change Scroll Animation Success. Evid: 324.
 * Event description: Module: siteDesign. Flow: a desired scroll animation was updated successfully.

 * adiBuilderType - Type: string.
 *
 * alias - Type: string. Desc: label (name seen by user) of animation:  none, parallax, reveal ...
 *
 * designId - Type: string.
 *
 * editMode - Type: string.
 *
 * esi - Type: guid.
 *
 * industryId - Type: string.
 *
 * instanceId - Type: string.
 *
 * loadTime - Type: numeric.
 *
 * msid - Type: guid.
 *
 * name - Type: string.
 *
 * revision - Type: numeric.
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string.
 *
 * uuid - Type: guid.
 * @param {siteDesignCustomizeDesignChangeScrollAnimationSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteDesignCustomizeDesignChangeScrollAnimationSuccess = function (params) {
    return { evid: 324, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} contentEditorAddSecondaryButtonParams
* @property {string} adiBuilderType - desktop / MED / ...
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {GUID} msid - metasite id
* @property {string} nodeId - unique number per node, in case this is a list - this is the sectionNodeId
* @property {string} origin - OSI / right click
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - screen resolution
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
**/
/**
 * Name: contentEditor - Add Secondary Button. Evid: 425.
 * Event description: Module: contentEditor. Flow: user clicks on "Add Secondary Button".

 * adiBuilderType - Type: string. Desc: desktop / MED / ...
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * nodeId - Type: string. Desc: unique number per node, in case this is a list - this is the sectionNodeId
 *
 * origin - Type: string. Desc: OSI / right click
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 * @param {contentEditorAddSecondaryButtonParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var contentEditorAddSecondaryButton = function (params) {
    return { evid: 425, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderTopBarPreviewSiteClickParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} origin - origin of preview: top bar , custom site design
* @property {number} revision - -
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - Top Bar - Preview site click. Evid: 159.
 * Event description: Module: builder. Flow: user clicks on preview site. .

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * origin - Type: string. Desc: origin of preview: top bar , custom site design
 *
 * revision - Type: numeric. Desc: -
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderTopBarPreviewSiteClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderTopBarPreviewSiteClick = function (params) {
    return { evid: 159, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} sectionManagementAddSectionToPageSuccessParams
* @property {string} addType - click / drag / tap (on MED) / none (from app panel)
* @property {string} adiBuilderType - null
* @property {string} appId - in case of tpa: app_id/blog
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {boolean} is_columns - flag for columns in selected layout
* @property {boolean} isLinked - flag for linked sections
* @property {number} loadTime - time in ms
* @property {GUID} msid - metasite id
* @property {number} noOfSuggestions - int number that represents the number of suggested layouts that the user saw
* @property {string} nodeId - unique number per node
* @property {string} pageId - number of page
* @property {string} place - where the group is placed: recommended / others / expanded list
* @property {number} placeOfSelected - int number that represents the place of the selected layout (1 for the first,…)
* @property {number} position - position of section in page
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} selectedLayout - layout id
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: sectionManagement - Add Section to page - success. Evid: 256.
 * Event description: Module: sectionManagement. Flow: section was added to stage successfully..

 * addType - Type: string. Desc: click / drag / tap (on MED) / none (from app panel)
 *
 * adiBuilderType - Type: string.
 *
 * appId - Type: string. Desc: in case of tpa: app_id/blog
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * is_columns - Type: bool. Desc: flag for columns in selected layout
 *
 * isLinked - Type: bool. Desc: flag for linked sections
 *
 * loadTime - Type: numeric. Desc: time in ms
 *
 * msid - Type: guid. Desc: metasite id
 *
 * noOfSuggestions - Type: numeric. Desc: int number that represents the number of suggested layouts that the user saw
 *
 * nodeId - Type: string. Desc: unique number per node
 *
 * pageId - Type: string. Desc: number of page
 *
 * place - Type: string. Desc: where the group is placed: recommended / others / expanded list
 *
 * placeOfSelected - Type: numeric. Desc: int number that represents the place of the selected layout (1 for the first,…)
 *
 * position - Type: numeric. Desc: position of section in page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * selectedLayout - Type: string. Desc: layout id
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {sectionManagementAddSectionToPageSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionManagementAddSectionToPageSuccess = function (params) {
    return { evid: 256, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} medBuilderAddPagesStartParams
* @property {string} adiBuilderType - MED
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {number} numOfPages - number of pages
* @property {string} pageNames - page chosen (comma separated)
* @property {number} revision - builder version
* @property {string} screenResolution - screen resolution
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: MED - Builder - Add Pages Start. Evid: 822.
 * Event description: Module: MED. Flow: user clicks on done on add pages panel.

 * adiBuilderType - Type: string. Desc: MED
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * numOfPages - Type: numeric. Desc: number of pages
 *
 * pageNames - Type: string. Desc: page chosen (comma separated)
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {medBuilderAddPagesStartParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var medBuilderAddPagesStart = function (params) {
    return { evid: 822, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} sectionManagementAddSectionToPageParams
* @property {string} addType - click / drag / tap (on MED) / none (from app panel)
* @property {string} adiBuilderType - null
* @property {string} appId - in case of tpa: app_id/blog
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {boolean} is_columns - flag for columns in selected layout
* @property {boolean} isLinked - flag for linked sections
* @property {GUID} msid - metasite id
* @property {number} noOfSuggestions - int number that represents the number of suggested layouts that the user saw
* @property {string} origin - from where the section was added: sections panel / apps panel etc
* @property {string} pageId - number of page
* @property {string} place - where the group is placed: recommended / others / expanded list
* @property {number} placeOfSelected - int number that represents the place of the selected layout (1 for the first,…)
* @property {number} position - position of section in page
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} selectedLayout - layout id
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: sectionManagement - Add Section to page. Evid: 255.
 * Event description: Module: sectionManagement. Flow: user chooses a layout of the new section.
In case of dragging the section, this event will be reported only after user positioned the section in the desired place..

 * addType - Type: string. Desc: click / drag / tap (on MED) / none (from app panel)
 *
 * adiBuilderType - Type: string.
 *
 * appId - Type: string. Desc: in case of tpa: app_id/blog
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * is_columns - Type: bool. Desc: flag for columns in selected layout
 *
 * isLinked - Type: bool. Desc: flag for linked sections
 *
 * msid - Type: guid. Desc: metasite id
 *
 * noOfSuggestions - Type: numeric. Desc: int number that represents the number of suggested layouts that the user saw
 *
 * origin - Type: string. Desc: from where the section was added: sections panel / apps panel etc
 *
 * pageId - Type: string. Desc: number of page
 *
 * place - Type: string. Desc: where the group is placed: recommended / others / expanded list
 *
 * placeOfSelected - Type: numeric. Desc: int number that represents the place of the selected layout (1 for the first,…)
 *
 * position - Type: numeric. Desc: position of section in page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * selectedLayout - Type: string. Desc: layout id
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {sectionManagementAddSectionToPageParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionManagementAddSectionToPage = function (params) {
    return { evid: 255, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} appsRestaurantAppsMenuDropdownListOpenParams
* @property {string} adiBuilderType - desktop / mobile
* @property {GUID} appId - app id
* @property {string} appName - app name
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - screen resolution
* @property {string} structureId - structure id
**/
/**
 * Name: apps - restaurant apps menu dropdown list open. Evid: 460.
 * Event description: Module: apps. Flow: user clicks on restaurant's app menu (from apps panel).

 * adiBuilderType - Type: string. Desc: desktop / mobile
 *
 * appId - Type: guid. Desc: app id
 *
 * appName - Type: string. Desc: app name
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * structureId - Type: string. Desc: structure id
 * @param {appsRestaurantAppsMenuDropdownListOpenParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appsRestaurantAppsMenuDropdownListOpen = function (params) {
    return { evid: 460, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} siteDesignCustomizeDesignColorPaletteModeChangeColorMainClickParams
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / no-tour
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: siteDesign - Customize Design - color palette mode - change color main click. Evid: 311.
 * Event description: Module: siteDesign. Flow: user chooses to change color.

 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / no-tour
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {siteDesignCustomizeDesignColorPaletteModeChangeColorMainClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteDesignCustomizeDesignColorPaletteModeChangeColorMainClick = function (params) {
    return { evid: 311, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} loadingExistingSiteLoadStoryHandleDeepLinkParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} intervalLoadTime - loading time diff from previous phase
* @property {number} loadTime - loading time till this phase
* @property {GUID} msid - metasite id
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: loading - existing site - LoadStory: Handle deep link. Evid: 514.
 * Event description: Module: builder. Flow: phase in opening the builder (existing site) started..

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * intervalLoadTime - Type: numeric. Desc: loading time diff from previous phase
 *
 * loadTime - Type: numeric. Desc: loading time till this phase
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {loadingExistingSiteLoadStoryHandleDeepLinkParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var loadingExistingSiteLoadStoryHandleDeepLink = function (params) {
    return { evid: 514, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} sectionDesignFocalPointPanelClickParams
* @property {string} adiBuilderType - mobile or desktop editor
* @property {boolean} changed - true / false
* @property {string} designId - id of the design
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {GUID} msid - metasite id
* @property {string} navButton - done / cancel
* @property {number} revision - builder version
* @property {string} screenResolution - screen resolution
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
**/
/**
 * Name: sectionDesign - focal point panel - click. Evid: 583.
 * Event description: Module: sectionDesign. Flow: user clicks on a button in focal point panel.

 * adiBuilderType - Type: string. Desc: mobile or desktop editor
 *
 * changed - Type: bool. Desc: true / false
 *
 * designId - Type: string. Desc: id of the design
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * navButton - Type: string. Desc: done / cancel
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 * @param {sectionDesignFocalPointPanelClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionDesignFocalPointPanelClick = function (params) {
    return { evid: 583, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} contentEditorFailToFitLayoutCanTFindAProperLayoutParams
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} nodeId - unique number per node, in case this is a list - this is the sectionNodeId
* @property {string} pageId - number of page
* @property {string} reason - failure reason
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: contentEditor - Fail to fit layout (can't find a proper layout). Evid: 227.
 * Event description: Module: contentEditor. Flow: CRM has failed to fit a layout. .

 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * nodeId - Type: string. Desc: unique number per node, in case this is a list - this is the sectionNodeId
 *
 * pageId - Type: string. Desc: number of page
 *
 * reason - Type: string. Desc: failure reason
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {contentEditorFailToFitLayoutCanTFindAProperLayoutParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var contentEditorFailToFitLayoutCanTFindAProperLayout = function (params) {
    return { evid: 227, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} mediaManagementReplaceMediaWindowIsLoadedParams
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id
* @property {string} galleryType - single item/external video/ gallery organizer
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {string} mediaType - single image/image gallery/clipart/shape/bgVideo/extVideo
* @property {GUID} msid - metasite id
* @property {string} nodeId - unique number per node, in case this is a list - this is the sectionNodeId
* @property {number} numTotal - in case of gallery: number of items in gallery
* @property {string} origin - from where the media window was opened: edit panel /gallery organizer
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: mediaManagement - Replace media window is loaded. Evid: 400.
 * Event description: Module: mediaManagement. Flow: media organizer / media gallery is loaded, for all types of media windows. .

 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id
 *
 * galleryType - Type: string. Desc: single item/external video/ gallery organizer
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * mediaType - Type: string. Desc: single image/image gallery/clipart/shape/bgVideo/extVideo
 *
 * msid - Type: guid. Desc: metasite id
 *
 * nodeId - Type: string. Desc: unique number per node, in case this is a list - this is the sectionNodeId
 *
 * numTotal - Type: numeric. Desc: in case of gallery: number of items in gallery
 *
 * origin - Type: string. Desc: from where the media window was opened: edit panel /gallery organizer
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {mediaManagementReplaceMediaWindowIsLoadedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var mediaManagementReplaceMediaWindowIsLoaded = function (params) {
    return { evid: 400, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} appsClickOnManageAppParams
* @property {string} adiBuilderType - null
* @property {GUID} appId - app_id, like: 61F33D50-3002-4882-AE86-D319C1A249AB = blog
* @property {string} appInstanceId - unique identifier of app (store, bookings, etc.) instance in site
* @property {string} appName - blog, Store, Booking
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} source - section / top-bar...
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: apps - Click on Manage App. Evid: 450.
 * Event description: Module: apps. Flow: user clicks on manage app button, which opens the app backoffice..

 * adiBuilderType - Type: string.
 *
 * appId - Type: guid. Desc: app_id, like: 61F33D50-3002-4882-AE86-D319C1A249AB = blog
 *
 * appInstanceId - Type: string. Desc: unique identifier of app (store, bookings, etc.) instance in site
 *
 * appName - Type: string. Desc: blog, Store, Booking
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * source - Type: string. Desc: section / top-bar...
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {appsClickOnManageAppParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appsClickOnManageApp = function (params) {
    return { evid: 450, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderCoreLoadingLoadLayoutsCompleteParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} intervalLoadTime - loading time diff from previous phase
* @property {number} loadTime - loading time till this phase
* @property {string} loadType - new site / existing site
* @property {GUID} msid - metasite id
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - core loading - load layouts complete. Evid: 15.
 * Event description: Module: builder. Flow: phase in loading the core.

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * intervalLoadTime - Type: numeric. Desc: loading time diff from previous phase
 *
 * loadTime - Type: numeric. Desc: loading time till this phase
 *
 * loadType - Type: string. Desc: new site / existing site
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderCoreLoadingLoadLayoutsCompleteParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderCoreLoadingLoadLayoutsComplete = function (params) {
    return { evid: 15, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} contentEditorImageCropSuccessParams
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} loadTime - deprecated
* @property {GUID} msid - metasite id
* @property {string} nodeId - unique number per node, in case this is a list - this is the sectionNodeId
* @property {string} objectType - single / list / field
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: contentEditor - Image Crop - success. Evid: 210.
 * Event description: Module: contentEditor. Flow: image cropped after the user selected the area and clicked done, the change is updated also on the stage. .

 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * loadTime - Type: numeric. Desc: deprecated
 *
 * msid - Type: guid. Desc: metasite id
 *
 * nodeId - Type: string. Desc: unique number per node, in case this is a list - this is the sectionNodeId
 *
 * objectType - Type: string. Desc: single / list / field
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {contentEditorImageCropSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var contentEditorImageCropSuccess = function (params) {
    return { evid: 210, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} mediaManagementPreviewMediaLoadedParams
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id
* @property {string} galleryType - single item/external video/ gallery organizer
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {string} mediaType - single image/image gallery/clipart/shape/bgVideo/extVideo
* @property {GUID} msid - metasite id
* @property {string} nodeId - unique number per node, in case this is a list - this is the sectionNodeId
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: mediaManagement - Preview media - loaded. Evid: 410.
 * Event description: Module: mediaManagement. Flow: media is successfully shown (extVideo/ gallery image). .

 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id
 *
 * galleryType - Type: string. Desc: single item/external video/ gallery organizer
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * mediaType - Type: string. Desc: single image/image gallery/clipart/shape/bgVideo/extVideo
 *
 * msid - Type: guid. Desc: metasite id
 *
 * nodeId - Type: string. Desc: unique number per node, in case this is a list - this is the sectionNodeId
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {mediaManagementPreviewMediaLoadedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var mediaManagementPreviewMediaLoaded = function (params) {
    return { evid: 410, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} contentEditorPopupDialogIsLoadedParams
* @property {string} adiBuilderType - desktop/mobile
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} name - dialog name
* @property {string} objectType - single / list
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - screen resolution
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} source - how the panel was opened - button/button in list item
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: contentEditor - Popup dialog is loaded. Evid: 245.
 * Event description: Module: contentEditor. Flow: content editor popup dialog is loaded. E.g., button style dialog..

 * adiBuilderType - Type: string. Desc: desktop/mobile
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * name - Type: string. Desc: dialog name
 *
 * objectType - Type: string. Desc: single / list
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * source - Type: string. Desc: how the panel was opened - button/button in list item
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {contentEditorPopupDialogIsLoadedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var contentEditorPopupDialogIsLoaded = function (params) {
    return { evid: 245, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} loadingFirstTimeCreateStorySaveNewStoryParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} intervalLoadTime - loading - first time - CreateStory: Get Unique name
* @property {number} loadTime - loading time till this phase
* @property {GUID} msid - metasite id
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: loading - first time - CreateStory: Save new story. Evid: 169.
 * Event description: Module: builder. Flow: phase in opening the builder (first time) started..

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * intervalLoadTime - Type: numeric. Desc: loading - first time - CreateStory: Get Unique name
 *
 * loadTime - Type: numeric. Desc: loading time till this phase
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {loadingFirstTimeCreateStorySaveNewStoryParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var loadingFirstTimeCreateStorySaveNewStory = function (params) {
    return { evid: 169, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} sectionDesignChangeSlideshowDurationSuccessParams
* @property {string} adiBuilderType - desktop / mobile/ MED....
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} loadTime - time elapsed from start
* @property {GUID} msid - metasite id
* @property {string} name - slidshow duration. e.g 3sec
* @property {number} revision - builder version
* @property {string} screenResolution - screen_resolution
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: sectionDesign - change slideshow duration - success. Evid: 581.
 * Event description: Module: sectionDesign. Flow: user changes the slide show duration.

 * adiBuilderType - Type: string. Desc: desktop / mobile/ MED....
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * loadTime - Type: numeric. Desc: time elapsed from start
 *
 * msid - Type: guid. Desc: metasite id
 *
 * name - Type: string. Desc: slidshow duration. e.g 3sec
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string. Desc: screen_resolution
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {sectionDesignChangeSlideshowDurationSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionDesignChangeSlideshowDurationSuccess = function (params) {
    return { evid: 581, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} introSiteConverterSiteJsonParsingStartParams
* @property {string} adiBuilderType - desktop / mobile
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} screenResolution - screen resolution
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: intro - Site Converter - Site json parsing start. Evid: 6.
 * Event description: Module: intro. Flow: JSON is returned from WixWiz and parsing process starts.

 * adiBuilderType - Type: string. Desc: desktop / mobile
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {introSiteConverterSiteJsonParsingStartParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var introSiteConverterSiteJsonParsingStart = function (params) {
    return { evid: 6, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} siteDesignCustomizeDesignOverrideSectionDesignApplySuccessParams
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} loadTime - time in ms to apply change
* @property {GUID} msid - metasite id
* @property {string} name - font / element animation / scroll animation
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: siteDesign - Customize Design - override section design - apply success. Evid: 332.
 * Event description: Module: siteDesign. Flow: user changes site design and has already set a section with a different animation/font. user clicks on apply the new animation/font to all sections - success.

 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * loadTime - Type: numeric. Desc: time in ms to apply change
 *
 * msid - Type: guid. Desc: metasite id
 *
 * name - Type: string. Desc: font / element animation / scroll animation
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {siteDesignCustomizeDesignOverrideSectionDesignApplySuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteDesignCustomizeDesignOverrideSectionDesignApplySuccess = function (params) {
    return { evid: 332, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} loadingAutomationTestCompletedParams
* @property {string} adiBuilderType - null
* @property {number} loadTime - loading time till this phase
* @property {GUID} msid - metasite id
* @property {string} screenResolution - null
* @property {string} testName - test's name
**/
/**
 * Name: loading - automation  - test completed. Evid: 30.
 * Event description: Module: builder. Flow: performance test completed..

 * adiBuilderType - Type: string.
 *
 * loadTime - Type: numeric. Desc: loading time till this phase
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string.
 *
 * testName - Type: string. Desc: test's name
 * @param {loadingAutomationTestCompletedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var loadingAutomationTestCompleted = function (params) {
    return { evid: 30, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} contentEditorClickOnHideShowOnItemInListItemsSuccessParams
* @property {string} action - hide/show
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} loadTime - time in ms
* @property {GUID} msid - metasite id
* @property {string} nodeId - unique number per node, in case this is a list - this is the sectionNodeId
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: contentEditor - Click on hide/show on item in List items - Success. Evid: 231.
 * Event description: Module: contentEditor. Flow: user clicks on 'hide/show on an item in list, and action has successed..

 * action - Type: string. Desc: hide/show
 *
 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * loadTime - Type: numeric. Desc: time in ms
 *
 * msid - Type: guid. Desc: metasite id
 *
 * nodeId - Type: string. Desc: unique number per node, in case this is a list - this is the sectionNodeId
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {contentEditorClickOnHideShowOnItemInListItemsSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var contentEditorClickOnHideShowOnItemInListItemsSuccess = function (params) {
    return { evid: 231, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} pagesManagerPagePermissionsPanelIsLoadedParams
* @property {string} adiBuilderType - desktop / MED
* @property {string} appId - in case of tpa: app_id/blog
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} origin - OSI / right click
* @property {string} pageId - number of page
* @property {string} pageType - TPA / General / Members / Members area - private / Members area -  public
* @property {number} revision - builder version
* @property {string} screenResolution - -
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: pagesManager - Page permissions panel is loaded. Evid: 376.
 * Event description: Module: pagesManager. Flow: user loaded the Page permissions panel.

 * adiBuilderType - Type: string. Desc: desktop / MED
 *
 * appId - Type: string. Desc: in case of tpa: app_id/blog
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * origin - Type: string. Desc: OSI / right click
 *
 * pageId - Type: string. Desc: number of page
 *
 * pageType - Type: string. Desc: TPA / General / Members / Members area - private / Members area -  public
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string. Desc: -
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {pagesManagerPagePermissionsPanelIsLoadedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pagesManagerPagePermissionsPanelIsLoaded = function (params) {
    return { evid: 376, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} contentEditorTextManagerSearchResultsPresentedParams
* @property {string} adiBuilderType - desktop / mobile / ...
* @property {number} bestMatchResults - # of best match texts
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} nodeId - unique number per node, in case this is a list - this is the sectionNodeId
* @property {string} objectType - single / list / field
* @property {string} pageId - number of page
* @property {number} results - # of results
* @property {number} revision - builder version
* @property {string} screenResolution - screen_resolution
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {string} textType - title / description / ...
**/
/**
 * Name: contentEditor - Text Manager - search results presented. Evid: 249.
 * Event description: Module: contentEditor. Flow: user search for a text and get search results (including empty results page).

 * adiBuilderType - Type: string. Desc: desktop / mobile / ...
 *
 * bestMatchResults - Type: numeric. Desc: # of best match texts
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * nodeId - Type: string. Desc: unique number per node, in case this is a list - this is the sectionNodeId
 *
 * objectType - Type: string. Desc: single / list / field
 *
 * pageId - Type: string. Desc: number of page
 *
 * results - Type: numeric. Desc: # of results
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string. Desc: screen_resolution
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * textType - Type: string. Desc: title / description / ...
 * @param {contentEditorTextManagerSearchResultsPresentedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var contentEditorTextManagerSearchResultsPresented = function (params) {
    return { evid: 249, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} siteDesignCustomizeDesignChangeScrollAnimationClickParams
* @property {string} adiBuilderType - null
* @property {string} alias - label (name the user sees) of animation:  none, parallax, reveal ...
* @property {string} designId - null
* @property {string} editMode - null
* @property {GUID} esi - null
* @property {string} industryId - null
* @property {string} instanceId - null
* @property {GUID} msid - null
* @property {string} name - null
* @property {number} revision - null
* @property {string} screenResolution - null
* @property {string} structureId - null
* @property {GUID} uuid - null
**/
/**
 * Name: siteDesign - Customize Design - Change Scroll Animation Click. Evid: 323.
 * Event description: Module: siteDesign. Flow: user clicks on a desired  scroll animation.

 * adiBuilderType - Type: string.
 *
 * alias - Type: string. Desc: label (name the user sees) of animation:  none, parallax, reveal ...
 *
 * designId - Type: string.
 *
 * editMode - Type: string.
 *
 * esi - Type: guid.
 *
 * industryId - Type: string.
 *
 * instanceId - Type: string.
 *
 * msid - Type: guid.
 *
 * name - Type: string.
 *
 * revision - Type: numeric.
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string.
 *
 * uuid - Type: guid.
 * @param {siteDesignCustomizeDesignChangeScrollAnimationClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteDesignCustomizeDesignChangeScrollAnimationClick = function (params) {
    return { evid: 323, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} tourQuitTourParams
* @property {string} adiBuilderType - null
* @property {string} assistType - tours / smart assist
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} name - name of tour: welcome / preview / design-entire website / design-fonts&colors / edit section / add section / add page
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: tour - Quit Tour. Evid: 56.
 * Event description: Module: tour. Flow: user quits a running tour.

 * adiBuilderType - Type: string.
 *
 * assistType - Type: string. Desc: tours / smart assist
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * name - Type: string. Desc: name of tour: welcome / preview / design-entire website / design-fonts&colors / edit section / add section / add page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {tourQuitTourParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tourQuitTour = function (params) {
    return { evid: 56, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} introReCaptchaImNotARobotResultParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} result - success, expired, error
* @property {string} screenResolution - screen resolution
**/
/**
 * Name: intro - reCaptcha - "I'm not a robot" result. Evid: 600.
 * Event description: Module: intro. Flow: user clicked "I'm not a robot" on reCaptcha intro page.

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * result - Type: string. Desc: success, expired, error
 *
 * screenResolution - Type: string. Desc: screen resolution
 * @param {introReCaptchaImNotARobotResultParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var introReCaptchaImNotARobotResult = function (params) {
    return { evid: 600, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderPublishSiteCongratsPageClickOnSocialParams
* @property {string} adiBuilderType - --
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} pageView - all options {onboarding-1publish-congrats,onboarding-2publish-congrats,premium}
* @property {string} screenResolution - --
* @property {string} socialButton - {FB,Tweeter}
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - Publish Site - Congrats page - click on social. Evid: 188.
 * Event description: Module: builder. Flow: post publish congrats page view - click on social button.

 * adiBuilderType - Type: string. Desc: --
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * pageView - Type: string. Desc: all options {onboarding-1publish-congrats,onboarding-2publish-congrats,premium}
 *
 * screenResolution - Type: string. Desc: --
 *
 * socialButton - Type: string. Desc: {FB,Tweeter}
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderPublishSiteCongratsPageClickOnSocialParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderPublishSiteCongratsPageClickOnSocial = function (params) {
    return { evid: 188, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} dialogsShowParams
* @property {string} adiBuilderType - null
* @property {GUID} appId - application id
* @property {GUID} appInstanceId - app instance id
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} name - name of dialog: delete section / move section to page / delete page / signout / create new site /migrate old blog
* @property {string} nodeId - unique number per node, in case this is a list - this is the sectionNodeId
* @property {string} origin - where this dialog opened from
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: dialogs - Show. Evid: 47.
 * Event description: Module: dialogs. Flow: dialog is shown. .

 * adiBuilderType - Type: string.
 *
 * appId - Type: guid. Desc: application id
 *
 * appInstanceId - Type: guid. Desc: app instance id
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * name - Type: string. Desc: name of dialog: delete section / move section to page / delete page / signout / create new site /migrate old blog
 *
 * nodeId - Type: string. Desc: unique number per node, in case this is a list - this is the sectionNodeId
 *
 * origin - Type: string. Desc: where this dialog opened from
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {dialogsShowParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dialogsShow = function (params) {
    return { evid: 47, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderGoToEditorContinueToProEditorSuccessParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} loadTime - time from click
* @property {GUID} msid - metasite id
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - Go to Editor - Continue to Pro Editor Success. Evid: 185.
 * Event description: Module: builder. Flow: user chooses to leave ADI and go to Pro Editor - success event (the editor started loading).

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * loadTime - Type: numeric. Desc: time from click
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderGoToEditorContinueToProEditorSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderGoToEditorContinueToProEditorSuccess = function (params) {
    return { evid: 185, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} caasDefaultContentFallbackParams
* @property {string} adiBuilderType - -
* @property {string} industryId - industry ID
* @property {string} language - content language
* @property {string} screenResolution - null
* @property {string} structureId - structure ID
* @property {GUID} uuid - user id
**/
/**
 * Name: caas - default content fallback. Evid: 602.
 * Event description: Module: caas. Flow: when content manager fails to load user selected category / default category.

 * adiBuilderType - Type: string. Desc: -
 *
 * industryId - Type: string. Desc: industry ID
 *
 * language - Type: string. Desc: content language
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure ID
 *
 * uuid - Type: guid. Desc: user id
 * @param {caasDefaultContentFallbackParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var caasDefaultContentFallback = function (params) {
    return { evid: 602, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} loadingFirstTimeCreateStorySetSitePropertiesParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} intervalLoadTime - loading time diff from previous phase
* @property {number} loadTime - loading time till this phase
* @property {GUID} msid - metasite id
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: loading - first time - CreateStory: Set site properties. Evid: 502.
 * Event description: Module: builder. Flow: phase in opening the builder (first time) started.

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * intervalLoadTime - Type: numeric. Desc: loading time diff from previous phase
 *
 * loadTime - Type: numeric. Desc: loading time till this phase
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {loadingFirstTimeCreateStorySetSitePropertiesParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var loadingFirstTimeCreateStorySetSiteProperties = function (params) {
    return { evid: 502, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} contentEditorHideComponentFromSiteSuccessParams
* @property {string} action - hide/unhide
* @property {string} adiBuilderType - desktop / mobile
* @property {string} editMode - automatic / show me how / manual / smart assist
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} fieldName - which field is updated: title,subtitle,body,image,button,link, list description
* @property {string} fieldType - text/ dropdown/ link / long text
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} origin - smart assist
* @property {number} revision - builder version
* @property {string} screenResolution - screen resolution
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: contentEditor - hide component from site success. Evid: 242.
 * Event description: Module: contentEditor. Flow: user clicks on 'hide Icons' in smart assist card tour.

 * action - Type: string. Desc: hide/unhide
 *
 * adiBuilderType - Type: string. Desc: desktop / mobile
 *
 * editMode - Type: string. Desc: automatic / show me how / manual / smart assist
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * fieldName - Type: string. Desc: which field is updated: title,subtitle,body,image,button,link, list description
 *
 * fieldType - Type: string. Desc: text/ dropdown/ link / long text
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * origin - Type: string. Desc: smart assist
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {contentEditorHideComponentFromSiteSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var contentEditorHideComponentFromSiteSuccess = function (params) {
    return { evid: 242, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderTopBarViewSiteClickParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - Top Bar - View published site click. Evid: 154.
 * Event description: Module: builder. Flow: user clicks on site > view published site..

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderTopBarViewSiteClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderTopBarViewSiteClick = function (params) {
    return { evid: 154, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} loadingPhaseInInitCompleteParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} intervalLoadTime - load time of this phase in ms
* @property {number} loadTime - total load time till this phase in ms
* @property {string} loadType - new / existing
* @property {GUID} msid - metasite id
* @property {string} phaseName - phase name
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {string} subPhaseName - sub phase name
* @property {GUID} uuid - user id
**/
/**
 * Name: loading - phase in init - complete. Evid: 2.
 * Event description: Module: builder. Flow: a phase in the init has been completed.

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * intervalLoadTime - Type: numeric. Desc: load time of this phase in ms
 *
 * loadTime - Type: numeric. Desc: total load time till this phase in ms
 *
 * loadType - Type: string. Desc: new / existing
 *
 * msid - Type: guid. Desc: metasite id
 *
 * phaseName - Type: string. Desc: phase name
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * subPhaseName - Type: string. Desc: sub phase name
 *
 * uuid - Type: guid. Desc: user id
 * @param {loadingPhaseInInitCompleteParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var loadingPhaseInInitComplete = function (params) {
    return { evid: 2, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} introSelectImagesLegalPageNavigationClickParams
* @property {string} adiBuilderType - desktop / MED...
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry
* @property {string} mainCategory - the category from the 'vertical selector' category that the user chose
* @property {string} navButton - next / skip / back / review images
* @property {string} nextView - name of next page: business type / services selection / business name / location / search confirm / search results / edit info card / builder / pro editor
* @property {string} numOfChosen - facebook=3,mysite=5,google=0….
* @property {string} numOfSuggested - facebook=10,mysite=12,google=15….
* @property {string} screenResolution - -
* @property {string} structureId - structure
**/
/**
 * Name: intro -  select images legal page - navigation click. Evid: 98.
 * Event description: Module: intro. Flow: user clicks on a navigation button on the select images legal page.

 * adiBuilderType - Type: string. Desc: desktop / MED...
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry
 *
 * mainCategory - Type: string. Desc: the category from the 'vertical selector' category that the user chose
 *
 * navButton - Type: string. Desc: next / skip / back / review images
 *
 * nextView - Type: string. Desc: name of next page: business type / services selection / business name / location / search confirm / search results / edit info card / builder / pro editor
 *
 * numOfChosen - Type: string. Desc: facebook=3,mysite=5,google=0….
 *
 * numOfSuggested - Type: string. Desc: facebook=10,mysite=12,google=15….
 *
 * screenResolution - Type: string. Desc: -
 *
 * structureId - Type: string. Desc: structure
 * @param {introSelectImagesLegalPageNavigationClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var introSelectImagesLegalPageNavigationClick = function (params) {
    return { evid: 98, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderBrowserTabCloseParams
* @property {string} adiBuilderType - adi_builder_type
* @property {GUID} esi - esi
* @property {string} industryId - site industry id
* @property {GUID} msid - metasite id
* @property {string} screenResolution - screen_resolution
* @property {string} structureId - site structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - browser tab close. Evid: 3998.
 * Event description: Sent when a user closes a tab with open ADI builder.

 * adiBuilderType - Type: string. Desc: adi_builder_type
 *
 * esi - Type: guid. Desc: esi
 *
 * industryId - Type: string. Desc: site industry id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string. Desc: screen_resolution
 *
 * structureId - Type: string. Desc: site structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderBrowserTabCloseParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderBrowserTabClose = function (params) {
    return { evid: 3998, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} sectionManagementMoveSectionWithinThePageClickParams
* @property {string} adiBuilderType - null
* @property {string} appId - in case of tpa: app_id/blog
* @property {string} direction - up / down / scroll
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} nodeId - unique number per node
* @property {string} origin - OSI / right click
* @property {number} originPosition - new position of section in page
* @property {string} pageId - number of page
* @property {number} position - position of section in page
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: sectionManagement - Move section within the page click. Evid: 260.
 * Event description: Module: sectionManagement. Flow: user clicks on move section up/down/scroll within the page..

 * adiBuilderType - Type: string.
 *
 * appId - Type: string. Desc: in case of tpa: app_id/blog
 *
 * direction - Type: string. Desc: up / down / scroll
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * nodeId - Type: string. Desc: unique number per node
 *
 * origin - Type: string. Desc: OSI / right click
 *
 * originPosition - Type: numeric. Desc: new position of section in page
 *
 * pageId - Type: string. Desc: number of page
 *
 * position - Type: numeric. Desc: position of section in page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {sectionManagementMoveSectionWithinThePageClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionManagementMoveSectionWithinThePageClick = function (params) {
    return { evid: 260, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} siteDesignCustomizeDesignAdvancedColorsAreHardToReadDisplayedParams
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: siteDesign - Customize Design - Advanced - colors are hard to read displayed. Evid: 325.
 * Event description: Module: siteDesign. Flow: in advanced editing, custom colors that the user chose are hard to read, warning message is displayed.

 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {siteDesignCustomizeDesignAdvancedColorsAreHardToReadDisplayedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteDesignCustomizeDesignAdvancedColorsAreHardToReadDisplayed = function (params) {
    return { evid: 325, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderFetchingUserDetailsParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} loadTime - loading time till this phase
* @property {GUID} msid - metasite id
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - fetching user details. Evid: 170.
 * Event description: Module: builder. Flow: sent after evid 129.

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * loadTime - Type: numeric. Desc: loading time till this phase
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderFetchingUserDetailsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderFetchingUserDetails = function (params) {
    return { evid: 170, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} mediaManagementGalleryOrganizerMediaAddedToOrganizerParams
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} nodeId - unique number per node, in case this is a list - this is the sectionNodeId
* @property {number} numAdded - number of added images
* @property {number} numTotal - in case of gallery: number of items in gallery
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: mediaManagement - Gallery Organizer - Media added to organizer. Evid: 404.
 * Event description: Module: mediaManagement. Flow: user returns from media gallery to gallery organizer. .

 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * nodeId - Type: string. Desc: unique number per node, in case this is a list - this is the sectionNodeId
 *
 * numAdded - Type: numeric. Desc: number of added images
 *
 * numTotal - Type: numeric. Desc: in case of gallery: number of items in gallery
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {mediaManagementGalleryOrganizerMediaAddedToOrganizerParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var mediaManagementGalleryOrganizerMediaAddedToOrganizer = function (params) {
    return { evid: 404, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} sectionDesignChangeFontSizeSuccessParams
* @property {string} adiBuilderType - null
* @property {string} designId - id of the design
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} fontSize - font size
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} loadTime - time in ms to change size
* @property {GUID} msid - metasite id
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} setId - unique identifier of the font set
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: sectionDesign - change font size - success. Evid: 555.
 * Event description: Module: sectionDesign. Flow: user changes section font size - success.

 * adiBuilderType - Type: string.
 *
 * designId - Type: string. Desc: id of the design
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * fontSize - Type: string. Desc: font size
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * loadTime - Type: numeric. Desc: time in ms to change size
 *
 * msid - Type: guid. Desc: metasite id
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * setId - Type: string. Desc: unique identifier of the font set
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {sectionDesignChangeFontSizeSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionDesignChangeFontSizeSuccess = function (params) {
    return { evid: 555, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} contentEditorUpdateFieldParams
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {number} fieldLength - length of text in the field
* @property {string} fieldName - which field is updated: title,subtitle,body,image,button,link, list description
* @property {string} fieldType - text/ dropdown/ link / long text
* @property {string} fieldValue - value selected - only for dropdown fields / empty when user clears field
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} nodeId - unique number per node, in case this is a list - this is the sectionNodeId
* @property {string} origin - stage / panel
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: contentEditor - update field. Evid: 202.
 * Event description: Module: contentEditor. Flow: user edits a field inside a section or in a sub panel (for example in the media settings panel). It doesn't include fields inside popup dialogs.. .

 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * fieldLength - Type: numeric. Desc: length of text in the field
 *
 * fieldName - Type: string. Desc: which field is updated: title,subtitle,body,image,button,link, list description
 *
 * fieldType - Type: string. Desc: text/ dropdown/ link / long text
 *
 * fieldValue - Type: string. Desc: value selected - only for dropdown fields / empty when user clears field
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * nodeId - Type: string. Desc: unique number per node, in case this is a list - this is the sectionNodeId
 *
 * origin - Type: string. Desc: stage / panel
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {contentEditorUpdateFieldParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var contentEditorUpdateField = function (params) {
    return { evid: 202, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} bannerIsDismissedParams
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} name - name of banner
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: Banner is dismissed. Evid: 62.
 * Event description: Module: dialogs. Flow: A banner is dismissed.

 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * name - Type: string. Desc: name of banner
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {bannerIsDismissedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bannerIsDismissed = function (params) {
    return { evid: 62, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} contentEditorResetContentColorSuccessParams
* @property {string} adiBuilderType - desktop/mobile
* @property {string} contentName - content type reset, in list items it is the content the OSI was clicked from
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} nodeId - unique number per node, in case this is a list - this is the sectionNodeId
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - screen resolution
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: contentEditor - reset content color success. Evid: 240.
 * Event description: Module: contentEditor. Flow: color is reset for a specific content in section.

 * adiBuilderType - Type: string. Desc: desktop/mobile
 *
 * contentName - Type: string. Desc: content type reset, in list items it is the content the OSI was clicked from
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * nodeId - Type: string. Desc: unique number per node, in case this is a list - this is the sectionNodeId
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {contentEditorResetContentColorSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var contentEditorResetContentColorSuccess = function (params) {
    return { evid: 240, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} contentEditorFailoverReArrangeSolutionParams
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} nodeId - unique number per node, in case this is a list - this is the sectionNodeId
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: contentEditor - Failover / Re-arrange Solution. Evid: 225.
 * Event description: Module: contentEditor. Flow: user added more content in list item (e.g. long title), the layout is the same but the solution has changed. .

 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * nodeId - Type: string. Desc: unique number per node, in case this is a list - this is the sectionNodeId
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {contentEditorFailoverReArrangeSolutionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var contentEditorFailoverReArrangeSolution = function (params) {
    return { evid: 225, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderAddPagesScreenLoadingSuccessParams
* @property {string} adiBuilderType - desktop/MED
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} intervalLoadTime - time (in ms) elapsed since loading started
* @property {GUID} msid - metasite id
* @property {number} pageCount - count of pages suggested
* @property {string} screenResolution - user device screen resolution
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: tour - welcome tour - Add pages - page loading success. Evid: 80.
 * Event description: Module: tour. Flow: add pages screen is successfully loaded in welcome tour.

 * adiBuilderType - Type: string. Desc: desktop/MED
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * intervalLoadTime - Type: numeric. Desc: time (in ms) elapsed since loading started
 *
 * msid - Type: guid. Desc: metasite id
 *
 * pageCount - Type: numeric. Desc: count of pages suggested
 *
 * screenResolution - Type: string. Desc: user device screen resolution
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderAddPagesScreenLoadingSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderAddPagesScreenLoadingSuccess = function (params) {
    return { evid: 80, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderTopBarSeoPanelGetFoundOnGoogleClickParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - null
* @property {string} industryId - null
* @property {string} instanceId - null
* @property {GUID} msid - null
* @property {string} origin - topbar / seo panel
* @property {string} screenResolution - null
* @property {string} structureId - null
* @property {GUID} uuid - null
**/
/**
 * Name: builder - Top Bar / SEO Panel - Get found on Google click. Evid: 181.
 * Event description: Module: builder. Flow: user clicks on site > get found on google.

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid.
 *
 * industryId - Type: string.
 *
 * instanceId - Type: string.
 *
 * msid - Type: guid.
 *
 * origin - Type: string. Desc: topbar / seo panel
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string.
 *
 * uuid - Type: guid.
 * @param {builderTopBarSeoPanelGetFoundOnGoogleClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderTopBarSeoPanelGetFoundOnGoogleClick = function (params) {
    return { evid: 181, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} loadingPhaseInInitStartParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} loadTime - load time from the beginning of load
* @property {string} loadType - new / existing
* @property {GUID} msid - metasite id
* @property {string} phaseName - phase name
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {string} subPhaseName - sub phase name
* @property {GUID} uuid - user id
**/
/**
 * Name: loading - phase in init - start. Evid: 1.
 * Event description: Module: builder. Flow: a phase in the init has started.

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * loadTime - Type: numeric. Desc: load time from the beginning of load
 *
 * loadType - Type: string. Desc: new / existing
 *
 * msid - Type: guid. Desc: metasite id
 *
 * phaseName - Type: string. Desc: phase name
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * subPhaseName - Type: string. Desc: sub phase name
 *
 * uuid - Type: guid. Desc: user id
 * @param {loadingPhaseInInitStartParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var loadingPhaseInInitStart = function (params) {
    return { evid: 1, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderLinkDialogDoneClickedParams
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {number} fieldLength - length of text in the field
* @property {string} fieldName - which field is updated: title,subtitle,body,image,button,link, list description
* @property {string} fieldType - text/ dropdown/ link / long text
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {string} isHidden - true/false is the linked page hidden (for lightbox link)
* @property {string} linkTo - none / page / web /  document / email / phone / lightbox
* @property {GUID} msid - metasite id
* @property {string} nodeId - unique number per node, in case this is a list - this is the sectionNodeId
* @property {string} pageId - number of page
* @property {string} panelType - main / list item / social panel / media settings
* @property {string} place - section name
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} source - from where the user edit the link {button/richText/menu item}
* @property {string} structureId - structure id
* @property {string} targetPage - if web: the url, if page: the page name
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - Link dialog - done clicked. Evid: 213.
 * Event description: Module: builder. Flow: user clicks on 'done' in the link dialog..

 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * fieldLength - Type: numeric. Desc: length of text in the field
 *
 * fieldName - Type: string. Desc: which field is updated: title,subtitle,body,image,button,link, list description
 *
 * fieldType - Type: string. Desc: text/ dropdown/ link / long text
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * isHidden - Type: string. Desc: true/false is the linked page hidden (for lightbox link)
 *
 * linkTo - Type: string. Desc: none / page / web /  document / email / phone / lightbox
 *
 * msid - Type: guid. Desc: metasite id
 *
 * nodeId - Type: string. Desc: unique number per node, in case this is a list - this is the sectionNodeId
 *
 * pageId - Type: string. Desc: number of page
 *
 * panelType - Type: string. Desc: main / list item / social panel / media settings
 *
 * place - Type: string. Desc: section name
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * source - Type: string. Desc: from where the user edit the link {button/richText/menu item}
 *
 * structureId - Type: string. Desc: structure id
 *
 * targetPage - Type: string. Desc: if web: the url, if page: the page name
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderLinkDialogDoneClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderLinkDialogDoneClicked = function (params) {
    return { evid: 213, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} contentEditorSwitchMediaTypeClickParams
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {string} mediaType - which field is clicked: image/gallery/video/shape/clipart
* @property {GUID} msid - metasite id
* @property {string} nodeId - unique number per node, in case this is a list - this is the sectionNodeId
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: contentEditor - Switch Media type click. Evid: 206.
 * Event description: Module: contentEditor. Flow: changing image/gallery/video. .

 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * mediaType - Type: string. Desc: which field is clicked: image/gallery/video/shape/clipart
 *
 * msid - Type: guid. Desc: metasite id
 *
 * nodeId - Type: string. Desc: unique number per node, in case this is a list - this is the sectionNodeId
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {contentEditorSwitchMediaTypeClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var contentEditorSwitchMediaTypeClick = function (params) {
    return { evid: 206, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} siteDesignResetDesignSuccessParams
* @property {string} adiBuilderType - null
* @property {string} designId - id of the design
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {boolean} isAdvanced - Is reset clicked from advanced editing mode or from main panel{True if clicked from advanced}
* @property {number} loadTime - loading time till this phase
* @property {GUID} msid - metasite id
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: siteDesign - Reset Design - success. Evid: 308.
 * Event description: Module: siteDesign. Flow: design was reset successfully..

 * adiBuilderType - Type: string.
 *
 * designId - Type: string. Desc: id of the design
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * isAdvanced - Type: bool. Desc: Is reset clicked from advanced editing mode or from main panel{True if clicked from advanced}
 *
 * loadTime - Type: numeric. Desc: loading time till this phase
 *
 * msid - Type: guid. Desc: metasite id
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {siteDesignResetDesignSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteDesignResetDesignSuccess = function (params) {
    return { evid: 308, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderLightboxModeOpenCloseParams
* @property {string} action - open/close
* @property {string} adiBuilderType - desktop/MED
* @property {number} delay - chosen delay (for close action)
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {boolean} isActive - is Lightbox activated (for close action)
* @property {GUID} msid - metasite id
* @property {string} pagesShown - list of pages the lightbox is selected to show on (for close action)
* @property {string} screenResolution - resolution on user device screen
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - Lightbox mode open/close. Evid: 193.
 * Event description: Module: builder. Flow: Lightbox mode opened/closed.

 * action - Type: string. Desc: open/close
 *
 * adiBuilderType - Type: string. Desc: desktop/MED
 *
 * delay - Type: numeric. Desc: chosen delay (for close action)
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * isActive - Type: bool. Desc: is Lightbox activated (for close action)
 *
 * msid - Type: guid. Desc: metasite id
 *
 * pagesShown - Type: string. Desc: list of pages the lightbox is selected to show on (for close action)
 *
 * screenResolution - Type: string. Desc: resolution on user device screen
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderLightboxModeOpenCloseParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderLightboxModeOpenClose = function (params) {
    return { evid: 193, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} loadingFirstTimeSendSiteSourcesSendSiteSourcesInfoToWixwizAsyncParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} intervalLoadTime - loading time diff from previous phase
* @property {number} loadTime - loading time till this phase
* @property {GUID} msid - metasite id
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: loading - first time - Send Site Sources: Send site sources info to wixwiz (async). Evid: 509.
 * Event description: Module: builder. Flow: phase in opening the builder (first time) started..

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * intervalLoadTime - Type: numeric. Desc: loading time diff from previous phase
 *
 * loadTime - Type: numeric. Desc: loading time till this phase
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {loadingFirstTimeSendSiteSourcesSendSiteSourcesInfoToWixwizAsyncParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var loadingFirstTimeSendSiteSourcesSendSiteSourcesInfoToWixwizAsync = function (params) {
    return { evid: 509, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} contentEditorResetContentColorClickParams
* @property {string} adiBuilderType - desktop/mobile
* @property {string} contentName - content updated: title,subtitle,body,image,button,link, list description,...
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} nodeId - unique number per node, in case this is a list - this is the sectionNodeId
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - screen resolution
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: contentEditor - reset content color click. Evid: 239.
 * Event description: Module: contentEditor. Flow: user clicks on "fix color" on the OSI tooltip shown for a content in section.

 * adiBuilderType - Type: string. Desc: desktop/mobile
 *
 * contentName - Type: string. Desc: content updated: title,subtitle,body,image,button,link, list description,...
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * nodeId - Type: string. Desc: unique number per node, in case this is a list - this is the sectionNodeId
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {contentEditorResetContentColorClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var contentEditorResetContentColorClick = function (params) {
    return { evid: 239, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} pagesManagerClickOnPageParams
* @property {string} adiBuilderType - null
* @property {GUID} appId - app_id
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} pageId - number of page
* @property {string} pageName - page name
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} source - second topbar / pages panel
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: pagesManager - click on page. Evid: 368.
 * Event description: Module: pagesManager. Flow: user switches between pages in pages panel.

 * adiBuilderType - Type: string.
 *
 * appId - Type: guid. Desc: app_id
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * pageId - Type: string. Desc: number of page
 *
 * pageName - Type: string. Desc: page name
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * source - Type: string. Desc: second topbar / pages panel
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {pagesManagerClickOnPageParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pagesManagerClickOnPage = function (params) {
    return { evid: 368, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} introStieConverterPhaseInImportCompleteParams
* @property {string} adiBuilderType - NA
* @property {string} details - wix site, non-wix site, content-imported, content-not-imported
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} intervalLoadTime - load time of this phase in ms
* @property {boolean} isHomepage - true if importing the homepage
* @property {number} loadTime - total load time till this phase in ms
* @property {GUID} msid - metasite id
* @property {string} phaseName - phase name
* @property {string} screenResolution - screen resolution
* @property {string} structureId - structure id
* @property {number} totalPages - total number of pages to import
* @property {string} url - site url for conversion
* @property {GUID} uuid - user id
**/
/**
 * Name: intro - Site Converter - phase in import - complete. Evid: 124.
 * Event description: Module: builder. Flow: a phase in the init has been completed.

 * adiBuilderType - Type: string. Desc: NA
 *
 * details - Type: string. Desc: wix site, non-wix site, content-imported, content-not-imported
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * intervalLoadTime - Type: numeric. Desc: load time of this phase in ms
 *
 * isHomepage - Type: bool. Desc: true if importing the homepage
 *
 * loadTime - Type: numeric. Desc: total load time till this phase in ms
 *
 * msid - Type: guid. Desc: metasite id
 *
 * phaseName - Type: string. Desc: phase name
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * structureId - Type: string. Desc: structure id
 *
 * totalPages - Type: numeric. Desc: total number of pages to import
 *
 * url - Type: string. Desc: site url for conversion
 *
 * uuid - Type: guid. Desc: user id
 * @param {introStieConverterPhaseInImportCompleteParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var introStieConverterPhaseInImportComplete = function (params) {
    return { evid: 124, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderTopBarGoToSiteSettingsParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - Top Bar - Go To Site Settings. Evid: 149.
 * Event description: Module: builder. Flow: user clicks on site > site settings. .

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderTopBarGoToSiteSettingsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderTopBarGoToSiteSettings = function (params) {
    return { evid: 149, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} siteDesignChangeFontSizeSuccessParams
* @property {string} adiBuilderType - null
* @property {string} designId - id of the design
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} fontSize - font size
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} loadTime - time to change size
* @property {GUID} msid - metasite id
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} setId - unique identifier of the font set
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: siteDesign - Change font size - success. Evid: 329.
 * Event description: Module: siteDesign. Flow: user changes font size - success.

 * adiBuilderType - Type: string.
 *
 * designId - Type: string. Desc: id of the design
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * fontSize - Type: string. Desc: font size
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * loadTime - Type: numeric. Desc: time to change size
 *
 * msid - Type: guid. Desc: metasite id
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * setId - Type: string. Desc: unique identifier of the font set
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {siteDesignChangeFontSizeSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteDesignChangeFontSizeSuccess = function (params) {
    return { evid: 329, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} sectionManagementSectionDuplicateSuccessParams
* @property {string} adiBuilderType - null
* @property {string} appId - in case of tpa: app_id/blog
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} loadTime - time in ms
* @property {GUID} msid - metasite id
* @property {string} nodeId - unique number per node
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: sectionManagement - Section duplicate - success. Evid: 265.
 * Event description: Module: sectionManagement. Flow: section was duplicated successfully..

 * adiBuilderType - Type: string.
 *
 * appId - Type: string. Desc: in case of tpa: app_id/blog
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * loadTime - Type: numeric. Desc: time in ms
 *
 * msid - Type: guid. Desc: metasite id
 *
 * nodeId - Type: string. Desc: unique number per node
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {sectionManagementSectionDuplicateSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionManagementSectionDuplicateSuccess = function (params) {
    return { evid: 265, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} pagesManagerRemoveTpaPackageSuccessParams
* @property {string} adiBuilderType - desktop / mobile / MED
* @property {string} appId - in case of tpa: app_id/blog
* @property {GUID} appInstanceId - app instance id
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {boolean} is_columns - flag for columns in selected layout
* @property {number} loadTime - time in ms
* @property {GUID} msid - metasite id
* @property {string} nodeId - unique number per node
* @property {number} numOfPages - number of additional TPA pages removed
* @property {number} revision - builder version
* @property {string} screenResolution - screen_resolution
* @property {string} structureId - structure id
**/
/**
 * Name: apps - Remove TPA package - success. Evid: 373.
 * Event description: Module: apps. Flow: all TPA pages/sections were deleted..

 * adiBuilderType - Type: string. Desc: desktop / mobile / MED
 *
 * appId - Type: string. Desc: in case of tpa: app_id/blog
 *
 * appInstanceId - Type: guid. Desc: app instance id
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * is_columns - Type: bool. Desc: flag for columns in selected layout
 *
 * loadTime - Type: numeric. Desc: time in ms
 *
 * msid - Type: guid. Desc: metasite id
 *
 * nodeId - Type: string. Desc: unique number per node
 *
 * numOfPages - Type: numeric. Desc: number of additional TPA pages removed
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string. Desc: screen_resolution
 *
 * structureId - Type: string. Desc: structure id
 * @param {pagesManagerRemoveTpaPackageSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pagesManagerRemoveTpaPackageSuccess = function (params) {
    return { evid: 373, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} introLogoPaletteNavigationClickParams
* @property {string} adiBuilderType - desktop / mobile / MED
* @property {string} colorationLevel - {plain, tinted, colorful, vibrant, none}
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} selectedIndustryId - industry id
* @property {string} navButton - name of navigation button: next / skip / back / escape
* @property {string} nextView - name of next page: business type / services selection / business name / location / search confirm / search results / edit info card / builder / pro editor
* @property {number} num_of_colors - number of colors in the palette
* @property {string} screenResolution - screen resolution of user's device
* @property {string} selectedStructureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: intro - Logo palette - navigation click. Evid: 95.
 * Event description: Module: intro. Flow: user clicks on a navigation button in the Logo palette page of welcomeTour..

 * adiBuilderType - Type: string. Desc: desktop / mobile / MED
 *
 * colorationLevel - Type: string. Desc: {plain, tinted, colorful, vibrant, none}
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * selectedIndustryId - Type: string. Desc: industry id
 *
 * navButton - Type: string. Desc: name of navigation button: next / skip / back / escape
 *
 * nextView - Type: string. Desc: name of next page: business type / services selection / business name / location / search confirm / search results / edit info card / builder / pro editor
 *
 * num_of_colors - Type: numeric. Desc: number of colors in the palette
 *
 * screenResolution - Type: string. Desc: screen resolution of user's device
 *
 * selectedStructureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {introLogoPaletteNavigationClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var introLogoPaletteNavigationClick = function (params) {
    return { evid: 95, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} pagesManagerPagePermissionsPanelCtaClickParams
* @property {string} adiBuilderType - MED / desktop
* @property {string} appId - in case of tpa: app_id/blog
* @property {string} cta - article's title: Permissions: Members Only / Permissions / Permissions: Everyone/ etc...
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {number} fieldLength - length of text in the field (when relevant)
* @property {string} fieldName - which field is updated: title,description,keywords,show in page results, page url
* @property {string} fieldType - text/ boolea button / link
* @property {string} fieldValue - value selected - only for show in seach results - true / false
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} pageId - number of page
* @property {string} pageType - pageType = {TPA / General / Members / Members area - private / Members area -  public}
* @property {number} revision - builder version
* @property {string} screenResolution - -
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: pagesManager - Page permissions panel CTA click. Evid: 378.
 * Event description: Module: pagesManager. Flow: user clicks on a CTA in the Page permissions panel.

 * adiBuilderType - Type: string. Desc: MED / desktop
 *
 * appId - Type: string. Desc: in case of tpa: app_id/blog
 *
 * cta - Type: string. Desc: article's title: Permissions: Members Only / Permissions / Permissions: Everyone/ etc...
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * fieldLength - Type: numeric. Desc: length of text in the field (when relevant)
 *
 * fieldName - Type: string. Desc: which field is updated: title,description,keywords,show in page results, page url
 *
 * fieldType - Type: string. Desc: text/ boolea button / link
 *
 * fieldValue - Type: string. Desc: value selected - only for show in seach results - true / false
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * pageId - Type: string. Desc: number of page
 *
 * pageType - Type: string. Desc: pageType = {TPA / General / Members / Members area - private / Members area -  public}
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string. Desc: -
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {pagesManagerPagePermissionsPanelCtaClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pagesManagerPagePermissionsPanelCtaClick = function (params) {
    return { evid: 378, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} mediaManagementPreviewMediaClickParams
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id
* @property {string} galleryType - single item/external video/ gallery organizer
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {string} mediaType - single image/image gallery/clipart/shape/bgVideo/extVideo
* @property {GUID} msid - metasite id
* @property {string} nodeId - unique number per node, in case this is a list - this is the sectionNodeId
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: mediaManagement - Preview media - click . Evid: 409.
 * Event description: Module: mediaManagement. Flow: user clicks on the magnifying glass to enlarge an image in the gallery organizer, or clicks on the play button in the external video gallery. .

 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id
 *
 * galleryType - Type: string. Desc: single item/external video/ gallery organizer
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * mediaType - Type: string. Desc: single image/image gallery/clipart/shape/bgVideo/extVideo
 *
 * msid - Type: guid. Desc: metasite id
 *
 * nodeId - Type: string. Desc: unique number per node, in case this is a list - this is the sectionNodeId
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {mediaManagementPreviewMediaClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var mediaManagementPreviewMediaClick = function (params) {
    return { evid: 409, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} introBusinessTypeNotSupportedParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} mainCategory - the category from the "vertical selector" category that the user chose
* @property {string} name - name of the business type
* @property {string} screenResolution - null
* @property {string} text - searched text when selecting a business type
* @property {GUID} uuid - user id
**/
/**
 * Name: intro - business type not supported . Evid: 113.
 * Event description: Module: intro. Flow: intro - Select Business type page - not supported message. .

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * mainCategory - Type: string. Desc: the category from the "vertical selector" category that the user chose
 *
 * name - Type: string. Desc: name of the business type
 *
 * screenResolution - Type: string.
 *
 * text - Type: string. Desc: searched text when selecting a business type
 *
 * uuid - Type: guid. Desc: user id
 * @param {introBusinessTypeNotSupportedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var introBusinessTypeNotSupported = function (params) {
    return { evid: 113, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} introSelectBusinessTypePageNavigationClickParams
* @property {string} adiBuilderType - null
* @property {string} contentLanguage - Content Language - which supported on ADI
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} flow - main funnel/adi intro/marketing templates
* @property {string} selectedIndustryId - industry id
* @property {boolean} isFake - true if sent fake (when intro starts from tpa page)
* @property {string} mainCategory - the category from the 'vertical selector' category that the user chose
* @property {string} name - name of the business type (in the user's lng)
* @property {string} navButton - name of navigation button: next / skip / back / escape
* @property {string} nextView - name of next page: business type / services selection / business name / location / search confirm / search results / edit info card / builder / pro editor
* @property {string} screenResolution - null
* @property {string} selectedStructureId - structure id
* @property {string} suggestList - from where user selected: example list / no matches list / category list
* @property {string} text - searched text
* @property {GUID} uuid - user id
**/
/**
 * Name: intro - Select Business type page - navigation click. Evid: 103.
 * Event description: Module: intro. Flow: user clicks on a navigation button in the select category page (1st page). .

 * adiBuilderType - Type: string.
 *
 * contentLanguage - Type: string. Desc: Content Language - which supported on ADI
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * flow - Type: string. Desc: main funnel/adi intro/marketing templates
 *
 * selectedIndustryId - Type: string. Desc: industry id
 *
 * isFake - Type: bool. Desc: true if sent fake (when intro starts from tpa page)
 *
 * mainCategory - Type: string. Desc: the category from the 'vertical selector' category that the user chose
 *
 * name - Type: string. Desc: name of the business type (in the user's lng)
 *
 * navButton - Type: string. Desc: name of navigation button: next / skip / back / escape
 *
 * nextView - Type: string. Desc: name of next page: business type / services selection / business name / location / search confirm / search results / edit info card / builder / pro editor
 *
 * screenResolution - Type: string.
 *
 * selectedStructureId - Type: string. Desc: structure id
 *
 * suggestList - Type: string. Desc: from where user selected: example list / no matches list / category list
 *
 * text - Type: string. Desc: searched text
 *
 * uuid - Type: guid. Desc: user id
 * @param {introSelectBusinessTypePageNavigationClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var introSelectBusinessTypePageNavigationClick = function (params) {
    return { evid: 103, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} itemsManagerReorderItemParams
* @property {string} adiBuilderType - null
* @property {string} appId - in case of tpa: app_id/blog
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {string} item - pages / menu
* @property {string} itemType - page / section / document / external link etc.
* @property {GUID} msid - metasite id
* @property {string} pageId - number of page
* @property {number} position - new position
* @property {number} prevPosition - previous position
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: ItemsManager - reorder item. Evid: 365.
 * Event description: Module: itemsManager. Flow: user changes a Item's order in menu / pages.

 * adiBuilderType - Type: string.
 *
 * appId - Type: string. Desc: in case of tpa: app_id/blog
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * item - Type: string. Desc: pages / menu
 *
 * itemType - Type: string. Desc: page / section / document / external link etc.
 *
 * msid - Type: guid. Desc: metasite id
 *
 * pageId - Type: string. Desc: number of page
 *
 * position - Type: numeric. Desc: new position
 *
 * prevPosition - Type: numeric. Desc: previous position
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {itemsManagerReorderItemParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var itemsManagerReorderItem = function (params) {
    return { evid: 365, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderTopBarHireAWebProfessionalParams
* @property {string} adiBuilderType - type of ADI builder: desktop/MED/headless
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} origin - top bar/smart assist
* @property {string} screenResolution - screen resolution of user device
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - Hire a web professional click. Evid: 191.
 * Event description: Module: builder. Flow: user clicks on Hire a web professional from sites menu or smart assist panel.

 * adiBuilderType - Type: string. Desc: type of ADI builder: desktop/MED/headless
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * origin - Type: string. Desc: top bar/smart assist
 *
 * screenResolution - Type: string. Desc: screen resolution of user device
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderTopBarHireAWebProfessionalParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderTopBarHireAWebProfessional = function (params) {
    return { evid: 191, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} loadingFirstTimeInitDataLayoutSolverRenderParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} intervalLoadTime - loading time diff from previous phase
* @property {number} loadTime - loading time till this phase
* @property {GUID} msid - metasite id
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: loading - first time - Init Data: Layout solver + render. Evid: 131.
 * Event description: Module: builder. Flow: phase in opening the builder (first time) started..

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * intervalLoadTime - Type: numeric. Desc: loading time diff from previous phase
 *
 * loadTime - Type: numeric. Desc: loading time till this phase
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {loadingFirstTimeInitDataLayoutSolverRenderParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var loadingFirstTimeInitDataLayoutSolverRender = function (params) {
    return { evid: 131, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderSuggestedDomainApiResponseParams
* @property {string} adiBuilderType - ADI builder type
* @property {string} domains - array of returned domains
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {number} revision - revision
* @property {string} screenResolution - screen_resolution
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - suggested domain API response. Evid: 40.
 * Event description: Module: builder. Flow: suggest domain API returned an answer.

 * adiBuilderType - Type: string. Desc: ADI builder type
 *
 * domains - Type: string. Desc: array of returned domains
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * revision - Type: numeric. Desc: revision
 *
 * screenResolution - Type: string. Desc: screen_resolution
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderSuggestedDomainApiResponseParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderSuggestedDomainApiResponse = function (params) {
    return { evid: 40, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} tourWelcomeTourAddPagesNavigationParams
* @property {string} action - skip / next
* @property {string} adiBuilderType - dekstop / MED / headless
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {GUID} msid - metasite id
* @property {string} screenResolution - -
* @property {string} selection - pages and their final state separated by comma: contact=true,about=false etc.
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: tour - welcome tour - Add pages - navigation. Evid: 76.
 * Event description: Module: tour. Flow: when user choose a design kit in welcome tour.

 * action - Type: string. Desc: skip / next
 *
 * adiBuilderType - Type: string. Desc: dekstop / MED / headless
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string. Desc: -
 *
 * selection - Type: string. Desc: pages and their final state separated by comma: contact=true,about=false etc.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {tourWelcomeTourAddPagesNavigationParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tourWelcomeTourAddPagesNavigation = function (params) {
    return { evid: 76, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} medIntroPickStyleNavigationClickParams
* @property {string} adiBuilderType - MED
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} screenResolution - screen resolution
* @property {string} style - theme chosen
* @property {GUID} uuid - user id
**/
/**
 * Name: MED - intro - pick style navigation click. Evid: 891.
 * Event description: Module: MED. Flow: user picks one of the styles which sends them to the next page.

 * adiBuilderType - Type: string. Desc: MED
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * style - Type: string. Desc: theme chosen
 *
 * uuid - Type: guid. Desc: user id
 * @param {medIntroPickStyleNavigationClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var medIntroPickStyleNavigationClick = function (params) {
    return { evid: 891, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} sectionManagementSectionMenuDeleteSectionClickParams
* @property {string} adiBuilderType - null
* @property {string} appId - null
* @property {string} editMode - null
* @property {GUID} esi - null
* @property {string} industryId - null
* @property {string} instanceId - null
* @property {boolean} isLinked - flag for linked sections
* @property {GUID} msid - null
* @property {string} nodeId - null
* @property {string} origin - how delete section dialog was shown: hide-all-elements / more-actions
* @property {string} pageId - null
* @property {number} revision - null
* @property {string} screenResolution - null
* @property {string} sectionAlias - null
* @property {string} sectionType - null
* @property {string} structureId - null
* @property {GUID} uuid - null
**/
/**
 * Name: sectionManagement - Section menu - Delete section click. Evid: 257.
 * Event description: Module: sectionManagement. Flow: user clicks on delete section from the section menu..

 * adiBuilderType - Type: string.
 *
 * appId - Type: string.
 *
 * editMode - Type: string.
 *
 * esi - Type: guid.
 *
 * industryId - Type: string.
 *
 * instanceId - Type: string.
 *
 * isLinked - Type: bool. Desc: flag for linked sections
 *
 * msid - Type: guid.
 *
 * nodeId - Type: string.
 *
 * origin - Type: string. Desc: how delete section dialog was shown: hide-all-elements / more-actions
 *
 * pageId - Type: string.
 *
 * revision - Type: numeric.
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string.
 *
 * sectionType - Type: string.
 *
 * structureId - Type: string.
 *
 * uuid - Type: guid.
 * @param {sectionManagementSectionMenuDeleteSectionClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionManagementSectionMenuDeleteSectionClick = function (params) {
    return { evid: 257, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderTopBarClickOnLinkToOneOfTheAccountPagesParams
* @property {string} adiBuilderType - type of builder editor: mobile / desktop
* @property {GUID} esi - editing session id
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - msid
* @property {string} name - page name (my sites, account settings, billing)
* @property {string} screenResolution - screen resolution
* @property {string} structureId - structure id
* @property {GUID} uuid - uuid
**/
/**
 * Name: builder - Top Bar - click on link to one of the account pages. Evid: 189.
 * Event description: Module: builder. Flow: user clicks in account menu on one of the links to an account page (my sites, account settings, billing).

 * adiBuilderType - Type: string. Desc: type of builder editor: mobile / desktop
 *
 * esi - Type: guid. Desc: editing session id
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: msid
 *
 * name - Type: string. Desc: page name (my sites, account settings, billing)
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: uuid
 * @param {builderTopBarClickOnLinkToOneOfTheAccountPagesParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderTopBarClickOnLinkToOneOfTheAccountPages = function (params) {
    return { evid: 189, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderPreviewSiteClosePageParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {string} mode - preview in welcome tour / preview in builder
* @property {GUID} msid - metasite id
* @property {string} navigationClick - back / edit. relevant for preview in welcome tour
* @property {number} revision - -
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - Preview Site - Close page. Evid: 162.
 * Event description: Module: builder. Flow: user closes the preview site mode. .

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * mode - Type: string. Desc: preview in welcome tour / preview in builder
 *
 * msid - Type: guid. Desc: metasite id
 *
 * navigationClick - Type: string. Desc: back / edit. relevant for preview in welcome tour
 *
 * revision - Type: numeric. Desc: -
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderPreviewSiteClosePageParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderPreviewSiteClosePage = function (params) {
    return { evid: 162, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} tourFirstStepSelectionForMeOrShowMeParams
* @property {string} adiBuilderType - null
* @property {string} button - button clicked: show me how / do it for me
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} name - name of tour: welcome / preview / design-entire website / design-fonts&colors / edit section / add section / add page
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: tour - first step selection (for me or show me). Evid: 57.
 * Event description: Module: tour. Flow: user starts a tour and chooses between 'show me how' and 'do it for me'. .

 * adiBuilderType - Type: string.
 *
 * button - Type: string. Desc: button clicked: show me how / do it for me
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * name - Type: string. Desc: name of tour: welcome / preview / design-entire website / design-fonts&colors / edit section / add section / add page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {tourFirstStepSelectionForMeOrShowMeParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tourFirstStepSelectionForMeOrShowMe = function (params) {
    return { evid: 57, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderIntroQuestionsDialogPageViewParams
* @property {string} adiBuilderType - ADI builder type
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} mainCategory - the category from the 'vertical selector' category that the user chose
* @property {string} origin - create from template/ builder
* @property {string} screenResolution - screen resolution
* @property {GUID} uuid - user id
* @property {string} view - name of page: business type / business name
**/
/**
 * Name: builder - intro questions dialog - page view. Evid: 90.
 * Event description: Module: intro. Flow: questions from intro viewed as dialog in builder.

 * adiBuilderType - Type: string. Desc: ADI builder type
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * mainCategory - Type: string. Desc: the category from the 'vertical selector' category that the user chose
 *
 * origin - Type: string. Desc: create from template/ builder
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * uuid - Type: guid. Desc: user id
 *
 * view - Type: string. Desc: name of page: business type / business name
 * @param {builderIntroQuestionsDialogPageViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderIntroQuestionsDialogPageView = function (params) {
    return { evid: 90, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} loadingFirstTimeCompleteParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {number} focusOnTab - 1 - if the tab was focused during the loading time, 0 if switched tabs during loading
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} intervalLoadTime - loading time diff from previous phase
* @property {number} loadTime - loading time till this phase
* @property {string} loadingDetails - different loading details
* @property {GUID} msid - metasite id
* @property {string} rtlEnabled - true/false
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {number} timeInPage - time that user spent in ADI tab (in ms)
* @property {GUID} uuid - user id
* @property {string} validStory - true / false
**/
/**
 * Name: loading - first time - complete. Evid: 134.
 * Event description: Module: builder. Flow: builder is loaded for the first time (after the intro). .

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * focusOnTab - Type: numeric. Desc: 1 - if the tab was focused during the loading time, 0 if switched tabs during loading
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * intervalLoadTime - Type: numeric. Desc: loading time diff from previous phase
 *
 * loadTime - Type: numeric. Desc: loading time till this phase
 *
 * loadingDetails - Type: string. Desc: different loading details
 *
 * msid - Type: guid. Desc: metasite id
 *
 * rtlEnabled - Type: string. Desc: true/false
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * timeInPage - Type: numeric. Desc: time that user spent in ADI tab (in ms)
 *
 * uuid - Type: guid. Desc: user id
 *
 * validStory - Type: string. Desc: true / false
 * @param {loadingFirstTimeCompleteParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var loadingFirstTimeComplete = function (params) {
    return { evid: 134, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderStickySocialBarAddRemoveSuccessParams
* @property {string} action - add / remove
* @property {string} adiBuilderType - MED / desktop
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} screenResolution - -
* @property {GUID} uuid - user id
**/
/**
 * Name: Builder - Sticky social bar - add/remove - success. Evid: 68.
 * Event description: Module: Builder. Flow: user succeeded  to add/remove the Sticky social bar.

 * action - Type: string. Desc: add / remove
 *
 * adiBuilderType - Type: string. Desc: MED / desktop
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * screenResolution - Type: string. Desc: -
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderStickySocialBarAddRemoveSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderStickySocialBarAddRemoveSuccess = function (params) {
    return { evid: 68, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} itemsManagerHideShowItemParams
* @property {string} action - hide/show
* @property {string} adiBuilderType - null
* @property {string} appId - in case of tpa: app_id/blog
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {string} item - menu / pages
* @property {string} itemType - page / section / document / external link etc.
* @property {GUID} msid - metasite id
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: itemsManager - Hide / Show item. Evid: 356.
 * Event description: Module: itemsManager. Flow: user clicks on hide / show  item in menu/pages panel..

 * action - Type: string. Desc: hide/show
 *
 * adiBuilderType - Type: string.
 *
 * appId - Type: string. Desc: in case of tpa: app_id/blog
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * item - Type: string. Desc: menu / pages
 *
 * itemType - Type: string. Desc: page / section / document / external link etc.
 *
 * msid - Type: guid. Desc: metasite id
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {itemsManagerHideShowItemParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var itemsManagerHideShowItem = function (params) {
    return { evid: 356, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} siteDesignCustomizeDesignPanelIsLoadedParams
* @property {string} adiBuilderType - null
* @property {string} designId - id of the design
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: siteDesign - Customize design panel is loaded. Evid: 303.
 * Event description: Module: siteDesign. Flow: user clicks on 'customize' in a specific design..

 * adiBuilderType - Type: string.
 *
 * designId - Type: string. Desc: id of the design
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {siteDesignCustomizeDesignPanelIsLoadedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteDesignCustomizeDesignPanelIsLoaded = function (params) {
    return { evid: 303, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} sectionDesignShowHideListHeaderBackgroundClickParams
* @property {string} action - hide/show
* @property {string} adiBuilderType - null
* @property {string} designId - id of the design
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: sectionDesign - show/hide list header background - click. Evid: 564.
 * Event description: Module: sectionDesign. Flow: user toggles list section header background.

 * action - Type: string. Desc: hide/show
 *
 * adiBuilderType - Type: string.
 *
 * designId - Type: string. Desc: id of the design
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {sectionDesignShowHideListHeaderBackgroundClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionDesignShowHideListHeaderBackgroundClick = function (params) {
    return { evid: 564, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} mediaManagementCloseMediaWindowParams
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id
* @property {string} galleryType - single item/external video/ gallery organizer
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {string} mediaType - single image/image gallery/clipart/shape/bgVideo/extVideo
* @property {GUID} msid - metasite id
* @property {string} nodeId - unique number per node, in case this is a list - this is the sectionNodeId
* @property {string} origin - from where the media window was opened: edit panel /gallery organizer
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: mediaManagement - Close media window. Evid: 401.
 * Event description: Module: mediaManagement. Flow: user clicks on cancel or X in media organizer, only for the media organizer. .

 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id
 *
 * galleryType - Type: string. Desc: single item/external video/ gallery organizer
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * mediaType - Type: string. Desc: single image/image gallery/clipart/shape/bgVideo/extVideo
 *
 * msid - Type: guid. Desc: metasite id
 *
 * nodeId - Type: string. Desc: unique number per node, in case this is a list - this is the sectionNodeId
 *
 * origin - Type: string. Desc: from where the media window was opened: edit panel /gallery organizer
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {mediaManagementCloseMediaWindowParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var mediaManagementCloseMediaWindow = function (params) {
    return { evid: 401, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} sectionDesignColorPanelOpenedParams
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} origin - where the panel was opened (background-panel, customize-design)
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: sectionDesign - Color panel opened. Evid: 550.
 * Event description: Module: sectionDesign. Flow: user opens section color panel.

 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * origin - Type: string. Desc: where the panel was opened (background-panel, customize-design)
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {sectionDesignColorPanelOpenedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionDesignColorPanelOpened = function (params) {
    return { evid: 550, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderCsArticleSearchApiRequestParams
* @property {string} adiBuilderType - ADI builder type
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {number} revision - revision
* @property {string} screenResolution - screen_resolution
* @property {string} structureId - structure id
* @property {string} text - searched text
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - CS article search API request. Evid: 70.
 * Event description: Module: builder. Flow: CS article search API call is made.

 * adiBuilderType - Type: string. Desc: ADI builder type
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * revision - Type: numeric. Desc: revision
 *
 * screenResolution - Type: string. Desc: screen_resolution
 *
 * structureId - Type: string. Desc: structure id
 *
 * text - Type: string. Desc: searched text
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderCsArticleSearchApiRequestParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderCsArticleSearchApiRequest = function (params) {
    return { evid: 70, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} tourAssistantVideoModalCloseParams
* @property {string} adiBuilderType - desktop, mobile
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {number} revision - builder version
* @property {string} screenResolution - screen resolution
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: tour - Assistant Video Modal Close. Evid: 64.
 * Event description: Module: tour. Flow: user closes the assistant video modal.

 * adiBuilderType - Type: string. Desc: desktop, mobile
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {tourAssistantVideoModalCloseParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tourAssistantVideoModalClose = function (params) {
    return { evid: 64, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} notificationsNotificationsBadgeShownParams
* @property {string} adiBuilderType -
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} name - deprecated
* @property {number} revision - builder version
* @property {string} screenResolution -
* @property {string} state - array of notification types
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: notifications - notifications badge shown. Evid: 60.
 * Event description: Module: notifications. Flow: notifications badge shown on notification center..

 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * name - Type: string. Desc: deprecated
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * state - Type: string. Desc: array of notification types
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {notificationsNotificationsBadgeShownParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var notificationsNotificationsBadgeShown = function (params) {
    return { evid: 60, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} sectionDesignChangeTextAlignmentClickParams
* @property {string} adiBuilderType - mobile or desktop editor
* @property {string} designId - id of the design
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} origin - OSI / panel
* @property {number} revision - builder version
* @property {string} screenResolution - screen resolution
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} setId - unique identifier of the font set
* @property {string} structureId - structure id
* @property {string} textAlign - text alignment (left,right.center)
* @property {GUID} uuid - user id
**/
/**
 * Name: sectionDesign - change text alignment - click. Evid: 570.
 * Event description: Module: sectionDesign. Flow: user changes section text alignment.

 * adiBuilderType - Type: string. Desc: mobile or desktop editor
 *
 * designId - Type: string. Desc: id of the design
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * origin - Type: string. Desc: OSI / panel
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * setId - Type: string. Desc: unique identifier of the font set
 *
 * structureId - Type: string. Desc: structure id
 *
 * textAlign - Type: string. Desc: text alignment (left,right.center)
 *
 * uuid - Type: guid. Desc: user id
 * @param {sectionDesignChangeTextAlignmentClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionDesignChangeTextAlignmentClick = function (params) {
    return { evid: 570, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderTopBarPreviewSiteSuccessParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} loadTime - time in ms elapsed since start loading the preview
* @property {string} mode - preview in welcome tour / preview in builder
* @property {GUID} msid - metasite id
* @property {number} revision - -
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - Preview site success. Evid: 179.
 * Event description: Module: builder. Flow: preview site success.

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * loadTime - Type: numeric. Desc: time in ms elapsed since start loading the preview
 *
 * mode - Type: string. Desc: preview in welcome tour / preview in builder
 *
 * msid - Type: guid. Desc: metasite id
 *
 * revision - Type: numeric. Desc: -
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderTopBarPreviewSiteSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderTopBarPreviewSiteSuccess = function (params) {
    return { evid: 179, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} contentEditorGalleryLayoutWindowOpenedParams
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {string} layoutType - image / full width / shape
* @property {GUID} msid - metasite id
* @property {number} noOfSuggestions - int number that represents the number of suggested layouts
* @property {string} nodeId - unique number per node, in case this is a list - this is the sectionNodeId
* @property {string} origin - OSI / right click
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: contentEditor - Gallery layout window - opened. Evid: 221.
 * Event description: Module: contentEditor. Flow: user clicks on Change Gallery Type and galleries layout window is opened. .

 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * layoutType - Type: string. Desc: image / full width / shape
 *
 * msid - Type: guid. Desc: metasite id
 *
 * noOfSuggestions - Type: numeric. Desc: int number that represents the number of suggested layouts
 *
 * nodeId - Type: string. Desc: unique number per node, in case this is a list - this is the sectionNodeId
 *
 * origin - Type: string. Desc: OSI / right click
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {contentEditorGalleryLayoutWindowOpenedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var contentEditorGalleryLayoutWindowOpened = function (params) {
    return { evid: 221, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} mediaManagementMediaSettingsFieldWasUpdatedParams
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id
* @property {number} fieldLength - length of text in the field
* @property {string} fieldName - which field is updated: media preview,title,description,link,video url, auto play,loop play, video controls
* @property {string} fieldType - text/ dropdown/ link / long text / toggle
* @property {string} fieldValue - value selected - only for dropdown & toggle fields
* @property {string} galleryType - single item/external video/ gallery organizer
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {string} mediaType - single image/image gallery/clipart/shape/bgVideo/extVideo
* @property {GUID} msid - metasite id
* @property {string} nodeId - unique number per node, in case this is a list - this is the sectionNodeId
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: mediaManagement - Media Settings - field was updated. Evid: 412.
 * Event description: Module: mediaManagement. Flow: user update a field in the media settings (clipart, shape, single image, extVideo or image gallery). .

 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id
 *
 * fieldLength - Type: numeric. Desc: length of text in the field
 *
 * fieldName - Type: string. Desc: which field is updated: media preview,title,description,link,video url, auto play,loop play, video controls
 *
 * fieldType - Type: string. Desc: text/ dropdown/ link / long text / toggle
 *
 * fieldValue - Type: string. Desc: value selected - only for dropdown & toggle fields
 *
 * galleryType - Type: string. Desc: single item/external video/ gallery organizer
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * mediaType - Type: string. Desc: single image/image gallery/clipart/shape/bgVideo/extVideo
 *
 * msid - Type: guid. Desc: metasite id
 *
 * nodeId - Type: string. Desc: unique number per node, in case this is a list - this is the sectionNodeId
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {mediaManagementMediaSettingsFieldWasUpdatedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var mediaManagementMediaSettingsFieldWasUpdated = function (params) {
    return { evid: 412, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} loadingExistingSiteLoadCampaignLoadCampaignDataCompleteParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} intervalLoadTime - loading time diff from previous phase
* @property {number} loadTime - loading time till this phase
* @property {GUID} msid - metasite id
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: loading - existing site - Load Campaign: Load campaign data complete. Evid: 518.
 * Event description: Module: builder. Flow: phase in opening the builder (existing site) completed..

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * intervalLoadTime - Type: numeric. Desc: loading time diff from previous phase
 *
 * loadTime - Type: numeric. Desc: loading time till this phase
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {loadingExistingSiteLoadCampaignLoadCampaignDataCompleteParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var loadingExistingSiteLoadCampaignLoadCampaignDataComplete = function (params) {
    return { evid: 518, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderSwitchViewFromAnonToUserSuccess27Params
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} loadTime - **deprecated**
* @property {GUID} msid - metasite id
* @property {string} origin - what triggered the login / sign up
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {string} userStatus - new / existing
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - switch view from anon to user - success. Evid: 27.
 * Event description: Module: builder. Flow: after user logged in or signed up successfully.

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * loadTime - Type: numeric. Desc: **deprecated**
 *
 * msid - Type: guid. Desc: metasite id
 *
 * origin - Type: string. Desc: what triggered the login / sign up
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * userStatus - Type: string. Desc: new / existing
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderSwitchViewFromAnonToUserSuccess27Params} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderSwitchViewFromAnonToUserSuccess27 = function (params) {
    return { evid: 27, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} mediaManagementGalleryOrganizerClickAddMoreMediaParams
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} nodeId - unique number per node, in case this is a list - this is the sectionNodeId
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: mediaManagement - Gallery Organizer - Click add more media. Evid: 403.
 * Event description: Module: mediaManagement. Flow: user clicks on add more images in the gallery organizer. .

 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * nodeId - Type: string. Desc: unique number per node, in case this is a list - this is the sectionNodeId
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {mediaManagementGalleryOrganizerClickAddMoreMediaParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var mediaManagementGalleryOrganizerClickAddMoreMedia = function (params) {
    return { evid: 403, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} introWixwizSearchResultsGoToTopOfPageClickParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} mainCategory - the category from the 'vertical selector' category that the user chose
* @property {number} noOfMatches - for search results page: number of results that were found (overall)
* @property {number} noOfSeenMatches - number of results that user saw (how many results fully displayed on screen)
* @property {string} screenResolution - null
* @property {GUID} searchGuid - for search results page: every search a new guid is generated by wixwiz server
* @property {GUID} uuid - user id
**/
/**
 * Name: intro - Wixwiz Search results - go to top of page click. Evid: 109.
 * Event description: Module: intro. Flow: user clicks on 'go to top' in wixwiz page results. .

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * mainCategory - Type: string. Desc: the category from the 'vertical selector' category that the user chose
 *
 * noOfMatches - Type: numeric. Desc: for search results page: number of results that were found (overall)
 *
 * noOfSeenMatches - Type: numeric. Desc: number of results that user saw (how many results fully displayed on screen)
 *
 * screenResolution - Type: string.
 *
 * searchGuid - Type: guid. Desc: for search results page: every search a new guid is generated by wixwiz server
 *
 * uuid - Type: guid. Desc: user id
 * @param {introWixwizSearchResultsGoToTopOfPageClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var introWixwizSearchResultsGoToTopOfPageClick = function (params) {
    return { evid: 109, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} medGatewayAllocationRequestTryParams
* @property {string} adiBuilderType - MED
* @property {GUID} esi - editor session id, for every site editing session
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} screenResolution - null
**/
/**
 * Name: MED - Gateway Allocation Request Try. Evid: 1800.
 * Event description: Module: MED. Flow: Gateway allocation request sent.

 * adiBuilderType - Type: string. Desc: MED
 *
 * esi - Type: guid. Desc: editor session id, for every site editing session
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string.
 * @param {medGatewayAllocationRequestTryParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var medGatewayAllocationRequestTry = function (params) {
    return { evid: 1800, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} introSiteConverterSiteJsonParsingFailedParams
* @property {string} adiBuilderType - desktop / mobile
* @property {GUID} esi - editor session id, for every site editting session
* @property {number} imagesLeft - number of images left after parsing
* @property {number} imagesOrig - number of images in the original json
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} loadTime - time elapsed from process start
* @property {GUID} msid - metasite id
* @property {string} screenResolution - screen resolution
* @property {number} sectionsLeft - number of sections left after parsing
* @property {number} sectionsOrig - number of sections in the original json
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: intro - Site Converter - Site json parsing failed. Evid: 8.
 * Event description: Module: intro. Flow: parsing process of JSON (imported from WixWiz) has failed.

 * adiBuilderType - Type: string. Desc: desktop / mobile
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * imagesLeft - Type: numeric. Desc: number of images left after parsing
 *
 * imagesOrig - Type: numeric. Desc: number of images in the original json
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * loadTime - Type: numeric. Desc: time elapsed from process start
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * sectionsLeft - Type: numeric. Desc: number of sections left after parsing
 *
 * sectionsOrig - Type: numeric. Desc: number of sections in the original json
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {introSiteConverterSiteJsonParsingFailedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var introSiteConverterSiteJsonParsingFailed = function (params) {
    return { evid: 8, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} tourCompleteParams
* @property {string} adiBuilderType - null
* @property {string} assistType - tours / smart assist
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} name - name of tour: welcome / preview / design-entire website / design-fonts&colors / edit section / add section / add page
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: tour - Complete. Evid: 52.
 * Event description: Module: tour. Flow: tour complete dialog is shown. .

 * adiBuilderType - Type: string.
 *
 * assistType - Type: string. Desc: tours / smart assist
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * name - Type: string. Desc: name of tour: welcome / preview / design-entire website / design-fonts&colors / edit section / add section / add page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {tourCompleteParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tourComplete = function (params) {
    return { evid: 52, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} contentEditorImageResolutionImproveDialogApproveParams
* @property {string} action - on / off
* @property {string} adiBuilderType - desktop / MED / ...
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} improvedImageUrl - url of the improved image
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} nodeId - unique number per node, in case this is a list - this is the sectionNodeId
* @property {string} originalImageSize - w X h
* @property {string} originalImageUrl - url of the image uploaded by the user
* @property {string} pageId - number of page
* @property {string} placeholderSize - w X h
* @property {number} revision - builder version
* @property {string} screenResolution - screen resolution
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: contentEditor - Image Resolution Improve dialog approve. Evid: 421.
 * Event description: Module: contentEditor. Flow: user closes the Image Resolution Improve dialog and approves changes.

 * action - Type: string. Desc: on / off
 *
 * adiBuilderType - Type: string. Desc: desktop / MED / ...
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * improvedImageUrl - Type: string. Desc: url of the improved image
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * nodeId - Type: string. Desc: unique number per node, in case this is a list - this is the sectionNodeId
 *
 * originalImageSize - Type: string. Desc: w X h
 *
 * originalImageUrl - Type: string. Desc: url of the image uploaded by the user
 *
 * pageId - Type: string. Desc: number of page
 *
 * placeholderSize - Type: string. Desc: w X h
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {contentEditorImageResolutionImproveDialogApproveParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var contentEditorImageResolutionImproveDialogApprove = function (params) {
    return { evid: 421, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderClickOnShowMoreLessToursAfterSearchingParams
* @property {string} action - show more/show less
* @property {string} adiBuilderType - ADI builder type
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {number} revision - revision
* @property {string} screenResolution - screen_resolution
* @property {string} structureId - structure id
* @property {string} text - searched text if exists
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - click on show more/less tours after searching. Evid: 73.
 * Event description: Module: builder . Flow: user clicks on show more/less tours after searching and getting tours as a result.
expands/collapses tours list if returned more than 4.

 * action - Type: string. Desc: show more/show less
 *
 * adiBuilderType - Type: string. Desc: ADI builder type
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * revision - Type: numeric. Desc: revision
 *
 * screenResolution - Type: string. Desc: screen_resolution
 *
 * structureId - Type: string. Desc: structure id
 *
 * text - Type: string. Desc: searched text if exists
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderClickOnShowMoreLessToursAfterSearchingParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderClickOnShowMoreLessToursAfterSearching = function (params) {
    return { evid: 73, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} siteDesignCustomizeDesignChangeDarkLightModeParams
* @property {string} adiBuilderType - null
* @property {string} designId - id of the design
* @property {string} editMode - automatic / show me how / no-tour
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} name - dark/light/...
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: siteDesign - Customize Design - change dark/light mode. Evid: 318.
 * Event description: Module: siteDesign. Flow: user clicks onchange dark/light mode.

 * adiBuilderType - Type: string.
 *
 * designId - Type: string. Desc: id of the design
 *
 * editMode - Type: string. Desc: automatic / show me how / no-tour
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * name - Type: string. Desc: dark/light/...
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {siteDesignCustomizeDesignChangeDarkLightModeParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteDesignCustomizeDesignChangeDarkLightMode = function (params) {
    return { evid: 318, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderCoreLoadingLoadThemeChooserCompleteParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} intervalLoadTime - loading time diff from previous phase
* @property {number} loadTime - loading time till this phase
* @property {GUID} msid - metasite id
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - core loading - load theme chooser complete. Evid: 18.
 * Event description: Module: builder. Flow: phase in loading the core.

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * intervalLoadTime - Type: numeric. Desc: loading time diff from previous phase
 *
 * loadTime - Type: numeric. Desc: loading time till this phase
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderCoreLoadingLoadThemeChooserCompleteParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderCoreLoadingLoadThemeChooserComplete = function (params) {
    return { evid: 18, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} siteDesignCustomizeDesignChangeElementAnimationClickParams
* @property {string} adiBuilderType - null
* @property {string} designId - id of the design
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} name - name of animation: none, fade, float, ...
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: siteDesign - Customize Design - Change Element Animation Click. Evid: 316.
 * Event description: Module: siteDesign. Flow: user clicks on a desired element animation.

 * adiBuilderType - Type: string.
 *
 * designId - Type: string. Desc: id of the design
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * name - Type: string. Desc: name of animation: none, fade, float, ...
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {siteDesignCustomizeDesignChangeElementAnimationClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteDesignCustomizeDesignChangeElementAnimationClick = function (params) {
    return { evid: 316, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} contentEditorImageResolutionShowEnhancementMessageParams
* @property {string} action - super res potential: trigger / display
* @property {string} adiBuilderType - desktop / MED / ...
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {GUID} msid - metasite id
* @property {string} nodeId - unique number per node, in case this is a list - this is the sectionNodeId
* @property {string} originalImageUrl - original image url
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - screen resolution
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {number} upscaleRatio - ratio between orig size and required size values are percentage
* @property {number} upscaleRatioHeight - upscale_ratio_height, values are percentage
* @property {number} upscaleRatioWidth - upscale_ratio_weight values are percentage
**/
/**
 * Name: contentEditor - Image Resolution Triggered/Message Displayed. Evid: 419.
 * Event description: Module: contentEditor. Flow: Enhancement message is shown in media panel.

 * action - Type: string. Desc: super res potential: trigger / display
 *
 * adiBuilderType - Type: string. Desc: desktop / MED / ...
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * nodeId - Type: string. Desc: unique number per node, in case this is a list - this is the sectionNodeId
 *
 * originalImageUrl - Type: string. Desc: original image url
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * upscaleRatio - Type: numeric. Desc: ratio between orig size and required size values are percentage
 *
 * upscaleRatioHeight - Type: numeric. Desc: upscale_ratio_height, values are percentage
 *
 * upscaleRatioWidth - Type: numeric. Desc: upscale_ratio_weight values are percentage
 * @param {contentEditorImageResolutionShowEnhancementMessageParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var contentEditorImageResolutionShowEnhancementMessage = function (params) {
    return { evid: 419, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderTopBarHoverOnUpgradeParams
* @property {string} adiBuilderType - desktop/MED/headless
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} screenResolution - user device screen resolution
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - Top Bar - Hover on Upgrade. Evid: 283.
 * Event description: Module: builder. Flow: user hovers on Upgrade in Top Bar.

 * adiBuilderType - Type: string. Desc: desktop/MED/headless
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string. Desc: user device screen resolution
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderTopBarHoverOnUpgradeParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderTopBarHoverOnUpgrade = function (params) {
    return { evid: 283, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderSwitchBuilderTypeMobileDesktopSuccessParams
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} loadTime - time it took to load
* @property {GUID} msid - metasite id
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} selectedBuilder - mobile/desktop
* @property {string} source - where was switched from (topbar, pages panel)
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - switch builder type (mobile/desktop) - success. Evid: 36.
 * Event description: Module: builder. Flow: user switches between mobile and desktop editors success.

 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * loadTime - Type: numeric. Desc: time it took to load
 *
 * msid - Type: guid. Desc: metasite id
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * selectedBuilder - Type: string. Desc: mobile/desktop
 *
 * source - Type: string. Desc: where was switched from (topbar, pages panel)
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderSwitchBuilderTypeMobileDesktopSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderSwitchBuilderTypeMobileDesktopSuccess = function (params) {
    return { evid: 36, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} siteDesignDesignChangeSuccessParams
* @property {string} adiBuilderType - null
* @property {string} designId - id of the design
* @property {number} designNumber - what's the number of the selected design in the list: 1,2,…,
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} loadTime - loading time till this phase
* @property {GUID} msid - metasite id
* @property {number} noOfDesigns - how many designs there are
* @property {string} origin - how the panel is loaded: header / back from customize
* @property {string} prevDesignId - id of previous design
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {string} targetDesignId - target design id, replacing the 'designId' param in this event
* @property {GUID} uuid - user id
**/
/**
 * Name: siteDesign - Design change - success. Evid: 302.
 * Event description: Module: siteDesign. Flow: design was changed successfully..

 * adiBuilderType - Type: string.
 *
 * designId - Type: string. Desc: id of the design
 *
 * designNumber - Type: numeric. Desc: what's the number of the selected design in the list: 1,2,…,
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * loadTime - Type: numeric. Desc: loading time till this phase
 *
 * msid - Type: guid. Desc: metasite id
 *
 * noOfDesigns - Type: numeric. Desc: how many designs there are
 *
 * origin - Type: string. Desc: how the panel is loaded: header / back from customize
 *
 * prevDesignId - Type: string. Desc: id of previous design
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * targetDesignId - Type: string. Desc: target design id, replacing the 'designId' param in this event
 *
 * uuid - Type: guid. Desc: user id
 * @param {siteDesignDesignChangeSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteDesignDesignChangeSuccess = function (params) {
    return { evid: 302, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} pagesManagerAddTpaPackageSuccessParams
* @property {string} adiBuilderType - null
* @property {string} appId - in case of tpa: app_id/blog
* @property {string} appInstanceId - unique guid of app instance on site
* @property {string} appPageType - **deprecated**
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {boolean} is_columns - flag for columns in selected layout
* @property {number} loadTime - time in ms
* @property {GUID} msid - metasite id
* @property {string} nodeId - unique number per node
* @property {number} numOfPages - number of additional TPA pages added
* @property {string} origin - apps panel / section panel /biz manager
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: pagesManager - Add TPA package - success. Evid: 371.
 * Event description: Module: pagesManager. Flow: all TPA pages were created..

 * adiBuilderType - Type: string.
 *
 * appId - Type: string. Desc: in case of tpa: app_id/blog
 *
 * appInstanceId - Type: string. Desc: unique guid of app instance on site
 *
 * appPageType - Type: string. Desc: **deprecated**
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * is_columns - Type: bool. Desc: flag for columns in selected layout
 *
 * loadTime - Type: numeric. Desc: time in ms
 *
 * msid - Type: guid. Desc: metasite id
 *
 * nodeId - Type: string. Desc: unique number per node
 *
 * numOfPages - Type: numeric. Desc: number of additional TPA pages added
 *
 * origin - Type: string. Desc: apps panel / section panel /biz manager
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {pagesManagerAddTpaPackageSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pagesManagerAddTpaPackageSuccess = function (params) {
    return { evid: 371, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} sectionDesignSectionHeightChangeSuccessParams
* @property {string} adiBuilderType - desktop / mobile
* @property {string} changeHeightAction - longer / shorter
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {number} revision - builder version
* @property {string} screenResolution - screen resolution
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {number} sectionHeight - height of the section after action
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: sectionDesign - Section Height change success. Evid: 579.
 * Event description: Module: sectionDesign. Flow: section height changed.

 * adiBuilderType - Type: string. Desc: desktop / mobile
 *
 * changeHeightAction - Type: string. Desc: longer / shorter
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionHeight - Type: numeric. Desc: height of the section after action
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {sectionDesignSectionHeightChangeSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionDesignSectionHeightChangeSuccess = function (params) {
    return { evid: 579, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} tourWelcomeTourAddPagesPageViewParams
* @property {string} adiBuilderType - dekstop / MED / headless
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {GUID} msid - metasite id
* @property {string} screenResolution - -
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: tour - welcome tour - Add pages - page view. Evid: 74.
 * Event description: Module: tour. Flow: when user choose a design kit in welcome tour.

 * adiBuilderType - Type: string. Desc: dekstop / MED / headless
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string. Desc: -
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {tourWelcomeTourAddPagesPageViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tourWelcomeTourAddPagesPageView = function (params) {
    return { evid: 74, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} contentEditorClickOnAddDuplicateItemInAListParams
* @property {string} addType - new/ duplicate
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} nodeId - unique number per node, in case this is a list - this is the sectionNodeId
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: contentEditor - Click on Add/ Duplicate Item in a list. Evid: 215.
 * Event description: Module: contentEditor. Flow: user adds item to list. .

 * addType - Type: string. Desc: new/ duplicate
 *
 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * nodeId - Type: string. Desc: unique number per node, in case this is a list - this is the sectionNodeId
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {contentEditorClickOnAddDuplicateItemInAListParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var contentEditorClickOnAddDuplicateItemInAList = function (params) {
    return { evid: 215, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} loadingFirstTimeInitDataSaveStoryParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} intervalLoadTime - loading time diff from previous phase
* @property {number} loadTime - loading time till this phase
* @property {GUID} msid - metasite id
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: loading - first time - Init Data: Save story. Evid: 505.
 * Event description: Module: builder. Flow: phase in opening the builder (first time) started..

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * intervalLoadTime - Type: numeric. Desc: loading time diff from previous phase
 *
 * loadTime - Type: numeric. Desc: loading time till this phase
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {loadingFirstTimeInitDataSaveStoryParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var loadingFirstTimeInitDataSaveStory = function (params) {
    return { evid: 505, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} siteDesignCustomizeDesignColorPaletteModeAdvancedEditingColorClickSuccessParams
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / no-tour
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} loadTime - loading time between click to success
* @property {number} loading_time - loading time between click to Success
* @property {GUID} msid - metasite id
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: siteDesign - Customize Design - color palette mode - Advanced editing color click success. Evid: 321.
 * Event description: Module: siteDesign. Flow: user chooses the advanced editing button success.

 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / no-tour
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * loadTime - Type: numeric. Desc: loading time between click to success
 *
 * loading_time - Type: numeric. Desc: loading time between click to Success
 *
 * msid - Type: guid. Desc: metasite id
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {siteDesignCustomizeDesignColorPaletteModeAdvancedEditingColorClickSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteDesignCustomizeDesignColorPaletteModeAdvancedEditingColorClickSuccess = function (params) {
    return { evid: 321, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} pagesManagerSwitchPageTypeInTheAddPagePanelParams
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} pageId - number of page
* @property {string} place - where the group is placed: recommended / others / expanded list
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: pagesManager - Switch page type in the Add Page panel. Evid: 352.
 * Event description: Module: pagesManager. Flow: user switches between page types. .

 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * pageId - Type: string. Desc: number of page
 *
 * place - Type: string. Desc: where the group is placed: recommended / others / expanded list
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {pagesManagerSwitchPageTypeInTheAddPagePanelParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pagesManagerSwitchPageTypeInTheAddPagePanel = function (params) {
    return { evid: 352, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} dialogsCancelParams
* @property {string} adiBuilderType - null
* @property {GUID} appId - app id
* @property {GUID} appInstanceId - app instance id
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} name - name of dialog: delete section / move section to page / delete page / signout / create new site/ migrate old blog
* @property {string} nodeId - unique number per node, in case this is a list - this is the sectionNodeId
* @property {string} origin - where this dialog was opened from
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: dialogs - Cancel. Evid: 49.
 * Event description: Module: dialogs. Flow: user clicks on close dialog (cancel or x). .

 * adiBuilderType - Type: string.
 *
 * appId - Type: guid. Desc: app id
 *
 * appInstanceId - Type: guid. Desc: app instance id
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * name - Type: string. Desc: name of dialog: delete section / move section to page / delete page / signout / create new site/ migrate old blog
 *
 * nodeId - Type: string. Desc: unique number per node, in case this is a list - this is the sectionNodeId
 *
 * origin - Type: string. Desc: where this dialog was opened from
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {dialogsCancelParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dialogsCancel = function (params) {
    return { evid: 49, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} loadingFirstTimeStartParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} init_origin - initiator of the init
* @property {number} intervalLoadTime - loading time diff from previous phase
* @property {string} origin - from where the builder is opened: intro / home
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: loading - first time - start. Evid: 125.
 * Event description: Module: builder. Flow: builder is starting to load for the first time (after the intro). Prepare: MediaFrame warmp, callbacks.

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * init_origin - Type: string. Desc: initiator of the init
 *
 * intervalLoadTime - Type: numeric. Desc: loading time diff from previous phase
 *
 * origin - Type: string. Desc: from where the builder is opened: intro / home
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {loadingFirstTimeStartParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var loadingFirstTimeStart = function (params) {
    return { evid: 125, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderSignUpLoginPopUpShownParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} loadTime - **deprecated**
* @property {GUID} msid - metasite id
* @property {string} origin - which click has triggered the pop up
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - sign up login window shown. Evid: 26.
 * Event description: Module: builder. Flow: in anon flow, when the sign up login window is shown.

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * loadTime - Type: numeric. Desc: **deprecated**
 *
 * msid - Type: guid. Desc: metasite id
 *
 * origin - Type: string. Desc: which click has triggered the pop up
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderSignUpLoginPopUpShownParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderSignUpLoginPopUpShown = function (params) {
    return { evid: 26, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} siteDesignCustomizeDesignAdvancedFixColorsSuccessParams
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} loadTime - time in ms for fixing colors
* @property {GUID} msid - metasite id
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: siteDesign - Customize Design - Advanced - fix colors success. Evid: 327.
 * Event description: Module: siteDesign. Flow: in advanced editing, user clicked on fix colors and changes were made succeessfully.

 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * loadTime - Type: numeric. Desc: time in ms for fixing colors
 *
 * msid - Type: guid. Desc: metasite id
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {siteDesignCustomizeDesignAdvancedFixColorsSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteDesignCustomizeDesignAdvancedFixColorsSuccess = function (params) {
    return { evid: 327, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} siteDesignFontSetChangeSuccessParams
* @property {string} adiBuilderType - null
* @property {string} designId - id of the design
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} loadTime - loading time till this phase
* @property {GUID} msid - metasite id
* @property {string} name - sub panel name: font set
* @property {number} noOfSets - how many color/font sets there are
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} setId - unique identifier of the font set
* @property {number} setNumber - what's the number of the selected font set in the list: 1,2,…,35
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: siteDesign - Font Set change - success. Evid: 306.
 * Event description: Module: siteDesign. Flow: color/font set was updated successfully..

 * adiBuilderType - Type: string.
 *
 * designId - Type: string. Desc: id of the design
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * loadTime - Type: numeric. Desc: loading time till this phase
 *
 * msid - Type: guid. Desc: metasite id
 *
 * name - Type: string. Desc: sub panel name: font set
 *
 * noOfSets - Type: numeric. Desc: how many color/font sets there are
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * setId - Type: string. Desc: unique identifier of the font set
 *
 * setNumber - Type: numeric. Desc: what's the number of the selected font set in the list: 1,2,…,35
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {siteDesignFontSetChangeSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteDesignFontSetChangeSuccess = function (params) {
    return { evid: 306, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderStickySocialBarAddRemoveClickParams
* @property {string} action - add / remove
* @property {string} adiBuilderType - MED / desktop
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} origin - panel / intro / osi
* @property {string} screenResolution - -
* @property {GUID} uuid - user id
**/
/**
 * Name: Builder - Sticky social bar - add/remove - click. Evid: 67.
 * Event description: Module: Builder. Flow: user add/remove Sticky social bar.

 * action - Type: string. Desc: add / remove
 *
 * adiBuilderType - Type: string. Desc: MED / desktop
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * origin - Type: string. Desc: panel / intro / osi
 *
 * screenResolution - Type: string. Desc: -
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderStickySocialBarAddRemoveClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderStickySocialBarAddRemoveClick = function (params) {
    return { evid: 67, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} tourAssistantVideoModalLoadedParams
* @property {string} adiBuilderType - desktop, mobile
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} origin - assistant
* @property {number} revision - builder version
* @property {string} screenResolution - screen resolution
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: tour - Assistant Video Modal Loaded. Evid: 63.
 * Event description: Module: tour. Flow: user opened the intro video.

 * adiBuilderType - Type: string. Desc: desktop, mobile
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * origin - Type: string. Desc: assistant
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {tourAssistantVideoModalLoadedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tourAssistantVideoModalLoaded = function (params) {
    return { evid: 63, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} siteDesignCustomizeDesignSubPanelIsLoadedParams
* @property {string} adiBuilderType - null
* @property {string} designId - null
* @property {string} editMode - null
* @property {GUID} esi - null
* @property {string} industryId - null
* @property {string} instanceId - null
* @property {GUID} msid - null
* @property {string} name - null
* @property {string} origin - how panel was opened {topbar, design panel}
* @property {number} revision - null
* @property {string} screenResolution - null
* @property {string} structureId - null
* @property {GUID} uuid - null
**/
/**
 * Name: siteDesign - Customize Design - sub panel is loaded. Evid: 304.
 * Event description: Module: siteDesign. Flow: user opens the animation / font panel..

 * adiBuilderType - Type: string.
 *
 * designId - Type: string.
 *
 * editMode - Type: string.
 *
 * esi - Type: guid.
 *
 * industryId - Type: string.
 *
 * instanceId - Type: string.
 *
 * msid - Type: guid.
 *
 * name - Type: string.
 *
 * origin - Type: string. Desc: how panel was opened {topbar, design panel}
 *
 * revision - Type: numeric.
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string.
 *
 * uuid - Type: guid.
 * @param {siteDesignCustomizeDesignSubPanelIsLoadedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteDesignCustomizeDesignSubPanelIsLoaded = function (params) {
    return { evid: 304, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} appsClickOnAscendBusinessToolsParams
* @property {string} adiBuilderType - med / desktop
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {GUID} msid - metasite id
* @property {string} origin - topbar - apps / topbar - manage apps
* @property {number} revision - builder version
* @property {string} screenResolution - -
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: apps - click on ascend business tools. Evid: 461.
 * Event description: Module: apps. Flow: user clicks on managing ascend business tools.

 * adiBuilderType - Type: string. Desc: med / desktop
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * origin - Type: string. Desc: topbar - apps / topbar - manage apps
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string. Desc: -
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {appsClickOnAscendBusinessToolsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appsClickOnAscendBusinessTools = function (params) {
    return { evid: 461, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} formEditorSetFieldAsDefaultParams
* @property {string} action - set / clear
* @property {string} adiBuilderType - -
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} fieldName - which field is updated: title,subtitle,body,image,button,link, list description
* @property {string} fieldType - text/ dropdown/ link / long text
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} nodeId - unique number per node, in case this is a list - this is the sectionNodeId
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - -
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: formEditor - set field as default. Evid: 483.
 * Event description: Module: contentEditor. Flow: user sets a field as defalut.

 * action - Type: string. Desc: set / clear
 *
 * adiBuilderType - Type: string. Desc: -
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * fieldName - Type: string. Desc: which field is updated: title,subtitle,body,image,button,link, list description
 *
 * fieldType - Type: string. Desc: text/ dropdown/ link / long text
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * nodeId - Type: string. Desc: unique number per node, in case this is a list - this is the sectionNodeId
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string. Desc: -
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {formEditorSetFieldAsDefaultParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var formEditorSetFieldAsDefault = function (params) {
    return { evid: 483, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} sectionDesignFontPanelOpenedParams
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: sectionDesign - Font panel opened. Evid: 553.
 * Event description: Module: sectionDesign. Flow: user opens section font panel.

 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {sectionDesignFontPanelOpenedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionDesignFontPanelOpened = function (params) {
    return { evid: 553, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} tourBubbleShownParams
* @property {string} adiBuilderType - -
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {GUID} msid - metasite id
* @property {string} name - card's name
* @property {number} notificationCount - smart assist notification count
* @property {number} revision - builder version
* @property {string} screenResolution - -
* @property {string} structureId - structure id
* @property {string} type - smart assist / tour
* @property {GUID} uuid - user id
**/
/**
 * Name: tour - Bubble shown (deprecated event). Evid: 44.
 * Event description: Module: tours: A new bubble notification popped.

 * adiBuilderType - Type: string. Desc: -
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * name - Type: string. Desc: card's name
 *
 * notificationCount - Type: numeric. Desc: smart assist notification count
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string. Desc: -
 *
 * structureId - Type: string. Desc: structure id
 *
 * type - Type: string. Desc: smart assist / tour
 *
 * uuid - Type: guid. Desc: user id
 * @param {tourBubbleShownParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tourBubbleShown = function (params) {
    return { evid: 44, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} sectionDesignChangeScrollAnimationSuccessParams
* @property {string} adiBuilderType - null
* @property {string} alias - label (name the user sees) of animation: none, parallax, reveal ...
* @property {string} designId - id of the design
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} loadTime - time in ms for changing animation
* @property {GUID} msid - metasite id
* @property {string} name - name of animation
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: sectionDesign - change scroll animation - success. Evid: 560.
 * Event description: Module: sectionDesign. Flow: user changes section scroll animation - success.

 * adiBuilderType - Type: string.
 *
 * alias - Type: string. Desc: label (name the user sees) of animation: none, parallax, reveal ...
 *
 * designId - Type: string. Desc: id of the design
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * loadTime - Type: numeric. Desc: time in ms for changing animation
 *
 * msid - Type: guid. Desc: metasite id
 *
 * name - Type: string. Desc: name of animation
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {sectionDesignChangeScrollAnimationSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionDesignChangeScrollAnimationSuccess = function (params) {
    return { evid: 560, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} tourBubbleCtaClickParams
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} name - card's name
* @property {number} notificationCount - smart assist notification count
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {string} type - smart assist / tour
* @property {GUID} uuid - user id
**/
/**
 * Name: tour - Bubble CTA click (deprecated event). Evid: 45.
 * Event description: Module: tours: A new bubble notification clicked.

 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * name - Type: string. Desc: card's name
 *
 * notificationCount - Type: numeric. Desc: smart assist notification count
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * type - Type: string. Desc: smart assist / tour
 *
 * uuid - Type: guid. Desc: user id
 * @param {tourBubbleCtaClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tourBubbleCtaClick = function (params) {
    return { evid: 45, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} loadingExistingSiteLoadCampaignLoadCampaignDataAsyncParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} intervalLoadTime - loading time diff from previous phase
* @property {number} loadTime - loading time till this phase
* @property {GUID} msid - metasite id
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: loading - existing site - Load Campaign: Load campaign data (async). Evid: 517.
 * Event description: Module: builder. Flow: phase in opening the builder (existing site) started..

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * intervalLoadTime - Type: numeric. Desc: loading time diff from previous phase
 *
 * loadTime - Type: numeric. Desc: loading time till this phase
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {loadingExistingSiteLoadCampaignLoadCampaignDataAsyncParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var loadingExistingSiteLoadCampaignLoadCampaignDataAsync = function (params) {
    return { evid: 517, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} loadingFirstTimeSendSiteSourcesSendSiteSourcesInfoToWixwizCompleteParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} intervalLoadTime - loading time diff from previous phase
* @property {number} loadTime - loading time till this phase
* @property {GUID} msid - metasite id
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: loading - first time - Send Site Sources: Send site sources info to wixwiz complete. Evid: 510.
 * Event description: Module: builder. Flow: phase in opening the builder (first time) completed..

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * intervalLoadTime - Type: numeric. Desc: loading time diff from previous phase
 *
 * loadTime - Type: numeric. Desc: loading time till this phase
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {loadingFirstTimeSendSiteSourcesSendSiteSourcesInfoToWixwizCompleteParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var loadingFirstTimeSendSiteSourcesSendSiteSourcesInfoToWixwizComplete = function (params) {
    return { evid: 510, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} pagesManagerPagesDropdownListOpenOnHoverParams
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: pagesManager - Pages dropdown list open on hover. Evid: 372.
 * Event description: Module: pagesManager. Flow: user hovers on the pages button and the pages dropdown list is open.

 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {pagesManagerPagesDropdownListOpenOnHoverParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pagesManagerPagesDropdownListOpenOnHover = function (params) {
    return { evid: 372, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} pagesManagerClickOnHideUnhidePageParams
* @property {string} action - hide/unhide
* @property {string} adiBuilderType - desktop/MED
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} pageId - number of page
* @property {string} pageName - page name
* @property {number} revision - builder version
* @property {string} screenResolution - user's device screen resolution
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: pagesManager - click on hide/unhide page. Evid: 374.
 * Event description: Module: pagesManager. Flow: user clicks on hide/unhide page in pages panel settings.

 * action - Type: string. Desc: hide/unhide
 *
 * adiBuilderType - Type: string. Desc: desktop/MED
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * pageId - Type: string. Desc: number of page
 *
 * pageName - Type: string. Desc: page name
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string. Desc: user's device screen resolution
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {pagesManagerClickOnHideUnhidePageParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pagesManagerClickOnHideUnhidePage = function (params) {
    return { evid: 374, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} siteDesignCustomizeDesignChangeColorationLevelClickParams
* @property {string} adiBuilderType - mobile, desktop
* @property {string} designId - id of the design
* @property {string} editMode - automatic / show me how / no-tour
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} name - plain,colorful,...
* @property {number} revision - builder version
* @property {string} screenResolution - screen resolution
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: siteDesign - Customize Design - change coloration level click. Evid: 335.
 * Event description: Module: siteDesign. Flow: user clicks chooses coloration level in site color panel.

 * adiBuilderType - Type: string. Desc: mobile, desktop
 *
 * designId - Type: string. Desc: id of the design
 *
 * editMode - Type: string. Desc: automatic / show me how / no-tour
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * name - Type: string. Desc: plain,colorful,...
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {siteDesignCustomizeDesignChangeColorationLevelClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteDesignCustomizeDesignChangeColorationLevelClick = function (params) {
    return { evid: 335, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} introTypeBusinessLocationPageNavigationClickParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} lod - level of details of the location (exact / street / neighbourhood / city / state / country/online-event )
* @property {string} mainCategory - the category from the 'vertical selector' category that the user chose
* @property {string} navButton - name of navigation button: next / skip / back / escape
* @property {string} nextView - name of next page: business type / services selection / business name / location / search confirm / search results / edit info card / builder / pro editor
* @property {string} screenResolution - null
* @property {string} text - input text
* @property {GUID} uuid - user id
**/
/**
 * Name: intro - Type business location page - navigation click. Evid: 107.
 * Event description: Module: intro. Flow: user clicks on a navigation button in the location page (4th page). .

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * lod - Type: string. Desc: level of details of the location (exact / street / neighbourhood / city / state / country/online-event )
 *
 * mainCategory - Type: string. Desc: the category from the 'vertical selector' category that the user chose
 *
 * navButton - Type: string. Desc: name of navigation button: next / skip / back / escape
 *
 * nextView - Type: string. Desc: name of next page: business type / services selection / business name / location / search confirm / search results / edit info card / builder / pro editor
 *
 * screenResolution - Type: string.
 *
 * text - Type: string. Desc: input text
 *
 * uuid - Type: guid. Desc: user id
 * @param {introTypeBusinessLocationPageNavigationClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var introTypeBusinessLocationPageNavigationClick = function (params) {
    return { evid: 107, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} introEventsTpaSchedulePageActionOnPageParams
* @property {string} actionName - click, choose, remove
* @property {string} adiBuilderType - mobile / desktop
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} mainCategory - the category from the 'vertical selector' category that the user chose
* @property {string} name - field/button name: start date, start time, end date, end time,time zone, add end time...
* @property {string} screenResolution - screen resolution
**/
/**
 * Name: intro - Events (TPA) schedule page - action on page. Evid: 120.
 * Event description: Module: intro. Flow: user makes changes on the Events (TPA) schedule page.

 * actionName - Type: string. Desc: click, choose, remove
 *
 * adiBuilderType - Type: string. Desc: mobile / desktop
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * mainCategory - Type: string. Desc: the category from the 'vertical selector' category that the user chose
 *
 * name - Type: string. Desc: field/button name: start date, start time, end date, end time,time zone, add end time...
 *
 * screenResolution - Type: string. Desc: screen resolution
 * @param {introEventsTpaSchedulePageActionOnPageParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var introEventsTpaSchedulePageActionOnPage = function (params) {
    return { evid: 120, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderSiteConverterSectionPresetPickerFailedParams
* @property {string} adiBuilderType - desktop / mobile
* @property {GUID} esi - editor session id, for every site editting session
* @property {number} index - section index in original json
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} loadTime - time elapsed from calculation start
* @property {GUID} msid - metasite id
* @property {number} presetsCalculated - number of presets calculated for this section
* @property {string} screenResolution - screen resolution
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - Site Converter - Section Preset Picker Failed. Evid: 5.
 * Event description: Module: builder. Flow: calculation of presets fit for section has completed unsuccessfully.

 * adiBuilderType - Type: string. Desc: desktop / mobile
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * index - Type: numeric. Desc: section index in original json
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * loadTime - Type: numeric. Desc: time elapsed from calculation start
 *
 * msid - Type: guid. Desc: metasite id
 *
 * presetsCalculated - Type: numeric. Desc: number of presets calculated for this section
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderSiteConverterSectionPresetPickerFailedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderSiteConverterSectionPresetPickerFailed = function (params) {
    return { evid: 5, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} introTextManagerSendRequestForASpecificPageStartParams
* @property {string} adiBuilderType - desktop / mobile / MED / headless
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {number} pageIndex - page number in the site
* @property {string} url - page url
* @property {string} screenResolution - screen resolution
* @property {string} structureId - structure id
* @property {number} totalPages - total number of pages to import
* @property {GUID} uuid - user id
**/
/**
 * Name: intro - Text Manager - send request for a specific page - start. Evid: 31.
 * Event description: Module: intro. Flow: a request for a page is sent.

 * adiBuilderType - Type: string. Desc: desktop / mobile / MED / headless
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * pageIndex - Type: numeric. Desc: page number in the site
 *
 * url - Type: string. Desc: page url
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * structureId - Type: string. Desc: structure id
 *
 * totalPages - Type: numeric. Desc: total number of pages to import
 *
 * uuid - Type: guid. Desc: user id
 * @param {introTextManagerSendRequestForASpecificPageStartParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var introTextManagerSendRequestForASpecificPageStart = function (params) {
    return { evid: 31, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderTopBarGiveFeedbackClickParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {number} revision - -
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - Top Bar - Give Feedback click. Evid: 178.
 * Event description: Module: builder. Flow: user clicks on Give Feedback.

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * revision - Type: numeric. Desc: -
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderTopBarGiveFeedbackClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderTopBarGiveFeedbackClick = function (params) {
    return { evid: 178, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} contentEditorImageCropCancelParams
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} nodeId - unique number per node, in case this is a list - this is the sectionNodeId
* @property {string} objectType - single / list / field
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: contentEditor - Image Crop - cancel. Evid: 211.
 * Event description: Module: contentEditor. Flow: user didn't use the crop function (clicked on done without doing a change or clicked on cancel). .

 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * nodeId - Type: string. Desc: unique number per node, in case this is a list - this is the sectionNodeId
 *
 * objectType - Type: string. Desc: single / list / field
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {contentEditorImageCropCancelParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var contentEditorImageCropCancel = function (params) {
    return { evid: 211, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} newContentIsShownAdiToEditorTestParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} selectedIndustryId - industry id
* @property {string} screenResolution - null
* @property {string} selectedStructureId - structure id
**/
/**
 * Name: New Content is shown - ADI to Editor Stores test. Evid: 81.
 * Event description: The new content for ADI to Editor test is shown..

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * selectedIndustryId - Type: string. Desc: industry id
 *
 * screenResolution - Type: string.
 *
 * selectedStructureId - Type: string. Desc: structure id
 * @param {newContentIsShownAdiToEditorTestParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var newContentIsShownAdiToEditorTest = function (params) {
    return { evid: 81, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} clientAutosaveSuccessParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id
* @property {GUID} instanceId - instance_id, represents the story/msid
* @property {number} loadTime - time elapsed (in ms) from start
* @property {GUID} msid - msid
* @property {number} revision - revision number of editor
* @property {string} screenResolution - null
* @property {GUID} uuid - null
**/
/**
 * Name: Client - autosave success. Evid: 174.
 * Event description: Module: server. Flow: site is saved automatically every fixed time (if the user has done some changes). .

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id
 *
 * instanceId - Type: guid. Desc: instance_id, represents the story/msid
 *
 * loadTime - Type: numeric. Desc: time elapsed (in ms) from start
 *
 * msid - Type: guid. Desc: msid
 *
 * revision - Type: numeric. Desc: revision number of editor
 *
 * screenResolution - Type: string.
 *
 * uuid - Type: guid.
 * @param {clientAutosaveSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var clientAutosaveSuccess = function (params) {
    return { evid: 174, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} mediaManagementMediaSettingsShowParams
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id
* @property {string} galleryType - single item/external video/ gallery organizer
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {string} mediaType - single image/image gallery/clipart/shape/bgVideo/extVideo
* @property {GUID} msid - metasite id
* @property {string} nodeId - unique number per node, in case this is a list - this is the sectionNodeId
* @property {string} origin - OSI / right click
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: mediaManagement - Media Settings - Show. Evid: 411.
 * Event description: Module: mediaManagement. Flow: user clicks on media settings and settings panel is loaded. Available for clipart, shape, single image, extVideo. .

 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id
 *
 * galleryType - Type: string. Desc: single item/external video/ gallery organizer
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * mediaType - Type: string. Desc: single image/image gallery/clipart/shape/bgVideo/extVideo
 *
 * msid - Type: guid. Desc: metasite id
 *
 * nodeId - Type: string. Desc: unique number per node, in case this is a list - this is the sectionNodeId
 *
 * origin - Type: string. Desc: OSI / right click
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {mediaManagementMediaSettingsShowParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var mediaManagementMediaSettingsShow = function (params) {
    return { evid: 411, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderBusinessInfoUpdateChangesParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} fieldsUpdated - list of fields that were updated divided by commas: name,logo,email,address,phone,fax,social-facebook,social-twitter,social-linkedin ..
* @property {string} fieldsAdded - list of fields that were added divided by commas: name,logo,email,address,phone,fax,social-facebook,social-twitter,social-linkedin ..
* @property {string} fieldsRemoved - list of fields that were removed divided by commas: name,logo,email,address,phone,fax,social-facebook,social-twitter,social-linkedin ..
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - Business Info - Update changes. Evid: 145.
 * Event description: Module: builder. Flow: user approves changes in the business info page..

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * fieldsUpdated - Type: string. Desc: list of fields that were updated divided by commas: name,logo,email,address,phone,fax,social-facebook,social-twitter,social-linkedin ..
 *
 * fieldsAdded - Type: string. Desc: list of fields that were added divided by commas: name,logo,email,address,phone,fax,social-facebook,social-twitter,social-linkedin ..
 *
 * fieldsRemoved - Type: string. Desc: list of fields that were removed divided by commas: name,logo,email,address,phone,fax,social-facebook,social-twitter,social-linkedin ..
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderBusinessInfoUpdateChangesParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderBusinessInfoUpdateChanges = function (params) {
    return { evid: 145, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} siteDesignClickOnResetDesignParams
* @property {string} adiBuilderType - null
* @property {string} designId - id of the design
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {boolean} isAdvanced - Is reset clicked from advanced editing mode or from main panel{True if clicked from advanced}
* @property {GUID} msid - metasite id
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: siteDesign - Click on Reset Design. Evid: 307.
 * Event description: Module: siteDesign. Flow: user clicks on reset..

 * adiBuilderType - Type: string.
 *
 * designId - Type: string. Desc: id of the design
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * isAdvanced - Type: bool. Desc: Is reset clicked from advanced editing mode or from main panel{True if clicked from advanced}
 *
 * msid - Type: guid. Desc: metasite id
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {siteDesignClickOnResetDesignParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteDesignClickOnResetDesign = function (params) {
    return { evid: 307, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderPagePresetPreviewStartsLoadingParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} intervalLoadTime - **deprecated**
* @property {number} loadTime - **deprecated**
* @property {string} mode - builder/welcome tour
* @property {GUID} msid - metasite id
* @property {string} origin - fake browser / top bar
* @property {number} pageNumber - page number of fpd layouts
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
* @property {string} view - Select a Layout / Choose Your Colors
**/
/**
 * Name: builder - full page design starts loading. Evid: 21.
 * Event description: Module: builder. Flow: page preset preview starts loading after silent builder.

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * intervalLoadTime - Type: numeric. Desc: **deprecated**
 *
 * loadTime - Type: numeric. Desc: **deprecated**
 *
 * mode - Type: string. Desc: builder/welcome tour
 *
 * msid - Type: guid. Desc: metasite id
 *
 * origin - Type: string. Desc: fake browser / top bar
 *
 * pageNumber - Type: numeric. Desc: page number of fpd layouts
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 *
 * view - Type: string. Desc: Select a Layout / Choose Your Colors
 * @param {builderPagePresetPreviewStartsLoadingParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderPagePresetPreviewStartsLoading = function (params) {
    return { evid: 21, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderCoreLoadingLoadLayoutSolverCompleteParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} intervalLoadTime - loading time diff from previous phase
* @property {number} loadTime - loading time till this phase
* @property {GUID} msid - metasite id
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - core loading - load layout solver complete. Evid: 19.
 * Event description: Module: builder. Flow: phase in loading the core.

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * intervalLoadTime - Type: numeric. Desc: loading time diff from previous phase
 *
 * loadTime - Type: numeric. Desc: loading time till this phase
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderCoreLoadingLoadLayoutSolverCompleteParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderCoreLoadingLoadLayoutSolverComplete = function (params) {
    return { evid: 19, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} contentEditorRichTextClickParams
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {number} fieldLength - length of text in the field
* @property {string} fieldName - which field is updated: title,subtitle,body,image,button,link, list description
* @property {string} fieldType - text/ dropdown/ link / long text
* @property {string} fieldValue - value selected - only for dropdown fields / empty when user clears field
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} nodeId - unique number per node, in case this is a list - this is the sectionNodeId
* @property {string} origin - stage / panel
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} richTextMode - on/off
* @property {string} richTextType - {Bold,Italic,Underline,Numbers,Bullets,Link,ClearFormating}
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: contentEditor - rich text click. Evid: 232.
 * Event description: Module: contentEditor. Flow: user clicks on rich text.

 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * fieldLength - Type: numeric. Desc: length of text in the field
 *
 * fieldName - Type: string. Desc: which field is updated: title,subtitle,body,image,button,link, list description
 *
 * fieldType - Type: string. Desc: text/ dropdown/ link / long text
 *
 * fieldValue - Type: string. Desc: value selected - only for dropdown fields / empty when user clears field
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * nodeId - Type: string. Desc: unique number per node, in case this is a list - this is the sectionNodeId
 *
 * origin - Type: string. Desc: stage / panel
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * richTextMode - Type: string. Desc: on/off
 *
 * richTextType - Type: string. Desc: {Bold,Italic,Underline,Numbers,Bullets,Link,ClearFormating}
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {contentEditorRichTextClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var contentEditorRichTextClick = function (params) {
    return { evid: 232, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} medBuilderAddSectionsStartParams
* @property {string} adiBuilderType - MED
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {number} numOfSections - number of pages
* @property {number} revision - builder version
* @property {string} screenResolution - screen resolution
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: MED - Builder - Add Sections Start. Evid: 824.
 * Event description: Module: MED. Flow: user clicks done on add sections panel.

 * adiBuilderType - Type: string. Desc: MED
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * numOfSections - Type: numeric. Desc: number of pages
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {medBuilderAddSectionsStartParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var medBuilderAddSectionsStart = function (params) {
    return { evid: 824, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} loadingExistingSiteWizardServiceInitBFinializeCoreInitParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} intervalLoadTime - loading time diff from previous phase
* @property {number} loadTime - loading time till this phase
* @property {GUID} msid - metasite id
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: loading - existing site - WizardService init B: Finialize core init. Evid: 516.
 * Event description: Module: builder. Flow: phase in opening the builder (existing site) started. (waits for document services init).

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * intervalLoadTime - Type: numeric. Desc: loading time diff from previous phase
 *
 * loadTime - Type: numeric. Desc: loading time till this phase
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {loadingExistingSiteWizardServiceInitBFinializeCoreInitParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var loadingExistingSiteWizardServiceInitBFinializeCoreInit = function (params) {
    return { evid: 516, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} contentEditorImageResolutionImproveDialogIsLoadedParams
* @property {string} adiBuilderType - desktop / MED / ...
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} nodeId - unique number per node, in case this is a list - this is the sectionNodeId
* @property {string} originalImageUrl - original image url
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - screen resolution
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: contentEditor - Image Resolution Improve dialog is loaded. Evid: 420.
 * Event description: Module: contentEditor. Flow: user opens the Image Resolution Improve dialog when the image resolution is low.

 * adiBuilderType - Type: string. Desc: desktop / MED / ...
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * nodeId - Type: string. Desc: unique number per node, in case this is a list - this is the sectionNodeId
 *
 * originalImageUrl - Type: string. Desc: original image url
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {contentEditorImageResolutionImproveDialogIsLoadedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var contentEditorImageResolutionImproveDialogIsLoaded = function (params) {
    return { evid: 420, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} loadingFirstTimeCreateStorySetMainKitParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} intervalLoadTime - loading time diff from previous phase
* @property {number} loadTime - loading time till this phase
* @property {GUID} msid - metasite id
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: loading - first time - CreateStory: Set main kit. Evid: 501.
 * Event description: Module: builder. Flow: phase in opening the builder (first time) started.

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * intervalLoadTime - Type: numeric. Desc: loading time diff from previous phase
 *
 * loadTime - Type: numeric. Desc: loading time till this phase
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {loadingFirstTimeCreateStorySetMainKitParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var loadingFirstTimeCreateStorySetMainKit = function (params) {
    return { evid: 501, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderSiteConverterSectionPresetPickerStartParams
* @property {string} adiBuilderType - desktop / mobile
* @property {GUID} esi - editor session id, for every site editting session
* @property {number} index - section index in original json
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} screenResolution - screen resolution
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - Site Converter - Section Preset Picker Start. Evid: 3.
 * Event description: Module: builder. Flow: calculation of presets fit for section has started.

 * adiBuilderType - Type: string. Desc: desktop / mobile
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * index - Type: numeric. Desc: section index in original json
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderSiteConverterSectionPresetPickerStartParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderSiteConverterSectionPresetPickerStart = function (params) {
    return { evid: 3, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} medBuilderRichTextUiClickParams
* @property {string} action - Rich Text action (bold, italic, ...)
* @property {string} adiBuilderType - MED
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} fieldType - title / description...
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {number} revision - builder version
* @property {string} screenResolution - screen resolution
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} selectedLayout - layout id
* @property {string} structureId - structure id
* @property {string} type - single / list/ item
**/
/**
 * Name: MED - Builder - Rich Text UI Click. Evid: 831.
 * Event description: Module: MED. Flow: when user makes any rich text interaction. this interaction doesn't assure that the changes will be eventually made (the user has to click 'done' at the end to save changes).

 * action - Type: string. Desc: Rich Text action (bold, italic, ...)
 *
 * adiBuilderType - Type: string. Desc: MED
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * fieldType - Type: string. Desc: title / description...
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * selectedLayout - Type: string. Desc: layout id
 *
 * structureId - Type: string. Desc: structure id
 *
 * type - Type: string. Desc: single / list/ item
 * @param {medBuilderRichTextUiClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var medBuilderRichTextUiClick = function (params) {
    return { evid: 831, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} loadingFirstTimeCreateStoryWizardServiceInitAParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} intervalLoadTime - loading time diff from previous phase
* @property {number} loadTime - loading time till this phase
* @property {GUID} msid - metasite id
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: loading - first time - CreateStory: WizardService init A. Evid: 128.
 * Event description: Module: builder. Flow: phase in opening the builder (first time) started..

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * intervalLoadTime - Type: numeric. Desc: loading time diff from previous phase
 *
 * loadTime - Type: numeric. Desc: loading time till this phase
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {loadingFirstTimeCreateStoryWizardServiceInitAParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var loadingFirstTimeCreateStoryWizardServiceInitA = function (params) {
    return { evid: 128, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} contentEditorSwitchListItemToPageParams
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} nodeId - unique number per node, in case this is a list - this is the sectionNodeId
* @property {string} originPageId - originPageId and pageId will be ewual in this phase since the target is not known
* @property {string} pageId - number of ORIGIN page
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: contentEditor - Switch List item to Page. Evid: 219.
 * Event description: Module: contentEditor. Flow: user moves an item to a page. .

 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * nodeId - Type: string. Desc: unique number per node, in case this is a list - this is the sectionNodeId
 *
 * originPageId - Type: string. Desc: originPageId and pageId will be ewual in this phase since the target is not known
 *
 * pageId - Type: string. Desc: number of ORIGIN page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {contentEditorSwitchListItemToPageParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var contentEditorSwitchListItemToPage = function (params) {
    return { evid: 219, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderGoToEditorClickParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} origin - topbar, floating button
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - Go to Editor click. Evid: 155.
 * Event description: Module: builder. Flow: user clicks on go to editor from topbar or on floating button..

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * origin - Type: string. Desc: topbar, floating button
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderGoToEditorClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderGoToEditorClick = function (params) {
    return { evid: 155, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderCsArticleSearchApiResponseParams
* @property {string} adiBuilderType - ADI builder type
* @property {string} articles - array of returned articles
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {number} revision - revision
* @property {string} screenResolution - screen_resolution
* @property {string} structureId - structure id
* @property {string} text - searched text
* @property {string} tours - array of returned tours
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - CS article search API response. Evid: 71.
 * Event description: Module: builder. Flow: CS article search API returned an answer.

 * adiBuilderType - Type: string. Desc: ADI builder type
 *
 * articles - Type: string. Desc: array of returned articles
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * revision - Type: numeric. Desc: revision
 *
 * screenResolution - Type: string. Desc: screen_resolution
 *
 * structureId - Type: string. Desc: structure id
 *
 * text - Type: string. Desc: searched text
 *
 * tours - Type: string. Desc: array of returned tours
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderCsArticleSearchApiResponseParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderCsArticleSearchApiResponse = function (params) {
    return { evid: 71, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} medIntroGetStartedClickParams
* @property {string} adiBuilderType - MED
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} screenResolution - screen resolution
* @property {GUID} uuid - user id
**/
/**
 * Name: MED - intro - get started click. Evid: 890.
 * Event description: Module: MED. Flow: user clicks on get started (1st page).

 * adiBuilderType - Type: string. Desc: MED
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * uuid - Type: guid. Desc: user id
 * @param {medIntroGetStartedClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var medIntroGetStartedClick = function (params) {
    return { evid: 890, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} medBuilderBuilderReadyParams
* @property {string} adiBuilderType - MED
* @property {GUID} esi - editor session id, for every site editting session
* @property {number} fullLoadTime - Full loading time diff from start loading for MED
* @property {string} industryId - industry id
* @property {number} loadTime - loading time diff from start loading
* @property {GUID} msid - metasite id
* @property {number} revision - -
* @property {string} screenResolution - screen_resolution
* @property {string} structureId - structure id
* @property {string} type - new / existing
* @property {GUID} uuid - user id
**/
/**
 * Name: MED - Builder - builder ready. Evid: 836.
 * Event description: Module: MED. Flow: builder is open and ready to work on.

 * adiBuilderType - Type: string. Desc: MED
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * fullLoadTime - Type: numeric. Desc: Full loading time diff from start loading for MED
 *
 * industryId - Type: string. Desc: industry id
 *
 * loadTime - Type: numeric. Desc: loading time diff from start loading
 *
 * msid - Type: guid. Desc: metasite id
 *
 * revision - Type: numeric. Desc: -
 *
 * screenResolution - Type: string. Desc: screen_resolution
 *
 * structureId - Type: string. Desc: structure id
 *
 * type - Type: string. Desc: new / existing
 *
 * uuid - Type: guid. Desc: user id
 * @param {medBuilderBuilderReadyParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var medBuilderBuilderReady = function (params) {
    return { evid: 836, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderCoreLoadingWizardServiceSetStoryStylesParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} intervalLoadTime - loading time diff from previous phase
* @property {number} loadTime - loading time till this phase
* @property {string} loadType - new site / existing site
* @property {GUID} msid - metasite id
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - core loading - wizard service - set story styles. Evid: 17.
 * Event description: Module: builder. Flow: phase in loading the core.

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * intervalLoadTime - Type: numeric. Desc: loading time diff from previous phase
 *
 * loadTime - Type: numeric. Desc: loading time till this phase
 *
 * loadType - Type: string. Desc: new site / existing site
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderCoreLoadingWizardServiceSetStoryStylesParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderCoreLoadingWizardServiceSetStoryStyles = function (params) {
    return { evid: 17, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} loadingFirstTimeInitDataSaveDsIfTpaSaveLocalOtherwiseParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} intervalLoadTime - loading time diff from previous phase
* @property {number} loadTime - loading time till this phase
* @property {GUID} msid - metasite id
* @property {string} saveType - DS/ADI
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: loading - first time - Init Data: Save DS (if tpa) | Save Local (otherwise). Evid: 133.
 * Event description: Module: builder. Flow: phase  in opening the builder (first time) started..

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * intervalLoadTime - Type: numeric. Desc: loading time diff from previous phase
 *
 * loadTime - Type: numeric. Desc: loading time till this phase
 *
 * msid - Type: guid. Desc: metasite id
 *
 * saveType - Type: string. Desc: DS/ADI
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {loadingFirstTimeInitDataSaveDsIfTpaSaveLocalOtherwiseParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var loadingFirstTimeInitDataSaveDsIfTpaSaveLocalOtherwise = function (params) {
    return { evid: 133, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} contentEditorImageResolutionImproveToggleClickParams
* @property {string} action - on / off
* @property {string} adiBuilderType - desktop / MED / ...
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} nodeId - unique number per node, in case this is a list - this is the sectionNodeId
* @property {string} originalImageSize - w X h
* @property {string} originalImageUrl - url of the image uploaded by the user
* @property {string} pageId - number of page
* @property {string} placeholderSize - w X h
* @property {number} revision - builder version
* @property {string} screenResolution - screen resolution
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: contentEditor - Image Resolution Improve toggle click. Evid: 423.
 * Event description: Module: contentEditor. Flow: user clicks the toggle that improves / reset the image quality.

 * action - Type: string. Desc: on / off
 *
 * adiBuilderType - Type: string. Desc: desktop / MED / ...
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * nodeId - Type: string. Desc: unique number per node, in case this is a list - this is the sectionNodeId
 *
 * originalImageSize - Type: string. Desc: w X h
 *
 * originalImageUrl - Type: string. Desc: url of the image uploaded by the user
 *
 * pageId - Type: string. Desc: number of page
 *
 * placeholderSize - Type: string. Desc: w X h
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {contentEditorImageResolutionImproveToggleClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var contentEditorImageResolutionImproveToggleClick = function (params) {
    return { evid: 423, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} contentEditorChangeImageOpacityParams
* @property {string} adiBuilderType - desktop / mobile / MED / headless
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {boolean} isReset - true if opacity was reset
* @property {GUID} msid - metasite id
* @property {string} nodeId - unique number per node, in case this is a list - this is the sectionNodeId
* @property {number} opacity - image opacity
* @property {string} origin - OSI /right click / panel
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - screen_resolution
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: contentEditor - Change Image Opacity. Evid: 247.
 * Event description: Module: contentEditor. Flow: user changes image opacity in the media settings panel.

 * adiBuilderType - Type: string. Desc: desktop / mobile / MED / headless
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * isReset - Type: bool. Desc: true if opacity was reset
 *
 * msid - Type: guid. Desc: metasite id
 *
 * nodeId - Type: string. Desc: unique number per node, in case this is a list - this is the sectionNodeId
 *
 * opacity - Type: numeric. Desc: image opacity
 *
 * origin - Type: string. Desc: OSI /right click / panel
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string. Desc: screen_resolution
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {contentEditorChangeImageOpacityParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var contentEditorChangeImageOpacity = function (params) {
    return { evid: 247, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} siteDesignCustomizeDesignOpenColorSubPanelParams
* @property {string} adiBuilderType - null
* @property {string} designId - null
* @property {string} editMode - null
* @property {GUID} esi - null
* @property {string} industryId - null
* @property {string} instanceId - null
* @property {GUID} msid - null
* @property {string} origin - how panel was opened {topbar, design panel}
* @property {number} revision - null
* @property {string} screenResolution - null
* @property {string} structureId - null
* @property {GUID} uuid - null
**/
/**
 * Name: siteDesign - Customize Design - open color sub panel. Evid: 310.
 * Event description: Module: siteDesign. Flow: user opens the color palette settings.

 * adiBuilderType - Type: string.
 *
 * designId - Type: string.
 *
 * editMode - Type: string.
 *
 * esi - Type: guid.
 *
 * industryId - Type: string.
 *
 * instanceId - Type: string.
 *
 * msid - Type: guid.
 *
 * origin - Type: string. Desc: how panel was opened {topbar, design panel}
 *
 * revision - Type: numeric.
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string.
 *
 * uuid - Type: guid.
 * @param {siteDesignCustomizeDesignOpenColorSubPanelParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteDesignCustomizeDesignOpenColorSubPanel = function (params) {
    return { evid: 310, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderSuggestedDomainIsDisplayedParams
* @property {string} adiBuilderType - ADI builder type
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {number} revision - revision
* @property {string} screenResolution - screen_resolution
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - suggested domain is displayed. Evid: 37.
 * Event description: Module: builder. Flow: a suggested domain is displayed in fakebrowser.

 * adiBuilderType - Type: string. Desc: ADI builder type
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * revision - Type: numeric. Desc: revision
 *
 * screenResolution - Type: string. Desc: screen_resolution
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderSuggestedDomainIsDisplayedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderSuggestedDomainIsDisplayed = function (params) {
    return { evid: 37, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderAddPagesScreenStartsLoadingParams
* @property {string} adiBuilderType - desktop/MED
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {number} pageCount - count of pages suggested
* @property {string} screenResolution - user device screen resolution
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: tour - welcome tour - Add pages - page starts loading. Evid: 79.
 * Event description: Module: tour. Flow: add pages screen is starts loading in welcome tour.

 * adiBuilderType - Type: string. Desc: desktop/MED
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * pageCount - Type: numeric. Desc: count of pages suggested
 *
 * screenResolution - Type: string. Desc: user device screen resolution
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderAddPagesScreenStartsLoadingParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderAddPagesScreenStartsLoading = function (params) {
    return { evid: 79, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} introImageImportConfirmLegalPageNavigationClickParams
* @property {string} adiBuilderType - desktop / MED...
* @property {string} chosenOption - facebook, google, mysite,...
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry
* @property {string} mainCategory - the category from the 'vertical selector' category that the user chose
* @property {string} navButton - next,back,review images
* @property {string} numOfChosen - facebook=3,mysite=5,google=0….
* @property {string} numOfSuggested - facebook=10,mysite=12,google=15….
* @property {string} screenResolution - -
* @property {string} structureId - structure
**/
/**
 * Name: intro -  image import confirm legal page - navigation click. Evid: 97.
 * Event description: Module: intro. Flow: user clicks on a navigation button on the image import confirmation page (legal page).

 * adiBuilderType - Type: string. Desc: desktop / MED...
 *
 * chosenOption - Type: string. Desc: facebook, google, mysite,...
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry
 *
 * mainCategory - Type: string. Desc: the category from the 'vertical selector' category that the user chose
 *
 * navButton - Type: string. Desc: next,back,review images
 *
 * numOfChosen - Type: string. Desc: facebook=3,mysite=5,google=0….
 *
 * numOfSuggested - Type: string. Desc: facebook=10,mysite=12,google=15….
 *
 * screenResolution - Type: string. Desc: -
 *
 * structureId - Type: string. Desc: structure
 * @param {introImageImportConfirmLegalPageNavigationClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var introImageImportConfirmLegalPageNavigationClick = function (params) {
    return { evid: 97, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderBusinessInfoClosePageParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - Business Info - Close page. Evid: 147.
 * Event description: Module: builder. Flow: user closes the business info page (x/cancel). .

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderBusinessInfoClosePageParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderBusinessInfoClosePage = function (params) {
    return { evid: 147, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} sectionDesignAnimationPanelOpenedParams
* @property {string} adiBuilderType - null
* @property {string} animationType - e.g: slideshow
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: sectionDesign - Animation panel opened. Evid: 556.
 * Event description: Module: sectionDesign. Flow: user opens section animation panel.

 * adiBuilderType - Type: string.
 *
 * animationType - Type: string. Desc: e.g: slideshow
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {sectionDesignAnimationPanelOpenedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionDesignAnimationPanelOpened = function (params) {
    return { evid: 556, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderBrowserWindowFocusParams
* @property {string} actionName - suspend, activate
* @property {string} adiBuilderType - adi_builder_type
* @property {GUID} esi - esi
* @property {string} industryId - site industry id
* @property {GUID} msid - metasite id
* @property {string} screenResolution - screen_resolution
* @property {string} structureId - site structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - browser window focus. Evid: 3997.
 * Event description: Sent: When the user moves to another tab ("suspend") When the user comes back the tab of the ADI ("activate") - only for adi2editor users during preloader (only desktop builder).

 * actionName - Type: string. Desc: suspend, activate
 *
 * adiBuilderType - Type: string. Desc: adi_builder_type
 *
 * esi - Type: guid. Desc: esi
 *
 * industryId - Type: string. Desc: site industry id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string. Desc: screen_resolution
 *
 * structureId - Type: string. Desc: site structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderBrowserWindowFocusParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderBrowserWindowFocus = function (params) {
    return { evid: 3997, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} dataFixerCompleteParams
* @property {string} additionalData - extra data we have on data fixer
* @property {string} adiBuilderType - -
* @property {string} dataFixerSteps - The data fixer's steps
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {number} loadTime - data fixer load time in ms
* @property {GUID} msid - metasite id
* @property {string} name - data fixer name
* @property {string} screenResolution - -
* @property {string} status - success / failure
* @property {string} structureId - structure id
**/
/**
 * Name: data fixer - complete. Evid: 9.
 * Event description: Module: builder. Flow: a data fixer complete.

 * additionalData - Type: string. Desc: extra data we have on data fixer
 *
 * adiBuilderType - Type: string. Desc: -
 *
 * dataFixerSteps - Type: string. Desc: The data fixer's steps
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * loadTime - Type: numeric. Desc: data fixer load time in ms
 *
 * msid - Type: guid. Desc: metasite id
 *
 * name - Type: string. Desc: data fixer name
 *
 * screenResolution - Type: string. Desc: -
 *
 * status - Type: string. Desc: success / failure
 *
 * structureId - Type: string. Desc: structure id
 * @param {dataFixerCompleteParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dataFixerComplete = function (params) {
    return { evid: 9, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} siteDesignCustomizeDesignOverrideSectionDesignClickApplyParams
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} name - font / element animation / scroll animation
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: siteDesign - Customize Design - override section design - click apply. Evid: 331.
 * Event description: Module: siteDesign. Flow: user changes site design and has already set a section with a different animation/font. user clicks on apply the new animation/font to all sections.

 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * name - Type: string. Desc: font / element animation / scroll animation
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {siteDesignCustomizeDesignOverrideSectionDesignClickApplyParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteDesignCustomizeDesignOverrideSectionDesignClickApply = function (params) {
    return { evid: 331, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} medBuilderWarmupRequestTryParams
* @property {string} adiBuilderType - MED
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} revision - saved revision
* @property {string} screenResolution - screen resolution
* @property {string} structureId - structure id
**/
/**
 * Name: MED - Builder - Warmup Request Try. Evid: 832.
 * Event description: Module: MED. Flow: Builder sends a warmup request.

 * adiBuilderType - Type: string. Desc: MED
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * revision - Type: numeric. Desc: saved revision
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * structureId - Type: string. Desc: structure id
 * @param {medBuilderWarmupRequestTryParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var medBuilderWarmupRequestTry = function (params) {
    return { evid: 832, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} introPageViewParams
* @property {string} adiBuilderType - null
* @property {string} contentLanguage - Content Language - which supported on ADI
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} flow - applies for category search page: main funnel/adi intro
* @property {string} industryId - industry id that was chosen on the category page
* @property {boolean} isFake - true if sent fake (when intro starts from tpa page)
* @property {string} mainCategory - the category from the 'vertical selector' category that the user chose
* @property {number} noOfMatches - for search results page: number of results that were found (overall)
* @property {string} origin - the previous page (e.g. 'intro.business-category')
* @property {string} referral - for business type page: split page / new site in adi site menu/siteless
* @property {string} screenResolution - null
* @property {GUID} searchGuid - for search results page: every search a new guid is generated by wixwiz server
* @property {string} structureId - structure id that was chosen on the category page
* @property {string} tpas - the TPAs which this page is relevant to
* @property {GUID} uuid - user id
* @property {string} view - name of page: business type / services selection / business name / location / search confirm / search results / edit info card
**/
/**
 * Name: intro - page view. Evid: 100.
 * Event description: Module: intro. Flow: intro page view - all pages in the intro. .

 * adiBuilderType - Type: string.
 *
 * contentLanguage - Type: string. Desc: Content Language - which supported on ADI
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * flow - Type: string. Desc: applies for category search page: main funnel/adi intro
 *
 * industryId - Type: string. Desc: industry id that was chosen on the category page
 *
 * isFake - Type: bool. Desc: true if sent fake (when intro starts from tpa page)
 *
 * mainCategory - Type: string. Desc: the category from the 'vertical selector' category that the user chose
 *
 * noOfMatches - Type: numeric. Desc: for search results page: number of results that were found (overall)
 *
 * origin - Type: string. Desc: the previous page (e.g. 'intro.business-category')
 *
 * referral - Type: string. Desc: for business type page: split page / new site in adi site menu/siteless
 *
 * screenResolution - Type: string.
 *
 * searchGuid - Type: guid. Desc: for search results page: every search a new guid is generated by wixwiz server
 *
 * structureId - Type: string. Desc: structure id that was chosen on the category page
 *
 * tpas - Type: string. Desc: the TPAs which this page is relevant to
 *
 * uuid - Type: guid. Desc: user id
 *
 * view - Type: string. Desc: name of page: business type / services selection / business name / location / search confirm / search results / edit info card
 * @param {introPageViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var introPageView = function (params) {
    return { evid: 100, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} appsManageDropdownListOpenOnHoverParams
* @property {string} adiBuilderType - desktop / mobile
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {string} labelName - in case of topbar -  send the button's label (text)
* @property {GUID} msid - metasite id
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - screen resolution
* @property {string} structureId - structure id
**/
/**
 * Name: apps - manage dropdown list open on hover. Evid: 459.
 * Event description: Module: apps. Flow: user hovers (for 2 seconds) on the manage button and the dropdown list is open.

 * adiBuilderType - Type: string. Desc: desktop / mobile
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * labelName - Type: string. Desc: in case of topbar -  send the button's label (text)
 *
 * msid - Type: guid. Desc: metasite id
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * structureId - Type: string. Desc: structure id
 * @param {appsManageDropdownListOpenOnHoverParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appsManageDropdownListOpenOnHover = function (params) {
    return { evid: 459, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} siteDesignCustomizeDesignChangeColorationLevelSuccessParams
* @property {string} adiBuilderType - mobile, desktop
* @property {string} designId - id of the design
* @property {string} editMode - automatic / show me how / no-tour
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} loadTime - loading time between click to success
* @property {GUID} msid - metasite id
* @property {string} name - plain,colorful,...
* @property {number} revision - builder version
* @property {string} screenResolution - screen resolution
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: siteDesign - Customize Design - change coloration level success. Evid: 336.
 * Event description: Module: siteDesign. Flow: user clicks chooses coloration level in site color panel.

 * adiBuilderType - Type: string. Desc: mobile, desktop
 *
 * designId - Type: string. Desc: id of the design
 *
 * editMode - Type: string. Desc: automatic / show me how / no-tour
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * loadTime - Type: numeric. Desc: loading time between click to success
 *
 * msid - Type: guid. Desc: metasite id
 *
 * name - Type: string. Desc: plain,colorful,...
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {siteDesignCustomizeDesignChangeColorationLevelSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteDesignCustomizeDesignChangeColorationLevelSuccess = function (params) {
    return { evid: 336, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderPublishSiteCongratsPageClickOnDoneButtonParams
* @property {string} adiBuilderType - --
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} pageView - all options {onboarding-1publish-congrats,onboarding-2publish-congrats,premium}
* @property {string} screenResolution - --
* @property {boolean} showNextTime - {True if marked, else false)
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - Publish Site - Congrats page - click on done button. Evid: 186.
 * Event description: Module: builder. Flow: post publish congrats page view - click on done.

 * adiBuilderType - Type: string. Desc: --
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * pageView - Type: string. Desc: all options {onboarding-1publish-congrats,onboarding-2publish-congrats,premium}
 *
 * screenResolution - Type: string. Desc: --
 *
 * showNextTime - Type: bool. Desc: {True if marked, else false)
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderPublishSiteCongratsPageClickOnDoneButtonParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderPublishSiteCongratsPageClickOnDoneButton = function (params) {
    return { evid: 186, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} pagesManagerAddPagePanelIsLoadedParams
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} origin - top bar / menu link panel
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: pagesManager - Add Page panel is loaded. Evid: 351.
 * Event description: Module: pagesManager. Flow: user clicks on add page button and add page panel is loaded. .

 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * origin - Type: string. Desc: top bar / menu link panel
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {pagesManagerAddPagePanelIsLoadedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pagesManagerAddPagePanelIsLoaded = function (params) {
    return { evid: 351, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} sectionDesignShowHideListHeaderBackgroundSuccessParams
* @property {string} action - hide/show
* @property {string} adiBuilderType - null
* @property {string} designId - id of the design
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} loadTime - time to change background
* @property {GUID} msid - metasite id
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: sectionDesign - show/hide list header background - success. Evid: 565.
 * Event description: Module: sectionDesign. Flow: user toggles list section header background - success.

 * action - Type: string. Desc: hide/show
 *
 * adiBuilderType - Type: string.
 *
 * designId - Type: string. Desc: id of the design
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * loadTime - Type: numeric. Desc: time to change background
 *
 * msid - Type: guid. Desc: metasite id
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {sectionDesignShowHideListHeaderBackgroundSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionDesignShowHideListHeaderBackgroundSuccess = function (params) {
    return { evid: 565, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} formEditorClickOnAddDuplicateFormFieldValuesSuccessParams
* @property {string} addType - new / duplicated
* @property {string} adiBuilderType - MED / desktop / headless
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} fieldName - name
* @property {string} fieldValue - value added
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} nodeId - unique number per node, in case this is a list - this is the sectionNodeId
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - -
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: formEditor - Click on Add/duplicate form field values - success. Evid: 485.
 * Event description: Module: contentEditor. Flow: user adds/duplicates items to the form field values.

 * addType - Type: string. Desc: new / duplicated
 *
 * adiBuilderType - Type: string. Desc: MED / desktop / headless
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * fieldName - Type: string. Desc: name
 *
 * fieldValue - Type: string. Desc: value added
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * nodeId - Type: string. Desc: unique number per node, in case this is a list - this is the sectionNodeId
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string. Desc: -
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {formEditorClickOnAddDuplicateFormFieldValuesSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var formEditorClickOnAddDuplicateFormFieldValuesSuccess = function (params) {
    return { evid: 485, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} introEventsTpaSchedulePageNavigationClickParams
* @property {string} adiBuilderType - mobile / desktop
* @property {string} endValueExists - true if user chose end date / time
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} mainCategory - the category from the 'vertical selector' category that the user chose
* @property {string} navButton - name of navigation button: next / skip / back / escape
* @property {string} nextView - name of next page
* @property {string} screenResolution - screen resolution
* @property {string} startValueExists - true if user chose start date / time
**/
/**
 * Name: intro - Events (TPA) schedule page - navigation click. Evid: 119.
 * Event description: Module: intro. Flow: user clicks on a navigation button on the Event schedule page (relevant for Events TPA categories only)..

 * adiBuilderType - Type: string. Desc: mobile / desktop
 *
 * endValueExists - Type: string. Desc: true if user chose end date / time
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * mainCategory - Type: string. Desc: the category from the 'vertical selector' category that the user chose
 *
 * navButton - Type: string. Desc: name of navigation button: next / skip / back / escape
 *
 * nextView - Type: string. Desc: name of next page
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * startValueExists - Type: string. Desc: true if user chose start date / time
 * @param {introEventsTpaSchedulePageNavigationClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var introEventsTpaSchedulePageNavigationClick = function (params) {
    return { evid: 119, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} upgradeBannerIsDisplayedParams
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} name - name of banner e.g upgrade-default, upgrade-sale
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: upgrade Banner is displayed. Evid: 61.
 * Event description: Module: dialogs. Flow: A banner is displayed in the builder.

 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * name - Type: string. Desc: name of banner e.g upgrade-default, upgrade-sale
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {upgradeBannerIsDisplayedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var upgradeBannerIsDisplayed = function (params) {
    return { evid: 61, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} introServicesSelectedParams
* @property {string} adiBuilderType - null
* @property {string} blog - true (default) / true / false . If the user has stores by default, the true (default) value will be reported
* @property {string} bookings - true (default) / true / false . If the user has stores by default, the true (default) value will be reported
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} mainCategory - the category from the 'vertical selector' category that the user chose
* @property {string} screenResolution - null
* @property {string} stores - true (default) / true / false . If the user has stores by default, the true (default) value will be reported
* @property {string} userSubscription - true (default) / true / false . If the user has stores by default, the true (default) value will be reported
* @property {GUID} uuid - user id
**/
/**
 * Name: intro - Services selected. Evid: 104.
 * Event description: Module: intro. Flow: user changes a checkbox's status in the services page (for every change). .

 * adiBuilderType - Type: string.
 *
 * blog - Type: string. Desc: true (default) / true / false . If the user has stores by default, the true (default) value will be reported
 *
 * bookings - Type: string. Desc: true (default) / true / false . If the user has stores by default, the true (default) value will be reported
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * mainCategory - Type: string. Desc: the category from the 'vertical selector' category that the user chose
 *
 * screenResolution - Type: string.
 *
 * stores - Type: string. Desc: true (default) / true / false . If the user has stores by default, the true (default) value will be reported
 *
 * userSubscription - Type: string. Desc: true (default) / true / false . If the user has stores by default, the true (default) value will be reported
 *
 * uuid - Type: guid. Desc: user id
 * @param {introServicesSelectedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var introServicesSelected = function (params) {
    return { evid: 104, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} introYoutubeChannelPageNavigationClickParams
* @property {string} adiBuilderType - desktop / MED
* @property {GUID} esi - editor session id, for every site editting session
* @property {boolean} facebook - true / false
* @property {boolean} googlePlaces - true / false
* @property {string} navButton - name of navigation button: next / skip / back
* @property {string} nextView - ** Deprecated **
* @property {string} reviewImages - true / false
* @property {string} screenResolution - screen resolution
* @property {boolean} website - true / false
* @property {boolean} youTube - true / false
**/
/**
 * Name: intro - content import page - navigation click. Evid: 99.
 * Event description: Module: intro. Flow: user clicks on a navigation button on the unified import screen/ youtube channel intro page.

 * adiBuilderType - Type: string. Desc: desktop / MED
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * facebook - Type: bool. Desc: true / false
 *
 * googlePlaces - Type: bool. Desc: true / false
 *
 * navButton - Type: string. Desc: name of navigation button: next / skip / back
 *
 * nextView - Type: string. Desc: ** Deprecated **
 *
 * reviewImages - Type: string. Desc: true / false
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * website - Type: bool. Desc: true / false
 *
 * youTube - Type: bool. Desc: true / false
 * @param {introYoutubeChannelPageNavigationClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var introYoutubeChannelPageNavigationClick = function (params) {
    return { evid: 99, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} contentEditorAddDuplicateItemSuccessParams
* @property {string} addType - new/ duplicate
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} loadTime - time in ms
* @property {GUID} msid - metasite id
* @property {string} nodeId - unique number per node, in case this is a list - this is the sectionNodeId
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: contentEditor - Add/ Duplicate item - success. Evid: 216.
 * Event description: Module: contentEditor. Flow: item was added successfully to stage. .

 * addType - Type: string. Desc: new/ duplicate
 *
 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * loadTime - Type: numeric. Desc: time in ms
 *
 * msid - Type: guid. Desc: metasite id
 *
 * nodeId - Type: string. Desc: unique number per node, in case this is a list - this is the sectionNodeId
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {contentEditorAddDuplicateItemSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var contentEditorAddDuplicateItemSuccess = function (params) {
    return { evid: 216, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} loadingExistingSiteAssistantInitAssistantParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} intervalLoadTime - loading time diff from previous phase
* @property {number} loadTime - loading time till this phase
* @property {GUID} msid - metasite id
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: loading - existing site - Assistant: Init Assistant. Evid: 515.
 * Event description: Module: builder. Flow: phase in opening the builder (existing site) started..

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * intervalLoadTime - Type: numeric. Desc: loading time diff from previous phase
 *
 * loadTime - Type: numeric. Desc: loading time till this phase
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {loadingExistingSiteAssistantInitAssistantParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var loadingExistingSiteAssistantInitAssistant = function (params) {
    return { evid: 515, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} sectionDesignChangeFormDesignClickSuccessParams
* @property {string} adiBuilderType - desktop / mobile/ MED....
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} origin - OSI
* @property {string} screenResolution - screen_resolution
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: sectionDesign - change form design click - success. Evid: 585.
 * Event description: Module: sectionDesign. Flow: user changes form's design.

 * adiBuilderType - Type: string. Desc: desktop / mobile/ MED....
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * origin - Type: string. Desc: OSI
 *
 * screenResolution - Type: string. Desc: screen_resolution
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {sectionDesignChangeFormDesignClickSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionDesignChangeFormDesignClickSuccess = function (params) {
    return { evid: 585, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} mediaManagementExternalVideoSearchCompletedParams
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} nodeId - unique number per node, in case this is a list - this is the sectionNodeId
* @property {string} pageId - number of page
* @property {number} returnedResults - how many resuslts the user sees, 0 for zero matches
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} source - video source: vimeo / youtube
* @property {string} structureId - structure id
* @property {string} text - search term
* @property {GUID} uuid - user id
**/
/**
 * Name: mediaManagement - External Video - Search completed. Evid: 407.
 * Event description: Module: mediaManagement. Flow: user see the returned results. .

 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * nodeId - Type: string. Desc: unique number per node, in case this is a list - this is the sectionNodeId
 *
 * pageId - Type: string. Desc: number of page
 *
 * returnedResults - Type: numeric. Desc: how many resuslts the user sees, 0 for zero matches
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * source - Type: string. Desc: video source: vimeo / youtube
 *
 * structureId - Type: string. Desc: structure id
 *
 * text - Type: string. Desc: search term
 *
 * uuid - Type: guid. Desc: user id
 * @param {mediaManagementExternalVideoSearchCompletedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var mediaManagementExternalVideoSearchCompleted = function (params) {
    return { evid: 407, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} sectionDesignChangeFontSizeClickParams
* @property {string} adiBuilderType - null
* @property {string} designId - id of the design
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} fontSize - font size
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} origin - OSI / panel
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} setId - unique identifier of the font set
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: sectionDesign - change font size - click. Evid: 554.
 * Event description: Module: sectionDesign. Flow: user changes section font size.

 * adiBuilderType - Type: string.
 *
 * designId - Type: string. Desc: id of the design
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * fontSize - Type: string. Desc: font size
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * origin - Type: string. Desc: OSI / panel
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * setId - Type: string. Desc: unique identifier of the font set
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {sectionDesignChangeFontSizeClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionDesignChangeFontSizeClick = function (params) {
    return { evid: 554, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderSwitchBuilderTypeMobileDesktopClickParams
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} selectedBuilder - mobile/desktop
* @property {string} source - where was switched from (topbar, pages panel)
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - switch builder type (mobile/desktop) - click. Evid: 35.
 * Event description: Module: builder. Flow: user switches between mobile and desktop editors click.

 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * selectedBuilder - Type: string. Desc: mobile/desktop
 *
 * source - Type: string. Desc: where was switched from (topbar, pages panel)
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderSwitchBuilderTypeMobileDesktopClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderSwitchBuilderTypeMobileDesktopClick = function (params) {
    return { evid: 35, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} goToEditorContinueToProEditorStartForAdi2editorTestParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - esi
* @property {string} industryId - site industry id
* @property {GUID} msid - metasite id
* @property {string} origin - migration flow ondemand or onload
* @property {string} screenResolution - null
* @property {string} structureId - site structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: Go to Editor - Continue to Pro Editor Start (for ADI2Editor test). Evid: 3999.
 * Event description: Module: builder. Flow: ADI start to transfer a site to Editor (Adi to Editor test).

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: esi
 *
 * industryId - Type: string. Desc: site industry id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * origin - Type: string. Desc: migration flow ondemand or onload
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: site structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {goToEditorContinueToProEditorStartForAdi2editorTestParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var goToEditorContinueToProEditorStartForAdi2editorTest = function (params) {
    return { evid: 3999, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} introApproveSearchInformationPageNavigationClickParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} lod - level of details of the location (exact / street / neighbourhood / city / state / country )
* @property {string} mainCategory - the category from the 'vertical selector' category that the user chose
* @property {string} navButton - name of navigation button: next / skip / back / escape
* @property {string} nextView - name of next page: business type / services selection / business name / location / search confirm / search results / edit info card / builder / pro editor
* @property {string} screenResolution - null
* @property {string} text - searched text
* @property {GUID} uuid - user id
**/
/**
 * Name: intro - Approve search information page - navigation click. Evid: 108.
 * Event description: Module: intro. Flow: user clicks on a navigation button in the search confirmation page (5th page). .

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * lod - Type: string. Desc: level of details of the location (exact / street / neighbourhood / city / state / country )
 *
 * mainCategory - Type: string. Desc: the category from the 'vertical selector' category that the user chose
 *
 * navButton - Type: string. Desc: name of navigation button: next / skip / back / escape
 *
 * nextView - Type: string. Desc: name of next page: business type / services selection / business name / location / search confirm / search results / edit info card / builder / pro editor
 *
 * screenResolution - Type: string.
 *
 * text - Type: string. Desc: searched text
 *
 * uuid - Type: guid. Desc: user id
 * @param {introApproveSearchInformationPageNavigationClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var introApproveSearchInformationPageNavigationClick = function (params) {
    return { evid: 108, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} loadingExistingSiteRenderSiteDataListenToSantaChangesParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} intervalLoadTime - loading time diff from previous phase
* @property {number} loadTime - loading time till this phase
* @property {GUID} msid - metasite id
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: loading - existing site - Render Site Data: Listen to Santa changes. Evid: 519.
 * Event description: Module: builder. Flow: phase in opening the builder (existing site) started..

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * intervalLoadTime - Type: numeric. Desc: loading time diff from previous phase
 *
 * loadTime - Type: numeric. Desc: loading time till this phase
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {loadingExistingSiteRenderSiteDataListenToSantaChangesParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var loadingExistingSiteRenderSiteDataListenToSantaChanges = function (params) {
    return { evid: 519, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} contentEditorComponentWasHiddenSuccessParams
* @property {string} action - hide/unhide
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} fieldName - which field is updated: title,subtitle,body,image,button,link, list description
* @property {string} fieldType - text/ dropdown/ link / long text
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} loadTime - time in ms
* @property {GUID} msid - metasite id
* @property {string} nodeId - unique number per node, in case this is a list - this is the sectionNodeId
* @property {string} origin - where the action was made from (edit panel,OSI dropdown)
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: contentEditor - component was hidden - success. Evid: 205.
 * Event description: Module: contentEditor. Flow: component was hidden successfully and change is seen on stahe. .

 * action - Type: string. Desc: hide/unhide
 *
 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * fieldName - Type: string. Desc: which field is updated: title,subtitle,body,image,button,link, list description
 *
 * fieldType - Type: string. Desc: text/ dropdown/ link / long text
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * loadTime - Type: numeric. Desc: time in ms
 *
 * msid - Type: guid. Desc: metasite id
 *
 * nodeId - Type: string. Desc: unique number per node, in case this is a list - this is the sectionNodeId
 *
 * origin - Type: string. Desc: where the action was made from (edit panel,OSI dropdown)
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {contentEditorComponentWasHiddenSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var contentEditorComponentWasHiddenSuccess = function (params) {
    return { evid: 205, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} medBuilderUpdateRequestSentParams
* @property {string} action - action that is updated (change kit, edit section etc.)
* @property {string} adiBuilderType - MED
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} revision - saved revision
* @property {string} screenResolution - screen resolution
* @property {string} structureId - structure id
**/
/**
 * Name: MED - Builder - update Request sent. Evid: 892.
 * Event description: Module: MED. Flow: Builder sends an update request.

 * action - Type: string. Desc: action that is updated (change kit, edit section etc.)
 *
 * adiBuilderType - Type: string. Desc: MED
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * revision - Type: numeric. Desc: saved revision
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * structureId - Type: string. Desc: structure id
 * @param {medBuilderUpdateRequestSentParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var medBuilderUpdateRequestSent = function (params) {
    return { evid: 892, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} sectionManagementSectionPanelClosedParams
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} nodeId - unique number per node
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: sectionManagement - Section panel - closed. Evid: 267.
 * Event description: Module: sectionManagement. Flow: user closed the add replace section panel..

 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * nodeId - Type: string. Desc: unique number per node
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {sectionManagementSectionPanelClosedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionManagementSectionPanelClosed = function (params) {
    return { evid: 267, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} sectionManagementAddSectionClickParams
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} source - how the add section was opened: plus button / top bar / blank page
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: sectionManagement - Add Section click. Evid: 268.
 * Event description: Module: sectionManagement. Flow: user clicks on add section (from top bar / plus / when adding blank page ). ..

 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * source - Type: string. Desc: how the add section was opened: plus button / top bar / blank page
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {sectionManagementAddSectionClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionManagementAddSectionClick = function (params) {
    return { evid: 268, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} sectionManagementSectionMovedToANewPageSuccessParams
* @property {string} adiBuilderType - null
* @property {string} appId - in case of tpa: app_id/blog
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} loadTime - time in ms
* @property {GUID} msid - metasite id
* @property {string} nodeId - unique number per node
* @property {string} originPageId - number of origin page
* @property {number} originPosition - new position of section in page
* @property {string} pageId - number of page
* @property {number} position - position of section in page
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: sectionManagement - Section moved to a new page - success. Evid: 263.
 * Event description: Module: sectionManagement. Flow: user chooses the target page of the transfered section..

 * adiBuilderType - Type: string.
 *
 * appId - Type: string. Desc: in case of tpa: app_id/blog
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * loadTime - Type: numeric. Desc: time in ms
 *
 * msid - Type: guid. Desc: metasite id
 *
 * nodeId - Type: string. Desc: unique number per node
 *
 * originPageId - Type: string. Desc: number of origin page
 *
 * originPosition - Type: numeric. Desc: new position of section in page
 *
 * pageId - Type: string. Desc: number of page
 *
 * position - Type: numeric. Desc: position of section in page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {sectionManagementSectionMovedToANewPageSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionManagementSectionMovedToANewPageSuccess = function (params) {
    return { evid: 263, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} siteDesignClickOnDesiredPaletteFromCustomizePalleteSuccessParams
* @property {string} adiBuilderType - null
* @property {string} colorationLevel - {plain, tinted,  colorful, vibrant, none}
* @property {string} designId - id of the design
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} loadTime - loading time between click to success
* @property {number} loading_time - loading time between click to Success
* @property {GUID} msid - metasite id
* @property {number} noOfSets - The number of palettes to choose from, including Logo, Custom and Recommended Palettes
* @property {number} num_of_colors - number of colors in the palette
* @property {string} origin - welcomeTour  / header-panel / clipart-settings-panel / customize-palette-panel
* @property {string} palleteCreator - server(magic), default,custom,calculated
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {number} setNumber - The index of the chosen palette, where -1 means logo palette, and 0 or above means index in list of custom (if exists) or calculated palettes
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: siteDesign - Click on desired palette from customize pallete Success. Evid: 322.
 * Event description: Module: siteDesign. Flow: user chooses a palette in customize pallette panel - Success.

 * adiBuilderType - Type: string.
 *
 * colorationLevel - Type: string. Desc: {plain, tinted,  colorful, vibrant, none}
 *
 * designId - Type: string. Desc: id of the design
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * loadTime - Type: numeric. Desc: loading time between click to success
 *
 * loading_time - Type: numeric. Desc: loading time between click to Success
 *
 * msid - Type: guid. Desc: metasite id
 *
 * noOfSets - Type: numeric. Desc: The number of palettes to choose from, including Logo, Custom and Recommended Palettes
 *
 * num_of_colors - Type: numeric. Desc: number of colors in the palette
 *
 * origin - Type: string. Desc: welcomeTour  / header-panel / clipart-settings-panel / customize-palette-panel
 *
 * palleteCreator - Type: string. Desc: server(magic), default,custom,calculated
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * setNumber - Type: numeric. Desc: The index of the chosen palette, where -1 means logo palette, and 0 or above means index in list of custom (if exists) or calculated palettes
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {siteDesignClickOnDesiredPaletteFromCustomizePalleteSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteDesignClickOnDesiredPaletteFromCustomizePalleteSuccess = function (params) {
    return { evid: 322, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} tourWelcomeTourKitSelectionParams
* @property {string} adiBuilderType - -
* @property {string} designId - id of the design, only for the style dialog phase
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {GUID} msid - metasite id
* @property {number} position - kit's position
* @property {number} revision - builder version
* @property {string} screenResolution - -
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: tour - welcome tour - kit selection. Evid: 66.
 * Event description: Module: tour. Flow: when user choose a design kit in welcome tour.

 * adiBuilderType - Type: string. Desc: -
 *
 * designId - Type: string. Desc: id of the design, only for the style dialog phase
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * position - Type: numeric. Desc: kit's position
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string. Desc: -
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {tourWelcomeTourKitSelectionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tourWelcomeTourKitSelection = function (params) {
    return { evid: 66, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderRightClickParams
* @property {string} adiBuilderType - adi builder type
* @property {string} app_state - the builder state (pages panel opened, add section panel opened etc.)
* @property {string} class - DEPRECATED
* @property {string} classes - the class of what was clicked
* @property {string} component - currently deprecated
* @property {string} container - the general area of the click (header,dialog etc.)
* @property {string} dataHook - name of the area clicked (as used by automation)
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {number} revision - -
* @property {string} screenResolution - screen resolution
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - right click. Evid: 89.
 * Event description: Module: builder. Flow: user clicks on mouse right click somewhere in the builder.

 * adiBuilderType - Type: string. Desc: adi builder type
 *
 * app_state - Type: string. Desc: the builder state (pages panel opened, add section panel opened etc.)
 *
 * class - Type: string. Desc: DEPRECATED
 *
 * classes - Type: string. Desc: the class of what was clicked
 *
 * component - Type: string. Desc: currently deprecated
 *
 * container - Type: string. Desc: the general area of the click (header,dialog etc.)
 *
 * dataHook - Type: string. Desc: name of the area clicked (as used by automation)
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * revision - Type: numeric. Desc: -
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderRightClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderRightClick = function (params) {
    return { evid: 89, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} loadingExistingSiteLoadStoryWizardServiceInitAParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} intervalLoadTime - loading time diff from previous phase
* @property {number} loadTime - loading time till this phase
* @property {GUID} msid - metasite id
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: loading - existing site - LoadStory: WizardService init A. Evid: 137.
 * Event description: Module: builder. Flow: phase in opening the builder (existing site) started..

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * intervalLoadTime - Type: numeric. Desc: loading time diff from previous phase
 *
 * loadTime - Type: numeric. Desc: loading time till this phase
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {loadingExistingSiteLoadStoryWizardServiceInitAParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var loadingExistingSiteLoadStoryWizardServiceInitA = function (params) {
    return { evid: 137, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} sectionManagementAddSectionPanelIsLoadedParams
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} origin - top bar / menu link panel
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: sectionManagement - Add Section panel is loaded. Evid: 253.
 * Event description: Module: sectionManagement. Flow: user clicks on add section and the panel is loaded..

 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * origin - Type: string. Desc: top bar / menu link panel
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {sectionManagementAddSectionPanelIsLoadedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionManagementAddSectionPanelIsLoaded = function (params) {
    return { evid: 253, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderSwitchViewFromAnonToUserSuccess28Params
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} instanceId - instance_id, represents the story/msid
* @property {string} msid - metasite id
* @property {number} revision - **deprecated**
* @property {boolean} saveToSanta - **deprecated**
* @property {string} screenResolution - null
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - switch view from anon to user - success. Evid: 28.
 * Event description: Module: builder. Flow: after user logged in or signed up successfully.

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * instanceId - Type: string. Desc: instance_id, represents the story/msid
 *
 * msid - Type: string. Desc: metasite id
 *
 * revision - Type: numeric. Desc: **deprecated**
 *
 * saveToSanta - Type: bool. Desc: **deprecated**
 *
 * screenResolution - Type: string.
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderSwitchViewFromAnonToUserSuccess28Params} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderSwitchViewFromAnonToUserSuccess28 = function (params) {
    return { evid: 28, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} sectionManagementSectionMenuDuplicateSectionClickParams
* @property {string} adiBuilderType - null
* @property {string} appId - in case of tpa: app_id/blog
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} origin - OSI / right click / stage
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: sectionManagement - Section menu - Duplicate Section click. Evid: 264.
 * Event description: Module: sectionManagement. Flow: user chooses to duplicate an existing section..

 * adiBuilderType - Type: string.
 *
 * appId - Type: string. Desc: in case of tpa: app_id/blog
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * origin - Type: string. Desc: OSI / right click / stage
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {sectionManagementSectionMenuDuplicateSectionClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionManagementSectionMenuDuplicateSectionClick = function (params) {
    return { evid: 264, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} loadingFirstTimeRenderSiteDataListenToSantaChangesParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} intervalLoadTime - loading time diff from previous phase
* @property {number} loadTime - loading time till this phase
* @property {GUID} msid - metasite id
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: loading - first time - Render Site Data: Listen to Santa changes. Evid: 508.
 * Event description: Module: builder. Flow: phase in opening the builder (first time) started..

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * intervalLoadTime - Type: numeric. Desc: loading time diff from previous phase
 *
 * loadTime - Type: numeric. Desc: loading time till this phase
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {loadingFirstTimeRenderSiteDataListenToSantaChangesParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var loadingFirstTimeRenderSiteDataListenToSantaChanges = function (params) {
    return { evid: 508, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} tourBubbleClosedDeprecatedEventParams
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} name - card's name
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {string} type - smart assist / tour
* @property {GUID} uuid - user id
**/
/**
 * Name: tour - bubble closed (deprecated event). Evid: 46.
 * Event description: Module: tour. Flow: user closed the bubble..

 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * name - Type: string. Desc: card's name
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * type - Type: string. Desc: smart assist / tour
 *
 * uuid - Type: guid. Desc: user id
 * @param {tourBubbleClosedDeprecatedEventParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tourBubbleClosedDeprecatedEvent = function (params) {
    return { evid: 46, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} introWixwizSearchResultsPageNavigationClickParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {number} locationScore - location score from wixwiz on selected result
* @property {string} mainCategory - the category from the 'vertical selector' category that the user chose
* @property {string} navButton - name of navigation button: next / skip / back / escape
* @property {string} nextView - name of next page: business type / services selection / business name / location / search confirm / search results / edit info card / builder / pro editor
* @property {number} noOfMatches - for search results page: number of results that were found (overall)
* @property {number} noOfSeenMatches - number of results that user saw (how many results fully displayed on screen)
* @property {number} position - position of selected result
* @property {string} screenResolution - null
* @property {GUID} searchGuid - for search results page: every search a new guid is generated by wixwiz server
* @property {number} similarityScore - similarity score from wixwiz on selected result
* @property {GUID} uuid - user id
**/
/**
 * Name: intro - wixwiz search results page - navigation click. Evid: 110.
 * Event description: Module: intro. Flow: user clicks on a navigation button in the search results page (6th page), including the 'it's me' button. Navigation options: next (=it's me), back, skip. .

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * locationScore - Type: numeric. Desc: location score from wixwiz on selected result
 *
 * mainCategory - Type: string. Desc: the category from the 'vertical selector' category that the user chose
 *
 * navButton - Type: string. Desc: name of navigation button: next / skip / back / escape
 *
 * nextView - Type: string. Desc: name of next page: business type / services selection / business name / location / search confirm / search results / edit info card / builder / pro editor
 *
 * noOfMatches - Type: numeric. Desc: for search results page: number of results that were found (overall)
 *
 * noOfSeenMatches - Type: numeric. Desc: number of results that user saw (how many results fully displayed on screen)
 *
 * position - Type: numeric. Desc: position of selected result
 *
 * screenResolution - Type: string.
 *
 * searchGuid - Type: guid. Desc: for search results page: every search a new guid is generated by wixwiz server
 *
 * similarityScore - Type: numeric. Desc: similarity score from wixwiz on selected result
 *
 * uuid - Type: guid. Desc: user id
 * @param {introWixwizSearchResultsPageNavigationClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var introWixwizSearchResultsPageNavigationClick = function (params) {
    return { evid: 110, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} medHeadlessWrapperRequestFailedParams
* @property {string} adiBuilderType - headless
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} loadTime - time elapsed (in ms) from trial
* @property {string} name - warmup/update/build/publish
* @property {string} reason - reason for failure
* @property {string} screenResolution - screen resolution
* @property {string} structureId - structure id
**/
/**
 * Name: MED - Headless Server Request Failed. Evid: 812.
 * Event description: Module: MED. Flow: Headless Wrapper request (Warmup, Update, Build, Publish) failed.

 * adiBuilderType - Type: string. Desc: headless
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * loadTime - Type: numeric. Desc: time elapsed (in ms) from trial
 *
 * name - Type: string. Desc: warmup/update/build/publish
 *
 * reason - Type: string. Desc: reason for failure
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * structureId - Type: string. Desc: structure id
 * @param {medHeadlessWrapperRequestFailedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var medHeadlessWrapperRequestFailed = function (params) {
    return { evid: 812, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} loadingExistingSiteLoadStoryGetMetadataParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} intervalLoadTime - loading time diff from previous phase
* @property {number} loadTime - loading time till this phase
* @property {GUID} msid - metasite id
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: loading - existing site - LoadStory: Get metadata. Evid: 136.
 * Event description: Module: builder. Flow: phase in opening the builder (existing site) started..

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * intervalLoadTime - Type: numeric. Desc: loading time diff from previous phase
 *
 * loadTime - Type: numeric. Desc: loading time till this phase
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {loadingExistingSiteLoadStoryGetMetadataParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var loadingExistingSiteLoadStoryGetMetadata = function (params) {
    return { evid: 136, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} sectionManagementAddSectionToPageStartDraggingParams
* @property {string} addType - click / drag
* @property {string} adiBuilderType - null
* @property {string} appId - in case of tpa: app_id/blog
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {number} noOfSuggestions - int number that represents the number of suggested layouts that the user saw
* @property {string} pageId - number of page
* @property {string} place - where the group is placed: recommended / others / expanded list
* @property {number} placeOfSelected - int number that represents the place of the selected layout (1 for the first,…)
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} selectedLayout - layout id
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: sectionManagement - Add Section to page - Start dragging. Evid: 269.
 * Event description: Module: sectionManagement. Flow: user chooses a layout of the new section and start to drag it to the stage. Evid 255 will represent drag-complete..

 * addType - Type: string. Desc: click / drag
 *
 * adiBuilderType - Type: string.
 *
 * appId - Type: string. Desc: in case of tpa: app_id/blog
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * noOfSuggestions - Type: numeric. Desc: int number that represents the number of suggested layouts that the user saw
 *
 * pageId - Type: string. Desc: number of page
 *
 * place - Type: string. Desc: where the group is placed: recommended / others / expanded list
 *
 * placeOfSelected - Type: numeric. Desc: int number that represents the place of the selected layout (1 for the first,…)
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * selectedLayout - Type: string. Desc: layout id
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {sectionManagementAddSectionToPageStartDraggingParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionManagementAddSectionToPageStartDragging = function (params) {
    return { evid: 269, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} introSiteConverterSiteJsonParsingSuccessParams
* @property {string} adiBuilderType - desktop / mobile
* @property {GUID} esi - editor session id, for every site editting session
* @property {number} imagesLeft - number of images left after parsing
* @property {number} imagesOrig - number of images in the original json
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} loadTime - time elapsed from process start
* @property {GUID} msid - metasite id
* @property {string} screenResolution - screen resolution
* @property {number} sectionsLeft - number of sections left after parsing
* @property {number} sectionsOrig - number of sections in the original json
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: intro - Site Converter - Site json parsing success. Evid: 7.
 * Event description: Module: intro. Flow: parsing process of JSON (imported from WixWiz) complete successfully.

 * adiBuilderType - Type: string. Desc: desktop / mobile
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * imagesLeft - Type: numeric. Desc: number of images left after parsing
 *
 * imagesOrig - Type: numeric. Desc: number of images in the original json
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * loadTime - Type: numeric. Desc: time elapsed from process start
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * sectionsLeft - Type: numeric. Desc: number of sections left after parsing
 *
 * sectionsOrig - Type: numeric. Desc: number of sections in the original json
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {introSiteConverterSiteJsonParsingSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var introSiteConverterSiteJsonParsingSuccess = function (params) {
    return { evid: 7, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} introSelectServicesPageNavigationClickParams
* @property {string} adiBuilderType - null
* @property {string} bandsInTown - if bands in town is selected: true/false (default/prechecked/recommended/popular)
* @property {string} blog - true (default) / true / false . If the user has stores by default, the true (default) value will be reported
* @property {string} bookings - true (default) / true / false . If the user has stores by default, the true (default) value will be reported
* @property {string} chat - if chat is selected: true/false (default/prechecked/recommended/popular)
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} flow - main funnel when used in the  mani funnel
* @property {string} forum - if forum is selected: true/false (default/prechecked/recommended/popular)
* @property {string} groups - if groups is selected: true/false (default/prechecked/recommended/popular)
* @property {string} instagram - if instagram is selected: true/false (default/prechecked/recommended/popular)
* @property {string} mainCategory - the category from the 'vertical selector' category that the user chose
* @property {string} membersArea - if members area is selected: true/false (default/prechecked/recommended/popular)
* @property {string} multiEvent - if multi events is selected: true/false (default/prechecked/recommended/popular)
* @property {string} music - if music is selected: true/false (default/prechecked/recommended/popular)
* @property {string} navButton - name of navigation button: next / skip / back / escape
* @property {string} nextView - name of next page: business type / services selection / business name / location / search confirm / search results / edit info card / builder / pro editor
* @property {string} paidPlans - if paid plans is selected: true/false (default/prechecked/recommended/popular)
* @property {string} restaurantMenus - if restaurant Menus is selected: true/false (default/prechecked/recommended/popular)
* @property {string} restaurantOrders - if restaurant Orders is selected: true/false (default/prechecked/recommended/popular)
* @property {string} restaurantReservations - if restaurant Reservations is selected: true/false (default/prechecked/recommended/popular)
* @property {string} screenResolution - null
* @property {string} singleEvent - if single event is selected: true/false (default/prechecked/recommended/popular)
* @property {string} stores - true (default) / true / false . If the user has stores by default, the true (default) value will be reported
* @property {string} userSubscription - true (default) / true / false . If the user has stores by default, the true (default) value will be reported
* @property {GUID} uuid - user id
* @property {string} video - if video is selected: true/false (default/prechecked/recommended/popular)
**/
/**
 * Name: intro - Select services page - navigation click. Evid: 105.
 * Event description: Module: intro. Flow: user clicks on a navigation button in the select services page (2nd page). .

 * adiBuilderType - Type: string.
 *
 * bandsInTown - Type: string. Desc: if bands in town is selected: true/false (default/prechecked/recommended/popular)
 *
 * blog - Type: string. Desc: true (default) / true / false . If the user has stores by default, the true (default) value will be reported
 *
 * bookings - Type: string. Desc: true (default) / true / false . If the user has stores by default, the true (default) value will be reported
 *
 * chat - Type: string. Desc: if chat is selected: true/false (default/prechecked/recommended/popular)
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * flow - Type: string. Desc: main funnel when used in the  mani funnel
 *
 * forum - Type: string. Desc: if forum is selected: true/false (default/prechecked/recommended/popular)
 *
 * groups - Type: string. Desc: if groups is selected: true/false (default/prechecked/recommended/popular)
 *
 * instagram - Type: string. Desc: if instagram is selected: true/false (default/prechecked/recommended/popular)
 *
 * mainCategory - Type: string. Desc: the category from the 'vertical selector' category that the user chose
 *
 * membersArea - Type: string. Desc: if members area is selected: true/false (default/prechecked/recommended/popular)
 *
 * multiEvent - Type: string. Desc: if multi events is selected: true/false (default/prechecked/recommended/popular)
 *
 * music - Type: string. Desc: if music is selected: true/false (default/prechecked/recommended/popular)
 *
 * navButton - Type: string. Desc: name of navigation button: next / skip / back / escape
 *
 * nextView - Type: string. Desc: name of next page: business type / services selection / business name / location / search confirm / search results / edit info card / builder / pro editor
 *
 * paidPlans - Type: string. Desc: if paid plans is selected: true/false (default/prechecked/recommended/popular)
 *
 * restaurantMenus - Type: string. Desc: if restaurant Menus is selected: true/false (default/prechecked/recommended/popular)
 *
 * restaurantOrders - Type: string. Desc: if restaurant Orders is selected: true/false (default/prechecked/recommended/popular)
 *
 * restaurantReservations - Type: string. Desc: if restaurant Reservations is selected: true/false (default/prechecked/recommended/popular)
 *
 * screenResolution - Type: string.
 *
 * singleEvent - Type: string. Desc: if single event is selected: true/false (default/prechecked/recommended/popular)
 *
 * stores - Type: string. Desc: true (default) / true / false . If the user has stores by default, the true (default) value will be reported
 *
 * userSubscription - Type: string. Desc: true (default) / true / false . If the user has stores by default, the true (default) value will be reported
 *
 * uuid - Type: guid. Desc: user id
 *
 * video - Type: string. Desc: if video is selected: true/false (default/prechecked/recommended/popular)
 * @param {introSelectServicesPageNavigationClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var introSelectServicesPageNavigationClick = function (params) {
    return { evid: 105, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} appsAddTpaStartParams
* @property {string} adiBuilderType - desktop / mobile / MED
* @property {string} appId - application id
* @property {string} appName - application name
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} origin - panel / header / biz manager
* @property {number} revision - builder version
* @property {string} screenResolution - screen_resolution
* @property {string} structureId - structure id
**/
/**
 * Name: apps - add TPA - start. Evid: 457.
 * Event description: Module: apps. Flow: when TPA package installation starts.

 * adiBuilderType - Type: string. Desc: desktop / mobile / MED
 *
 * appId - Type: string. Desc: application id
 *
 * appName - Type: string. Desc: application name
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * origin - Type: string. Desc: panel / header / biz manager
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string. Desc: screen_resolution
 *
 * structureId - Type: string. Desc: structure id
 * @param {appsAddTpaStartParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appsAddTpaStart = function (params) {
    return { evid: 457, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} siteDesignCreatePaletteFromLogoAlgoStartParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} name - phase name: load-image / color-extract
* @property {string} origin - info-card / welcomeTour / clipart-settings-panel / header-panel
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: siteDesign - Create palette from logo algo start. Evid: 333.
 * Event description: Module: siteDesign. Flow: a color palette is created from the logo uploaded by the user. algo runs in background..

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * name - Type: string. Desc: phase name: load-image / color-extract
 *
 * origin - Type: string. Desc: info-card / welcomeTour / clipart-settings-panel / header-panel
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {siteDesignCreatePaletteFromLogoAlgoStartParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteDesignCreatePaletteFromLogoAlgoStart = function (params) {
    return { evid: 333, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} siteDesignCustomizeDesignChangeElementAnimationSuccessParams
* @property {string} adiBuilderType - null
* @property {string} designId - id of the design
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} loadTime - time in ms for changing animation
* @property {GUID} msid - metasite id
* @property {string} name - name of animation: none, fade, float, ...
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: siteDesign - Customize Design - Change Element Animation Success. Evid: 317.
 * Event description: Module: siteDesign. Flow: a desired element animation was updated successfully.

 * adiBuilderType - Type: string.
 *
 * designId - Type: string. Desc: id of the design
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * loadTime - Type: numeric. Desc: time in ms for changing animation
 *
 * msid - Type: guid. Desc: metasite id
 *
 * name - Type: string. Desc: name of animation: none, fade, float, ...
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {siteDesignCustomizeDesignChangeElementAnimationSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteDesignCustomizeDesignChangeElementAnimationSuccess = function (params) {
    return { evid: 317, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} contentEditorClickOnHideShowOnItemInListItemsParams
* @property {string} action - hide/show
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} nodeId - unique number per node, in case this is a list - this is the sectionNodeId
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: contentEditor - Click on hide/show on item in List items. Evid: 230.
 * Event description: Module: contentEditor. Flow: user clicks on 'hide/show on an item in list..

 * action - Type: string. Desc: hide/show
 *
 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * nodeId - Type: string. Desc: unique number per node, in case this is a list - this is the sectionNodeId
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {contentEditorClickOnHideShowOnItemInListItemsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var contentEditorClickOnHideShowOnItemInListItems = function (params) {
    return { evid: 230, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderBusinessInfoUpdateChangesSuccessParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} loadTime - time it took in ms
* @property {GUID} msid - metasite id
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - Business Info - Update changes - success. Evid: 146.
 * Event description: Module: builder. Flow: business info changes were updated successfully on stage. .

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * loadTime - Type: numeric. Desc: time it took in ms
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderBusinessInfoUpdateChangesSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderBusinessInfoUpdateChangesSuccess = function (params) {
    return { evid: 146, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} loadingFirstTimeInitDataUploadMediaFromIntroParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} intervalLoadTime - loading time diff from previous phase
* @property {number} loadTime - loading time till this phase
* @property {GUID} msid - metasite id
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: loading - first time - Init Data: Upload media from intro. Evid: 171.
 * Event description: Module: builder. Flow: phase in opening the builder (first time) started..

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * intervalLoadTime - Type: numeric. Desc: loading time diff from previous phase
 *
 * loadTime - Type: numeric. Desc: loading time till this phase
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {loadingFirstTimeInitDataUploadMediaFromIntroParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var loadingFirstTimeInitDataUploadMediaFromIntro = function (params) {
    return { evid: 171, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderSiteConverterSectionPresetPickerSuccessParams
* @property {string} adiBuilderType - desktop / mobile
* @property {GUID} esi - editor session id, for every site editting session
* @property {number} index - section index in original json
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} loadTime - time elapsed from calculation start
* @property {GUID} msid - metasite id
* @property {number} presetsCalculated - number of presets calculated for this section
* @property {string} screenResolution - screen resolution
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - Site Converter - Section Preset Picker Success. Evid: 4.
 * Event description: Module: builder. Flow: calculation of presets fit for section has completed successfully.

 * adiBuilderType - Type: string. Desc: desktop / mobile
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * index - Type: numeric. Desc: section index in original json
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * loadTime - Type: numeric. Desc: time elapsed from calculation start
 *
 * msid - Type: guid. Desc: metasite id
 *
 * presetsCalculated - Type: numeric. Desc: number of presets calculated for this section
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderSiteConverterSectionPresetPickerSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderSiteConverterSectionPresetPickerSuccess = function (params) {
    return { evid: 4, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} contentEditorOpenQuickActionDropdownParams
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} fieldName - which field is selected: title,subtitle,body,image,button,logo, list item etc.
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} nodeId - unique number per node, in case this is a list - this is the sectionNodeId
* @property {string} origin - OSI / right click
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: contentEditor - Open quick action dropdown. Evid: 235.
 * Event description: Module: contentEditor. Flow: user opens the quick actions dropdown from OSI/right click.

 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * fieldName - Type: string. Desc: which field is selected: title,subtitle,body,image,button,logo, list item etc.
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * nodeId - Type: string. Desc: unique number per node, in case this is a list - this is the sectionNodeId
 *
 * origin - Type: string. Desc: OSI / right click
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {contentEditorOpenQuickActionDropdownParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var contentEditorOpenQuickActionDropdown = function (params) {
    return { evid: 235, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} tourStartParams
* @property {string} adiBuilderType - null
* @property {string} assistType - tours / smart-assist
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} name - name of tour: welcome / preview / design-entire website / design-fonts&colors / edit section / add section / add page
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: tour - Start. Evid: 50.
 * Event description: Module: tour. Flow: tour starts . .

 * adiBuilderType - Type: string.
 *
 * assistType - Type: string. Desc: tours / smart-assist
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * name - Type: string. Desc: name of tour: welcome / preview / design-entire website / design-fonts&colors / edit section / add section / add page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {tourStartParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tourStart = function (params) {
    return { evid: 50, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} introBusinessTypeWasSelectedParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} flow - main funnel/adi intro
* @property {string} level - ** Deprecated **
* @property {string} mainCategory - the category from the 'vertical selector' category that the user chose
* @property {string} name - name of the business type
* @property {number} position - position of selected result
* @property {string} screenResolution - null
* @property {string} suggestList - from where user selected: example list / no matches list / category list
* @property {string} text - searched text
* @property {GUID} uuid - user id
**/
/**
 * Name: intro - Business type was selected. Evid: 101.
 * Event description: Module: intro. Flow: user selected from the drop down. .

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * flow - Type: string. Desc: main funnel/adi intro
 *
 * level - Type: string. Desc: ** Deprecated **
 *
 * mainCategory - Type: string. Desc: the category from the 'vertical selector' category that the user chose
 *
 * name - Type: string. Desc: name of the business type
 *
 * position - Type: numeric. Desc: position of selected result
 *
 * screenResolution - Type: string.
 *
 * suggestList - Type: string. Desc: from where user selected: example list / no matches list / category list
 *
 * text - Type: string. Desc: searched text
 *
 * uuid - Type: guid. Desc: user id
 * @param {introBusinessTypeWasSelectedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var introBusinessTypeWasSelected = function (params) {
    return { evid: 101, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderStickySocialBarShowOnHpToggleClickParams
* @property {string} action - on / off
* @property {string} adiBuilderType - MED / desktop
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} screenResolution - -
* @property {GUID} uuid - user id
**/
/**
 * Name: Builder - Sticky social bar - show on HP toggle click. Evid: 69.
 * Event description: Module: Builder. Flow: user clicks on the 'show on HP' toggle.

 * action - Type: string. Desc: on / off
 *
 * adiBuilderType - Type: string. Desc: MED / desktop
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * screenResolution - Type: string. Desc: -
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderStickySocialBarShowOnHpToggleClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderStickySocialBarShowOnHpToggleClick = function (params) {
    return { evid: 69, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderGoToEditorClosePageParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - Go to Editor - Close page. Evid: 158.
 * Event description: Module: builder. Flow: user closes the go to editor dialog.

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderGoToEditorClosePageParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderGoToEditorClosePage = function (params) {
    return { evid: 158, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} siteDesignCustomizeDesignAdvancedUserClicksFixColorsParams
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: siteDesign - Customize Design - Advanced - user clicks fix colors. Evid: 326.
 * Event description: Module: siteDesign. Flow: in advanced editing, custom colors that the user chose are hard to read, warning message is displayed and user clicks on fix colors.

 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {siteDesignCustomizeDesignAdvancedUserClicksFixColorsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteDesignCustomizeDesignAdvancedUserClicksFixColors = function (params) {
    return { evid: 326, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} siteDesignCustomizeDesignOpenAnimationListPanelParams
* @property {string} adiBuilderType - null
* @property {string} designId - id of the design
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: siteDesign - Customize Design - Open Animation List/Panel. Evid: 315.
 * Event description: Module: siteDesign. Flow: user clicks on animations dropdown or opens the animation panel.

 * adiBuilderType - Type: string.
 *
 * designId - Type: string. Desc: id of the design
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {siteDesignCustomizeDesignOpenAnimationListPanelParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteDesignCustomizeDesignOpenAnimationListPanel = function (params) {
    return { evid: 315, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderUndoRedoSuccessRetrieveFromServerParams
* @property {string} action - action type: undo/redo
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - Undo / Redo - success retrieve from server. Evid: 452.
 * Event description: Module: builder. Flow: undo / redo after many times retrieve revision from the server, this event fired when retrieval has succeeded..

 * action - Type: string. Desc: action type: undo/redo
 *
 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderUndoRedoSuccessRetrieveFromServerParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderUndoRedoSuccessRetrieveFromServer = function (params) {
    return { evid: 452, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} appsRemoveTpaStartParams
* @property {string} adiBuilderType - desktop / mobile / MED
* @property {string} appId - application id
* @property {GUID} appInstanceId - app instance id
* @property {string} appName - application name
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} nodeId - unique number per node
* @property {number} revision - builder version
* @property {string} screenResolution - screen_resolution
* @property {string} structureId - structure id
**/
/**
 * Name: apps - Remove TPA - start. Evid: 454.
 * Event description: Module: apps. Flow: users click on remove app.

 * adiBuilderType - Type: string. Desc: desktop / mobile / MED
 *
 * appId - Type: string. Desc: application id
 *
 * appInstanceId - Type: guid. Desc: app instance id
 *
 * appName - Type: string. Desc: application name
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * nodeId - Type: string. Desc: unique number per node
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string. Desc: screen_resolution
 *
 * structureId - Type: string. Desc: structure id
 * @param {appsRemoveTpaStartParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appsRemoveTpaStart = function (params) {
    return { evid: 454, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} contentEditorClickOnReplaceOrganizeMediaParams
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {string} mediaType - which field is clicked: image/gallery/video/shape/clipart
* @property {GUID} msid - metasite id
* @property {string} nodeId - unique number per node, in case this is a list - this is the sectionNodeId
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: contentEditor - Click on Replace / Organize Media. Evid: 207.
 * Event description: Module: contentEditor. Flow: user clicks on replace media when in image/clipart/shape/video mode or on organize media when in gallery mode. .

 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * mediaType - Type: string. Desc: which field is clicked: image/gallery/video/shape/clipart
 *
 * msid - Type: guid. Desc: metasite id
 *
 * nodeId - Type: string. Desc: unique number per node, in case this is a list - this is the sectionNodeId
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {contentEditorClickOnReplaceOrganizeMediaParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var contentEditorClickOnReplaceOrganizeMedia = function (params) {
    return { evid: 207, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} sectionManagementChangeASectionLayoutParams
* @property {string} adiBuilderType - null
* @property {string} appId - in case of tpa: app_id/blog
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {boolean} is_columns - flag for columns in selected layout
* @property {GUID} msid - metasite id
* @property {number} noOfRecommendedViewed - number of recommended layouts viewed by the user (by scrolling down the list)
* @property {number} noOfSuggestions - int number that represents the number of suggested layouts that the user saw
* @property {number} noOfSuggestionsViewed - **deprecated**
* @property {string} nodeId - unique number per node
* @property {string} pageId - number of page
* @property {string} place - recommended / others
* @property {number} placeOfSelected - int number that represents the place of the selected layout (1 for the first,…)
* @property {string} previousLayout - the previous layout id (before the change)
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} selectedLayout - layout id
* @property {string} source - where was the panel opened from {section/content - bg hidden}
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: sectionManagement - Change a section layout. Evid: 251.
 * Event description: Module: sectionManagement. Flow: user switches section's layout ..

 * adiBuilderType - Type: string.
 *
 * appId - Type: string. Desc: in case of tpa: app_id/blog
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * is_columns - Type: bool. Desc: flag for columns in selected layout
 *
 * msid - Type: guid. Desc: metasite id
 *
 * noOfRecommendedViewed - Type: numeric. Desc: number of recommended layouts viewed by the user (by scrolling down the list)
 *
 * noOfSuggestions - Type: numeric. Desc: int number that represents the number of suggested layouts that the user saw
 *
 * noOfSuggestionsViewed - Type: numeric. Desc: **deprecated**
 *
 * nodeId - Type: string. Desc: unique number per node
 *
 * pageId - Type: string. Desc: number of page
 *
 * place - Type: string. Desc: recommended / others
 *
 * placeOfSelected - Type: numeric. Desc: int number that represents the place of the selected layout (1 for the first,…)
 *
 * previousLayout - Type: string. Desc: the previous layout id (before the change)
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * selectedLayout - Type: string. Desc: layout id
 *
 * source - Type: string. Desc: where was the panel opened from {section/content - bg hidden}
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {sectionManagementChangeASectionLayoutParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionManagementChangeASectionLayout = function (params) {
    return { evid: 251, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} itemsManagerAddItemClickParams
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {string} item - page / menu
* @property {GUID} msid - metasite id
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} source - how the pages section was opened: top bar / pages panel
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: itemsManager - Add item Click. Evid: 349.
 * Event description: Module: itemsManager. Flow: user clicks on the add page/link button in the menu / pages panel.

 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * item - Type: string. Desc: page / menu
 *
 * msid - Type: guid. Desc: metasite id
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * source - Type: string. Desc: how the pages section was opened: top bar / pages panel
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {itemsManagerAddItemClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var itemsManagerAddItemClick = function (params) {
    return { evid: 349, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} sectionManagementDeleteSectionSuccessParams
* @property {string} adiBuilderType - null
* @property {string} appId - in case of tpa: app_id/blog
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {boolean} isLinked - flag for linked sections
* @property {number} loadTime - time in ms
* @property {GUID} msid - metasite id
* @property {string} nodeId - unique number per node
* @property {string} origin - null
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: sectionManagement - Delete section - success. Evid: 258.
 * Event description: Module: sectionManagement. Flow: section was deleted successfully..

 * adiBuilderType - Type: string.
 *
 * appId - Type: string. Desc: in case of tpa: app_id/blog
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * isLinked - Type: bool. Desc: flag for linked sections
 *
 * loadTime - Type: numeric. Desc: time in ms
 *
 * msid - Type: guid. Desc: metasite id
 *
 * nodeId - Type: string. Desc: unique number per node
 *
 * origin - Type: string.
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {sectionManagementDeleteSectionSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionManagementDeleteSectionSuccess = function (params) {
    return { evid: 258, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} sectionManagementSectionMovedWithinThePageSuccessParams
* @property {string} adiBuilderType - null
* @property {string} appId - in case of tpa: app_id/blog
* @property {string} direction - up / down / scroll
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} loadTime - time in ms
* @property {GUID} msid - metasite id
* @property {string} nodeId - unique number per node
* @property {number} originPosition - new position of section in page
* @property {string} pageId - number of page
* @property {number} position - position of section in page
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: sectionManagement - Section moved within the page - success. Evid: 261.
 * Event description: Module: sectionManagement. Flow: user chooses the target page of the transfered section..

 * adiBuilderType - Type: string.
 *
 * appId - Type: string. Desc: in case of tpa: app_id/blog
 *
 * direction - Type: string. Desc: up / down / scroll
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * loadTime - Type: numeric. Desc: time in ms
 *
 * msid - Type: guid. Desc: metasite id
 *
 * nodeId - Type: string. Desc: unique number per node
 *
 * originPosition - Type: numeric. Desc: new position of section in page
 *
 * pageId - Type: string. Desc: number of page
 *
 * position - Type: numeric. Desc: position of section in page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {sectionManagementSectionMovedWithinThePageSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionManagementSectionMovedWithinThePageSuccess = function (params) {
    return { evid: 261, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} introBusinessTypeScrolledToBottomParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} mainCategory - the category from the 'vertical selector' category that the user chose
* @property {number} returnedResults - how many resuslts the user sees
* @property {string} screenResolution - null
* @property {string} text - searched text
* @property {GUID} uuid - user id
**/
/**
 * Name: intro - Business type - scrolled to bottom. Evid: 114.
 * Event description: Module: intro. Flow: user typed a business type and scrolled down till the end of suggestion list.

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * mainCategory - Type: string. Desc: the category from the 'vertical selector' category that the user chose
 *
 * returnedResults - Type: numeric. Desc: how many resuslts the user sees
 *
 * screenResolution - Type: string.
 *
 * text - Type: string. Desc: searched text
 *
 * uuid - Type: guid. Desc: user id
 * @param {introBusinessTypeScrolledToBottomParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var introBusinessTypeScrolledToBottom = function (params) {
    return { evid: 114, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} contentEditorValueWasDeletedParams
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} fieldName - which field is updated: title,subtitle,body,image,button,link, list description
* @property {string} fieldType - text/ dropdown/ link / long text
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} nodeId - unique number per node, in case this is a list - this is the sectionNodeId
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: contentEditor - Value was deleted. Evid: 203.
 * Event description: Module: contentEditor. Flow: user deletes a value (not clears a cell, but clicks on the bin). .

 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * fieldName - Type: string. Desc: which field is updated: title,subtitle,body,image,button,link, list description
 *
 * fieldType - Type: string. Desc: text/ dropdown/ link / long text
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * nodeId - Type: string. Desc: unique number per node, in case this is a list - this is the sectionNodeId
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {contentEditorValueWasDeletedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var contentEditorValueWasDeleted = function (params) {
    return { evid: 203, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} introEditInfoCardPageNavigationClickParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} mainCategory - the category from the 'vertical selector' category that the user chose
* @property {string} navButton - name of navigation button: next / skip / back / escape
* @property {string} nextView - name of next page: business type / services selection / business name / location / search confirm / search results / edit info card / builder / pro editor
* @property {string} screenResolution - null
* @property {GUID} uuid - user id
**/
/**
 * Name: intro - Edit info card page - navigation click. Evid: 112.
 * Event description: Module: intro. Flow: user clicks on a navigation button in the edit info card page (7th page). .

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * mainCategory - Type: string. Desc: the category from the 'vertical selector' category that the user chose
 *
 * navButton - Type: string. Desc: name of navigation button: next / skip / back / escape
 *
 * nextView - Type: string. Desc: name of next page: business type / services selection / business name / location / search confirm / search results / edit info card / builder / pro editor
 *
 * screenResolution - Type: string.
 *
 * uuid - Type: guid. Desc: user id
 * @param {introEditInfoCardPageNavigationClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var introEditInfoCardPageNavigationClick = function (params) {
    return { evid: 112, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} mediaManagementGalleryOrganizerDeleteMediaParams
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} nodeId - unique number per node, in case this is a list - this is the sectionNodeId
* @property {number} numTotal - in case of gallery: number of items in gallery
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: mediaManagement - Gallery Organizer - Delete media. Evid: 405.
 * Event description: Module: mediaManagement. Flow: user deletes images from gallery organizer. .

 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * nodeId - Type: string. Desc: unique number per node, in case this is a list - this is the sectionNodeId
 *
 * numTotal - Type: numeric. Desc: in case of gallery: number of items in gallery
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {mediaManagementGalleryOrganizerDeleteMediaParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var mediaManagementGalleryOrganizerDeleteMedia = function (params) {
    return { evid: 405, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderPublishSiteCongratsPageClickOnViewSiteParams
* @property {string} adiBuilderType - --
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} pageView - all options {onboarding-1publish-congrats,onboarding-2publish-congrats,premium}
* @property {string} screenResolution - --
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - Publish Site - Congrats page - click on view site. Evid: 187.
 * Event description: Module: builder. Flow: post publish congrats page view - click on view site.

 * adiBuilderType - Type: string. Desc: --
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * pageView - Type: string. Desc: all options {onboarding-1publish-congrats,onboarding-2publish-congrats,premium}
 *
 * screenResolution - Type: string. Desc: --
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderPublishSiteCongratsPageClickOnViewSiteParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderPublishSiteCongratsPageClickOnViewSite = function (params) {
    return { evid: 187, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderCoreLoadingWizardServiceChangeStoryParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} intervalLoadTime - loading time diff from previous phase
* @property {number} loadTime - loading time till this phase
* @property {string} loadType - new site / existing site
* @property {GUID} msid - metasite id
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - core loading - wizard service - change story. Evid: 16.
 * Event description: Module: builder. Flow: phase in loading the core.

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * intervalLoadTime - Type: numeric. Desc: loading time diff from previous phase
 *
 * loadTime - Type: numeric. Desc: loading time till this phase
 *
 * loadType - Type: string. Desc: new site / existing site
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderCoreLoadingWizardServiceChangeStoryParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderCoreLoadingWizardServiceChangeStory = function (params) {
    return { evid: 16, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} mediaManagementApproveChangesInTheMediaWindowParams
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id
* @property {string} galleryType - single item/external video/ gallery organizer
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {string} mediaType - single image/image gallery/clipart/shape/bgVideo/extVideo
* @property {GUID} msid - metasite id
* @property {string} nodeId - unique number per node, in case this is a list - this is the sectionNodeId
* @property {number} numTotal - in case of gallery: number of items in gallery
* @property {string} origin - from where the media window was opened: edit panel /gallery organizer
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: mediaManagement - Approve changes in the media window. Evid: 402.
 * Event description: Module: mediaManagement. Flow: user clicks on apply and approves changes in the media panel (media gallery or media organizer). .

 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id
 *
 * galleryType - Type: string. Desc: single item/external video/ gallery organizer
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * mediaType - Type: string. Desc: single image/image gallery/clipart/shape/bgVideo/extVideo
 *
 * msid - Type: guid. Desc: metasite id
 *
 * nodeId - Type: string. Desc: unique number per node, in case this is a list - this is the sectionNodeId
 *
 * numTotal - Type: numeric. Desc: in case of gallery: number of items in gallery
 *
 * origin - Type: string. Desc: from where the media window was opened: edit panel /gallery organizer
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {mediaManagementApproveChangesInTheMediaWindowParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var mediaManagementApproveChangesInTheMediaWindow = function (params) {
    return { evid: 402, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} medBuilderMediaSettingsDropdownOpenParams
* @property {string} adiBuilderType - MED
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {GUID} msid - metasite id
* @property {number} revision - builder version
* @property {string} screenResolution - screen resolution
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
**/
/**
 * Name: MED - Builder - Media settings dropdown open. Evid: 828.
 * Event description: Module: MED. Flow: when user clicks on "settings" to replace media.

 * adiBuilderType - Type: string. Desc: MED
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 * @param {medBuilderMediaSettingsDropdownOpenParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var medBuilderMediaSettingsDropdownOpen = function (params) {
    return { evid: 828, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} sectionDesignChangeBackgroundImagePositionSuccessParams
* @property {string} adiBuilderType - null
* @property {string} designId - id of the design
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} loadTime - time until success
* @property {GUID} msid - metasite id
* @property {string} name - regular/header/list background
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
* @property {string} value - selected position (top/center/bottom_right...)
**/
/**
 * Name: sectionDesign - change background image position - success. Evid: 569.
 * Event description: Module: sectionDesign. Flow: user changes image position in background image settings - success.

 * adiBuilderType - Type: string.
 *
 * designId - Type: string. Desc: id of the design
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * loadTime - Type: numeric. Desc: time until success
 *
 * msid - Type: guid. Desc: metasite id
 *
 * name - Type: string. Desc: regular/header/list background
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 *
 * value - Type: string. Desc: selected position (top/center/bottom_right...)
 * @param {sectionDesignChangeBackgroundImagePositionSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionDesignChangeBackgroundImagePositionSuccess = function (params) {
    return { evid: 569, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderGoToEditorNotificationPageViewParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - Go to Editor - Notification page view. Evid: 156.
 * Event description: Module: builder. Flow: go to editor notification page view. .

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderGoToEditorNotificationPageViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderGoToEditorNotificationPageView = function (params) {
    return { evid: 156, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderUndoRedoSuccessParams
* @property {string} action - action type: undo/redo
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} loadTime - time in ms
* @property {GUID} msid - metasite id
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - Undo / Redo - success. Evid: 141.
 * Event description: Module: builder. Flow: undo / redo was updated successfully on stage. .

 * action - Type: string. Desc: action type: undo/redo
 *
 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * loadTime - Type: numeric. Desc: time in ms
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderUndoRedoSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderUndoRedoSuccess = function (params) {
    return { evid: 141, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} siteDesignCreatePaletteFromLogoAlgoSuccessParams
* @property {string} adiBuilderType - null
* @property {string} designId - id of the design
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} intervalLoadTime - time elapsed from last phase
* @property {number} loadTime - time elapsed from algo start
* @property {GUID} msid - metasite id
* @property {string} name - phase name: load-image / color-extract
* @property {number} num_of_colors - number of colors in the palette
* @property {string} origin - info-card / welcomeTour / clipart-settings-panel / header-panel
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: siteDesign - Create palette from logo algo success. Evid: 334.
 * Event description: Module: siteDesign. Flow: a color palette is created from the logo uploaded by the user. algo runs in background and ends successfully.

 * adiBuilderType - Type: string.
 *
 * designId - Type: string. Desc: id of the design
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * intervalLoadTime - Type: numeric. Desc: time elapsed from last phase
 *
 * loadTime - Type: numeric. Desc: time elapsed from algo start
 *
 * msid - Type: guid. Desc: metasite id
 *
 * name - Type: string. Desc: phase name: load-image / color-extract
 *
 * num_of_colors - Type: numeric. Desc: number of colors in the palette
 *
 * origin - Type: string. Desc: info-card / welcomeTour / clipart-settings-panel / header-panel
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {siteDesignCreatePaletteFromLogoAlgoSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteDesignCreatePaletteFromLogoAlgoSuccess = function (params) {
    return { evid: 334, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} medBuilderAddSectionsSuccessParams
* @property {string} adiBuilderType - MED
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} loadTime - time elapsed from Add start
* @property {GUID} msid - metasite id
* @property {number} numOfSections - number of pages
* @property {number} revision - builder version
* @property {string} screenResolution - screen resolution
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: MED - Builder - Add Sections Success. Evid: 825.
 * Event description: Module: MED. Flow: sections were added to the site.

 * adiBuilderType - Type: string. Desc: MED
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * loadTime - Type: numeric. Desc: time elapsed from Add start
 *
 * msid - Type: guid. Desc: metasite id
 *
 * numOfSections - Type: numeric. Desc: number of pages
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {medBuilderAddSectionsSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var medBuilderAddSectionsSuccess = function (params) {
    return { evid: 825, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderPublishSuccessParams
* @property {string} adiBuilderType - desktop / mobile
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {boolean} isFirst - is first publish
* @property {number} loadTime - time (in ms) elapsed since the final click on publish
* @property {GUID} msid - metasite id
* @property {number} revision - -
* @property {string} screenResolution - screen resolution
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - publish success. Evid: 24.
 * Event description: Module: builder. Flow: publish succeeded (including publish time).

 * adiBuilderType - Type: string. Desc: desktop / mobile
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * isFirst - Type: bool. Desc: is first publish
 *
 * loadTime - Type: numeric. Desc: time (in ms) elapsed since the final click on publish
 *
 * msid - Type: guid. Desc: metasite id
 *
 * revision - Type: numeric. Desc: -
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderPublishSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderPublishSuccess = function (params) {
    return { evid: 24, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} formEditorClickOnAddDuplicateFormFieldValuesParams
* @property {string} addType - new / duplicated
* @property {string} adiBuilderType - MED / desktop / headless
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} fieldName - name
* @property {string} fieldValue - value added
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} nodeId - unique number per node, in case this is a list - this is the sectionNodeId
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - -
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: formEditor - Click on Add/duplicate form field values. Evid: 484.
 * Event description: Module: contentEditor. Flow: user adds/duplicates items to the form field values.

 * addType - Type: string. Desc: new / duplicated
 *
 * adiBuilderType - Type: string. Desc: MED / desktop / headless
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * fieldName - Type: string. Desc: name
 *
 * fieldValue - Type: string. Desc: value added
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * nodeId - Type: string. Desc: unique number per node, in case this is a list - this is the sectionNodeId
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string. Desc: -
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {formEditorClickOnAddDuplicateFormFieldValuesParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var formEditorClickOnAddDuplicateFormFieldValues = function (params) {
    return { evid: 484, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} appsAppPanelCloseParams
* @property {string} adiBuilderType - mobile / desktop
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {number} revision - builder version
* @property {string} screenResolution - screen resolution
* @property {string} structureId - structure id
**/
/**
 * Name: apps - App Panel close. Evid: 456.
 * Event description: Module: apps. Flow: when closing app panel.

 * adiBuilderType - Type: string. Desc: mobile / desktop
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * structureId - Type: string. Desc: structure id
 * @param {appsAppPanelCloseParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appsAppPanelClose = function (params) {
    return { evid: 456, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} itemsManagerSetItemAsSubItemMainItemParams
* @property {string} adiBuilderType - null
* @property {string} appId - in case of tpa: app_id/blog
* @property {string} direction - subpage to main page / main page to subpage
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {string} item - pages / menu
* @property {string} itemType - page / section / document / external link etc.
* @property {GUID} msid - metasite id
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: itemsManager - Set item as SubItem/Main item. Evid: 358.
 * Event description: Module: itemsManager. Flow: user change an item to be a subitem / main item..

 * adiBuilderType - Type: string.
 *
 * appId - Type: string. Desc: in case of tpa: app_id/blog
 *
 * direction - Type: string. Desc: subpage to main page / main page to subpage
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * item - Type: string. Desc: pages / menu
 *
 * itemType - Type: string. Desc: page / section / document / external link etc.
 *
 * msid - Type: guid. Desc: metasite id
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {itemsManagerSetItemAsSubItemMainItemParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var itemsManagerSetItemAsSubItemMainItem = function (params) {
    return { evid: 358, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} pagesManagerDuplicatePageSuccessParams
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} loadTime - time in ms
* @property {GUID} msid - metasite id
* @property {string} originPageId - number of origin page
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: pagesManager - Duplicate page success. Evid: 355.
 * Event description: Module: pagesManager. Flow: page duplicated successfully.

 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * loadTime - Type: numeric. Desc: time in ms
 *
 * msid - Type: guid. Desc: metasite id
 *
 * originPageId - Type: string. Desc: number of origin page
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {pagesManagerDuplicatePageSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pagesManagerDuplicatePageSuccess = function (params) {
    return { evid: 355, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} pagesManagerDeletePageSuccessParams
* @property {string} adiBuilderType - null
* @property {string} appId - in case of tpa: app_id/blog
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} loadTime - time in ms
* @property {GUID} msid - metasite id
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: pagesManager - Delete page - success. Evid: 360.
 * Event description: Module: pagesManager. Flow: user clicks on delete and the page is deleted. .

 * adiBuilderType - Type: string.
 *
 * appId - Type: string. Desc: in case of tpa: app_id/blog
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * loadTime - Type: numeric. Desc: time in ms
 *
 * msid - Type: guid. Desc: metasite id
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {pagesManagerDeletePageSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pagesManagerDeletePageSuccess = function (params) {
    return { evid: 360, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} contentEditorPanelIsLoadedParams
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} nodeId - unique number per node, in case this is a list - this is the sectionNodeId
* @property {string} objectType - single / list / field
* @property {string} pageId - number of page
* @property {string} panelType - main / list item / social panel / media settings
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} source - how the panel was opened - button/switch section/ double click / click on specific item / menu edit
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: contentEditor - Panel is loaded. Evid: 200.
 * Event description: Module: contentEditor. Flow: content editor panel is loaded. E.g., edit, list item and media settings panels. It doesn't include popup dialogs.. .

 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * nodeId - Type: string. Desc: unique number per node, in case this is a list - this is the sectionNodeId
 *
 * objectType - Type: string. Desc: single / list / field
 *
 * pageId - Type: string. Desc: number of page
 *
 * panelType - Type: string. Desc: main / list item / social panel / media settings
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * source - Type: string. Desc: how the panel was opened - button/switch section/ double click / click on specific item / menu edit
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {contentEditorPanelIsLoadedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var contentEditorPanelIsLoaded = function (params) {
    return { evid: 200, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderLinkDialogClosedParams
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} nodeId - unique number per node, in case this is a list - this is the sectionNodeId
* @property {string} pageId - number of page
* @property {string} panelType - main / list item / social panel / media settings
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} source - from where the user edit the link {button/richText / menu item}
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - Link dialog - closed. Evid: 214.
 * Event description: Module: builder. Flow: user clicks on the x or the cancel buttons in the 'link to' window..

 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * nodeId - Type: string. Desc: unique number per node, in case this is a list - this is the sectionNodeId
 *
 * pageId - Type: string. Desc: number of page
 *
 * panelType - Type: string. Desc: main / list item / social panel / media settings
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * source - Type: string. Desc: from where the user edit the link {button/richText / menu item}
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderLinkDialogClosedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderLinkDialogClosed = function (params) {
    return { evid: 214, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} contentEditorItemMovedToAnotherPageSuccessParams
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} loadTime - time in ms
* @property {GUID} msid - metasite id
* @property {string} nodeId - unique number per node, in case this is a list - this is the sectionNodeId
* @property {string} originPageId - number of origin page
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: contentEditor - Item moved to another page - success. Evid: 220.
 * Event description: Module: contentEditor. Flow: item moved to a page successfully. .

 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * loadTime - Type: numeric. Desc: time in ms
 *
 * msid - Type: guid. Desc: metasite id
 *
 * nodeId - Type: string. Desc: unique number per node, in case this is a list - this is the sectionNodeId
 *
 * originPageId - Type: string. Desc: number of origin page
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {contentEditorItemMovedToAnotherPageSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var contentEditorItemMovedToAnotherPageSuccess = function (params) {
    return { evid: 220, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} medHeadlessWrapperRequestSuccessParams
* @property {string} adiBuilderType - headless
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} loadTime - time elapsed (in ms) from trial
* @property {string} name - warmup/update/build/publish
* @property {string} screenResolution - screen resolution
* @property {string} structureId - structure id
**/
/**
 * Name: MED - Headless Server Request Success. Evid: 811.
 * Event description: Module: MED. Flow: Headless Wrapper request (Warmup, Update, Build, Publish) returns successfully.

 * adiBuilderType - Type: string. Desc: headless
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * loadTime - Type: numeric. Desc: time elapsed (in ms) from trial
 *
 * name - Type: string. Desc: warmup/update/build/publish
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * structureId - Type: string. Desc: structure id
 * @param {medHeadlessWrapperRequestSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var medHeadlessWrapperRequestSuccess = function (params) {
    return { evid: 811, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} siteDesignChangeFontSizeClickParams
* @property {string} adiBuilderType - null
* @property {string} designId - id of the design
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} fontSize - font size
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} setId - unique identifier of the font set
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: siteDesign - Change font size - click. Evid: 328.
 * Event description: Module: siteDesign. Flow: user changes font size.

 * adiBuilderType - Type: string.
 *
 * designId - Type: string. Desc: id of the design
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * fontSize - Type: string. Desc: font size
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * setId - Type: string. Desc: unique identifier of the font set
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {siteDesignChangeFontSizeClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteDesignChangeFontSizeClick = function (params) {
    return { evid: 328, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} sectionDesignBackgroundPanelOpenedParams
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} name - regular/header/list background
* @property {string} origin - how panel was opened {section panel, content panel}
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: sectionDesign - Background panel opened. Evid: 561.
 * Event description: Module: sectionDesign. Flow: user opens section background panel.

 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * name - Type: string. Desc: regular/header/list background
 *
 * origin - Type: string. Desc: how panel was opened {section panel, content panel}
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {sectionDesignBackgroundPanelOpenedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionDesignBackgroundPanelOpened = function (params) {
    return { evid: 561, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderPreviewSiteSwitchToMobileDesktopViewParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {string} mode - preview in welcome tour / preview in builder
* @property {GUID} msid - metasite id
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
* @property {string} viewMode - mobile / desktop
**/
/**
 * Name: builder - Preview Site - Switch to Mobile/Desktop view. Evid: 161.
 * Event description: Module: builder. Flow: user switches between desktop and mobile view. .

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * mode - Type: string. Desc: preview in welcome tour / preview in builder
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 *
 * viewMode - Type: string. Desc: mobile / desktop
 * @param {builderPreviewSiteSwitchToMobileDesktopViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderPreviewSiteSwitchToMobileDesktopView = function (params) {
    return { evid: 161, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} sectionManagementMoveSectionWithinThePageStartDraggingParams
* @property {string} adiBuilderType - null
* @property {string} appId - in case of tpa: app_id/blog
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} nodeId - unique number per node
* @property {number} originPosition - new position of section in page
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: sectionManagement - Move Section within the page - Start dragging. Evid: 259.
 * Event description: Module: sectionManagement. Flow: user chooses a section to move within the page and start to drag it. Evid 260 will represent drag-complete..

 * adiBuilderType - Type: string.
 *
 * appId - Type: string. Desc: in case of tpa: app_id/blog
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * nodeId - Type: string. Desc: unique number per node
 *
 * originPosition - Type: numeric. Desc: new position of section in page
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {sectionManagementMoveSectionWithinThePageStartDraggingParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionManagementMoveSectionWithinThePageStartDragging = function (params) {
    return { evid: 259, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} sectionManagementClickOnMoreActionsMenuParams
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {number} placeOfSelected - not relevant
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} selectedLayout - not relevant
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: sectionManagement - Click on "More Actions" menu. Evid: 270.
 * Event description: Module: sectionManagement. Flow: User clicks on the "more actions"  small menu on the right of a section.

 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * placeOfSelected - Type: numeric. Desc: not relevant
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * selectedLayout - Type: string. Desc: not relevant
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {sectionManagementClickOnMoreActionsMenuParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionManagementClickOnMoreActionsMenu = function (params) {
    return { evid: 270, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderConnectDomainPageViewParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} referral - origin of page view: 1st publish / top bar
* @property {string} referralAdditionalInfo - --
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - Connect Domain - page view. Evid: 151.
 * Event description: Module: builder. Flow: connect domain page view (x/ maybe later). .

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * referral - Type: string. Desc: origin of page view: 1st publish / top bar
 *
 * referralAdditionalInfo - Type: string. Desc: --
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderConnectDomainPageViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderConnectDomainPageView = function (params) {
    return { evid: 151, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} loadingFirstTimeInitDataGenerateInitialContentParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} intervalLoadTime - loading time diff from previous phase
* @property {number} loadTime - loading time till this phase
* @property {GUID} msid - metasite id
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: loading - first time - Init Data: Generate initial content. Evid: 130.
 * Event description: Module: builder. Flow: phase in opening the builder (first time) started..

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * intervalLoadTime - Type: numeric. Desc: loading time diff from previous phase
 *
 * loadTime - Type: numeric. Desc: loading time till this phase
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {loadingFirstTimeInitDataGenerateInitialContentParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var loadingFirstTimeInitDataGenerateInitialContent = function (params) {
    return { evid: 130, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderCoreLoadingWizardServiceCoreInitializeStartParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} intervalLoadTime - loading time diff from previous phase
* @property {number} loadTime - loading time till this phase
* @property {string} loadType - new site / existing site
* @property {GUID} msid - metasite id
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - core loading - wizard service - core initialize start. Evid: 12.
 * Event description: Module: builder. Flow: phase in loading the core: load layouts, load preview, theme chooser, layout solver.

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * intervalLoadTime - Type: numeric. Desc: loading time diff from previous phase
 *
 * loadTime - Type: numeric. Desc: loading time till this phase
 *
 * loadType - Type: string. Desc: new site / existing site
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderCoreLoadingWizardServiceCoreInitializeStartParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderCoreLoadingWizardServiceCoreInitializeStart = function (params) {
    return { evid: 12, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} mediaManagementExternalVideoSearchVideoClickParams
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} nodeId - unique number per node, in case this is a list - this is the sectionNodeId
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} source - video source: vimeo / youtube
* @property {string} structureId - structure id
* @property {string} text - search term
* @property {GUID} uuid - user id
**/
/**
 * Name: mediaManagement - External Video - Search video click. Evid: 406.
 * Event description: Module: mediaManagement. Flow: user clicks on the search button in the extVideo gallery. .

 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * nodeId - Type: string. Desc: unique number per node, in case this is a list - this is the sectionNodeId
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * source - Type: string. Desc: video source: vimeo / youtube
 *
 * structureId - Type: string. Desc: structure id
 *
 * text - Type: string. Desc: search term
 *
 * uuid - Type: guid. Desc: user id
 * @param {mediaManagementExternalVideoSearchVideoClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var mediaManagementExternalVideoSearchVideoClick = function (params) {
    return { evid: 406, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} introSiteConverterErrorIsShownParams
* @property {string} adiBuilderType - NA
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} mainCategory - the category from the 'vertical selector' category that the user chose
* @property {string} name - error name
* @property {string} screenResolution - screen resolution
* @property {GUID} uuid - user id
* @property {string} view - page name
**/
/**
 * Name: intro - Site Converter - error is shown. Evid: 122.
 * Event description: Module: intro. Flow: error is shown to user during Site Converter process.

 * adiBuilderType - Type: string. Desc: NA
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * mainCategory - Type: string. Desc: the category from the 'vertical selector' category that the user chose
 *
 * name - Type: string. Desc: error name
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * uuid - Type: guid. Desc: user id
 *
 * view - Type: string. Desc: page name
 * @param {introSiteConverterErrorIsShownParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var introSiteConverterErrorIsShown = function (params) {
    return { evid: 122, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} loadingFirstTimeCreateStoryGetUniqueNameParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} intervalLoadTime - loading time diff from previous phase
* @property {number} loadTime - loading time till this phase
* @property {GUID} msid - metasite id
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: loading - first time - CreateStory: Get Unique name. Evid: 126.
 * Event description: Module: builder. Flow: phase 1 in opening the builder (first time) started..

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * intervalLoadTime - Type: numeric. Desc: loading time diff from previous phase
 *
 * loadTime - Type: numeric. Desc: loading time till this phase
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {loadingFirstTimeCreateStoryGetUniqueNameParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var loadingFirstTimeCreateStoryGetUniqueName = function (params) {
    return { evid: 126, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} medBuilderDownloadOneAppClickParams
* @property {string} adiBuilderType - MED
* @property {GUID} appId - app id if source is manage app
* @property {string} appName - app name if source is manage app
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {string} isWixAppInstalled - true/false
* @property {GUID} msid - metasite id
* @property {number} revision - builder version
* @property {string} screenResolution - screen_resolution
* @property {string} source - more/manage-app
* @property {string} structureId - structure id
**/
/**
 * Name: MED - Builder - Download/Open OneApp click. Evid: 830.
 * Event description: Module: MED. Flow: user clicks on Get/Open Wix App.

 * adiBuilderType - Type: string. Desc: MED
 *
 * appId - Type: guid. Desc: app id if source is manage app
 *
 * appName - Type: string. Desc: app name if source is manage app
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * isWixAppInstalled - Type: string. Desc: true/false
 *
 * msid - Type: guid. Desc: metasite id
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string. Desc: screen_resolution
 *
 * source - Type: string. Desc: more/manage-app
 *
 * structureId - Type: string. Desc: structure id
 * @param {medBuilderDownloadOneAppClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var medBuilderDownloadOneAppClick = function (params) {
    return { evid: 830, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} sectionManagementChangeSectionLayoutSuccessParams
* @property {string} adiBuilderType - null
* @property {string} appId - in case of tpa: app_id/blog
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {boolean} is_columns - flag for columns in selected layout
* @property {number} loadTime - time in ms
* @property {GUID} msid - metasite id
* @property {number} noOfRecommendedViewed - number of recommended layouts viewed by the user (by scrolling down the list)
* @property {number} noOfSuggestions - int number that represents the number of suggested layouts that the user saw
* @property {number} noOfSuggestionsViewed - **deprecated**
* @property {string} nodeId - unique number per node
* @property {string} pageId - number of page
* @property {string} place - recommended / others
* @property {number} placeOfSelected - int number that represents the place of the selected layout (1 for the first,…)
* @property {string} previousLayout - the previous layout id (before the change)
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} selectedLayout - layout id
* @property {string} source - where was the panel opened from {section/content - bg hidden}
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: sectionManagement - Change section layout - success. Evid: 252.
 * Event description: Module: sectionManagement. Flow: selected layout changed and updated on the stage..

 * adiBuilderType - Type: string.
 *
 * appId - Type: string. Desc: in case of tpa: app_id/blog
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * is_columns - Type: bool. Desc: flag for columns in selected layout
 *
 * loadTime - Type: numeric. Desc: time in ms
 *
 * msid - Type: guid. Desc: metasite id
 *
 * noOfRecommendedViewed - Type: numeric. Desc: number of recommended layouts viewed by the user (by scrolling down the list)
 *
 * noOfSuggestions - Type: numeric. Desc: int number that represents the number of suggested layouts that the user saw
 *
 * noOfSuggestionsViewed - Type: numeric. Desc: **deprecated**
 *
 * nodeId - Type: string. Desc: unique number per node
 *
 * pageId - Type: string. Desc: number of page
 *
 * place - Type: string. Desc: recommended / others
 *
 * placeOfSelected - Type: numeric. Desc: int number that represents the place of the selected layout (1 for the first,…)
 *
 * previousLayout - Type: string. Desc: the previous layout id (before the change)
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * selectedLayout - Type: string. Desc: layout id
 *
 * source - Type: string. Desc: where was the panel opened from {section/content - bg hidden}
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {sectionManagementChangeSectionLayoutSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionManagementChangeSectionLayoutSuccess = function (params) {
    return { evid: 252, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} contentEditorQuickActionClickParams
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} fieldName - which field is selected: title,subtitle,body,image,button,logo, list item etc.
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} name - the name of action clicked (hide/edit/settings etc.)
* @property {string} nodeId - unique number per node, in case this is a list - this is the sectionNodeId
* @property {string} origin - where the action was made from: double click/OSI dropdown
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: contentEditor - quick action click. Evid: 236.
 * Event description: Module: contentEditor. Flow: user performs a quick action from the OSI/right click dropdown or double clicking on a component.

 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * fieldName - Type: string. Desc: which field is selected: title,subtitle,body,image,button,logo, list item etc.
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * name - Type: string. Desc: the name of action clicked (hide/edit/settings etc.)
 *
 * nodeId - Type: string. Desc: unique number per node, in case this is a list - this is the sectionNodeId
 *
 * origin - Type: string. Desc: where the action was made from: double click/OSI dropdown
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {contentEditorQuickActionClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var contentEditorQuickActionClick = function (params) {
    return { evid: 236, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} sectionDesignChangeFormDesignClickParams
* @property {string} adiBuilderType - desktop / mobile/ MED....
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} origin - OSI
* @property {string} screenResolution - screen_resolution
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: sectionDesign - change form design click. Evid: 584.
 * Event description: Module: sectionDesign. Flow: user changes form's design.

 * adiBuilderType - Type: string. Desc: desktop / mobile/ MED....
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * origin - Type: string. Desc: OSI
 *
 * screenResolution - Type: string. Desc: screen_resolution
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {sectionDesignChangeFormDesignClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionDesignChangeFormDesignClick = function (params) {
    return { evid: 584, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} clickOnReplaceLogoIntroWelcomeTourBuilderParams
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / no-tour
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} name - name of tour: welcome / preview / design-entire website / design-fonts&colors / edit section / add section / add page
* @property {string} origin - origin of action: intro / welcomeTour-before-extraction / welcomeTour-after-extraction / header-panel / clipart-settings-panel
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: Click on Replace Logo (intro / welcomeTour / builder). Evid: 117.
 * Event description: Module: tour. Flow: user clicked on replace logo button in the intro / welcomeTour / builder.

 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / no-tour
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * name - Type: string. Desc: name of tour: welcome / preview / design-entire website / design-fonts&colors / edit section / add section / add page
 *
 * origin - Type: string. Desc: origin of action: intro / welcomeTour-before-extraction / welcomeTour-after-extraction / header-panel / clipart-settings-panel
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {clickOnReplaceLogoIntroWelcomeTourBuilderParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var clickOnReplaceLogoIntroWelcomeTourBuilder = function (params) {
    return { evid: 117, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} loadingExistingSiteLoadStoryLoadStoryParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} intervalLoadTime - loading time diff from previous phase
* @property {number} loadTime - loading time till this phase
* @property {GUID} msid - metasite id
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: loading - existing site - LoadStory: Load story. Evid: 511.
 * Event description: Module: builder. Flow: phase in opening the builder (existing site) started..

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * intervalLoadTime - Type: numeric. Desc: loading time diff from previous phase
 *
 * loadTime - Type: numeric. Desc: loading time till this phase
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {loadingExistingSiteLoadStoryLoadStoryParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var loadingExistingSiteLoadStoryLoadStory = function (params) {
    return { evid: 511, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} contentEditorChangeButtonStyleClickParams
* @property {string} adiBuilderType - desktop/mobile
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} nodeId - unique number per node, in case this is a list - this is the sectionNodeId
* @property {string} objectType - single / list / ..
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - screen resolution
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {number} styleIndex - position on panel
* @property {GUID} uuid - user id
**/
/**
 * Name: contentEditor - change button style click. Evid: 243.
 * Event description: Module: contentEditor. Flow: user chooses another style for a button.

 * adiBuilderType - Type: string. Desc: desktop/mobile
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * nodeId - Type: string. Desc: unique number per node, in case this is a list - this is the sectionNodeId
 *
 * objectType - Type: string. Desc: single / list / ..
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * styleIndex - Type: numeric. Desc: position on panel
 *
 * uuid - Type: guid. Desc: user id
 * @param {contentEditorChangeButtonStyleClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var contentEditorChangeButtonStyleClick = function (params) {
    return { evid: 243, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} tourSkipTourParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} name - name of tour
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: tour - Skip Tour. Evid: 54.
 * Event description: Module: tour. Flow: user skips a tour. .

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * name - Type: string. Desc: name of tour
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {tourSkipTourParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tourSkipTour = function (params) {
    return { evid: 54, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} loadingFirstTimeCreateTpaParams
* @property {string} adiBuilderType - null
* @property {GUID} appId - tpa app id
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} intervalLoadTime - loading time diff from previous phase
* @property {number} loadTime - loading time till this phase
* @property {GUID} msid - metasite id
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: loading - first time - create tpa. Evid: 132.
 * Event description: Module: builder. Flow: phase in opening the builder (first time) started..

 * adiBuilderType - Type: string.
 *
 * appId - Type: guid. Desc: tpa app id
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * intervalLoadTime - Type: numeric. Desc: loading time diff from previous phase
 *
 * loadTime - Type: numeric. Desc: loading time till this phase
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {loadingFirstTimeCreateTpaParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var loadingFirstTimeCreateTpa = function (params) {
    return { evid: 132, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} sectionDesignChangeScrollAnimationClickParams
* @property {string} adiBuilderType - null
* @property {string} alias - label (name the user sees) of animation: none, parallax, reveal ...
* @property {string} designId - id of the design
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} name - name of animation
* @property {string} origin - OSI / right click
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: sectionDesign - change scroll animation - click. Evid: 559.
 * Event description: Module: sectionDesign. Flow: user changes section scroll animation.

 * adiBuilderType - Type: string.
 *
 * alias - Type: string. Desc: label (name the user sees) of animation: none, parallax, reveal ...
 *
 * designId - Type: string. Desc: id of the design
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * name - Type: string. Desc: name of animation
 *
 * origin - Type: string. Desc: OSI / right click
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {sectionDesignChangeScrollAnimationClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionDesignChangeScrollAnimationClick = function (params) {
    return { evid: 559, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderCoreLoadingWizardServiceLoadPreviewParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} intervalLoadTime - loading time diff from previous phase
* @property {number} loadTime - loading time till this phase
* @property {string} loadType - new site / existing site
* @property {GUID} msid - metasite id
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - core loading - wizard service - load preview. Evid: 13.
 * Event description: Module: builder. Flow: phase in loading the core.

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * intervalLoadTime - Type: numeric. Desc: loading time diff from previous phase
 *
 * loadTime - Type: numeric. Desc: loading time till this phase
 *
 * loadType - Type: string. Desc: new site / existing site
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderCoreLoadingWizardServiceLoadPreviewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderCoreLoadingWizardServiceLoadPreview = function (params) {
    return { evid: 13, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} pagesManagerPagePermissionsPanelFieldWasUpdatedParams
* @property {string} adiBuilderType - MED / desktop
* @property {string} appId - in case of tpa: app_id/blog
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {number} fieldLength - length of text in the field (when relevant)
* @property {string} fieldName - which field is updated: title,description,keywords,show in page results, page url
* @property {string} fieldType - text/ boolea button / link
* @property {string} fieldValue - value selected - only for show in seach results - true / false
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} pageId - number of page
* @property {string} pageType - pageType = {TPA / General / Members / Members area - private / Members area -  public}
* @property {number} revision - builder version
* @property {string} screenResolution - -
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: pagesManager - Page permissions panel - field was updated. Evid: 377.
 * Event description: Module: pagesManager. Flow: field was updated in the Page permissions  panel.

 * adiBuilderType - Type: string. Desc: MED / desktop
 *
 * appId - Type: string. Desc: in case of tpa: app_id/blog
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * fieldLength - Type: numeric. Desc: length of text in the field (when relevant)
 *
 * fieldName - Type: string. Desc: which field is updated: title,description,keywords,show in page results, page url
 *
 * fieldType - Type: string. Desc: text/ boolea button / link
 *
 * fieldValue - Type: string. Desc: value selected - only for show in seach results - true / false
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * pageId - Type: string. Desc: number of page
 *
 * pageType - Type: string. Desc: pageType = {TPA / General / Members / Members area - private / Members area -  public}
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string. Desc: -
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {pagesManagerPagePermissionsPanelFieldWasUpdatedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pagesManagerPagePermissionsPanelFieldWasUpdated = function (params) {
    return { evid: 377, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderTopBarHelpClickParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {number} revision - -
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - Top Bar - Help click. Evid: 142.
 * Event description: Module: builder. Flow: user clicks on help. .

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * revision - Type: numeric. Desc: -
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderTopBarHelpClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderTopBarHelpClick = function (params) {
    return { evid: 142, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} itemManagerPagesMenuPanelWasClosedParams
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {string} item - menu / pages
* @property {GUID} msid - metasite id
* @property {string} name - name of closed window - add page / seo / pages panel
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: ItemManager - Pages/menu panel was closed. Evid: 366.
 * Event description: Module: ItemManager. Flow: user closes the pages/menu panel..

 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * item - Type: string. Desc: menu / pages
 *
 * msid - Type: guid. Desc: metasite id
 *
 * name - Type: string. Desc: name of closed window - add page / seo / pages panel
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {itemManagerPagesMenuPanelWasClosedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var itemManagerPagesMenuPanelWasClosed = function (params) {
    return { evid: 366, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} siteDesignClickOnDesiredDesignParams
* @property {string} adiBuilderType - null
* @property {string} designId - id of the design
* @property {number} designNumber - what's the number of the selected design in the list: 1,2,…,
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {number} noOfDesigns - how many designs there are
* @property {string} origin - how the panel is loaded: header / back from customize
* @property {string} prevDesignId - id of previous design
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {string} targetDesignId - target design id, replacing the 'designId' param in this event
* @property {GUID} uuid - user id
**/
/**
 * Name: siteDesign - Click on desired design. Evid: 301.
 * Event description: Module: siteDesign. Flow: user switches design..

 * adiBuilderType - Type: string.
 *
 * designId - Type: string. Desc: id of the design
 *
 * designNumber - Type: numeric. Desc: what's the number of the selected design in the list: 1,2,…,
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * noOfDesigns - Type: numeric. Desc: how many designs there are
 *
 * origin - Type: string. Desc: how the panel is loaded: header / back from customize
 *
 * prevDesignId - Type: string. Desc: id of previous design
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * targetDesignId - Type: string. Desc: target design id, replacing the 'designId' param in this event
 *
 * uuid - Type: guid. Desc: user id
 * @param {siteDesignClickOnDesiredDesignParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteDesignClickOnDesiredDesign = function (params) {
    return { evid: 301, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} contentEditorImageCropSaveParams
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} nodeId - unique number per node, in case this is a list - this is the sectionNodeId
* @property {string} objectType - single / list / field
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
**/
/**
 * Name: contentEditor - Image Crop - save. Evid: 233.
 * Event description: Module: contentEditor. Flow: user saves the crop changes.

 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * nodeId - Type: string. Desc: unique number per node, in case this is a list - this is the sectionNodeId
 *
 * objectType - Type: string. Desc: single / list / field
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 * @param {contentEditorImageCropSaveParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var contentEditorImageCropSave = function (params) {
    return { evid: 233, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} sectionDesignChangeColorSuccessParams
* @property {string} adiBuilderType - null
* @property {string} designId - id of the design
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} loadTime - time in ms to change color
* @property {GUID} msid - metasite id
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: sectionDesign - change color - success. Evid: 552.
 * Event description: Module: sectionDesign. Flow: user changes section color - success.

 * adiBuilderType - Type: string.
 *
 * designId - Type: string. Desc: id of the design
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * loadTime - Type: numeric. Desc: time in ms to change color
 *
 * msid - Type: guid. Desc: metasite id
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {sectionDesignChangeColorSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionDesignChangeColorSuccess = function (params) {
    return { evid: 552, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} itemsManagerRenameItemParams
* @property {string} adiBuilderType - null
* @property {string} appId - in case of tpa: app_id/blog
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {string} item - pages / menu
* @property {string} itemType - page / section / document / external link etc.
* @property {GUID} msid - metasite id
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: ItemsManager - Rename item. Evid: 357.
 * Event description: Module: ItemsManager. Flow: user clicks on rename item in menu/pages panel..

 * adiBuilderType - Type: string.
 *
 * appId - Type: string. Desc: in case of tpa: app_id/blog
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * item - Type: string. Desc: pages / menu
 *
 * itemType - Type: string. Desc: page / section / document / external link etc.
 *
 * msid - Type: guid. Desc: metasite id
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {itemsManagerRenameItemParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var itemsManagerRenameItem = function (params) {
    return { evid: 357, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} sectionDesignSectionHeightChangeClickParams
* @property {string} adiBuilderType - desktop / mobile
* @property {string} changeHeightAction - longer / shorter
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {number} revision - builder version
* @property {string} screenResolution - screen resolution
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {number} sectionHeight - height of the section after action
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: sectionDesign - Section Height change click. Evid: 578.
 * Event description: Module: sectionDesign. Flow: user changes section height using section height buttons.

 * adiBuilderType - Type: string. Desc: desktop / mobile
 *
 * changeHeightAction - Type: string. Desc: longer / shorter
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionHeight - Type: numeric. Desc: height of the section after action
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {sectionDesignSectionHeightChangeClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionDesignSectionHeightChangeClick = function (params) {
    return { evid: 578, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} sectionManagementPlanToAddTpaInWelcomeTourParams
* @property {string} adiBuilderType - null
* @property {string} appId - in case of tpa: app_id
* @property {string} appName - the app name
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} screenResolution - null
* @property {string} source - recommended , intro
* @property {GUID} uuid - user id
**/
/**
 * Name: sectionManagement - plan to add tpa in welcome tour. Evid: 271.
 * Event description: Module: sectionManagement. Flow: sent for each tpa that is about to be added in the welcome tour, based on user selection and CMS.

 * adiBuilderType - Type: string.
 *
 * appId - Type: string. Desc: in case of tpa: app_id
 *
 * appName - Type: string. Desc: the app name
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string.
 *
 * source - Type: string. Desc: recommended , intro
 *
 * uuid - Type: guid. Desc: user id
 * @param {sectionManagementPlanToAddTpaInWelcomeTourParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionManagementPlanToAddTpaInWelcomeTour = function (params) {
    return { evid: 271, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} siteDesignClickOnDesiredFontParams
* @property {string} adiBuilderType - null
* @property {string} designId - id of the design
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} name - sub panel name:  font set
* @property {number} noOfSets - how many color/font sets there are
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} setId - unique identifier of the color/font set
* @property {number} setNumber - what's the number of the selected color/font set in the list: 1,2,…,35
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: siteDesign - Click on desired font. Evid: 305.
 * Event description: Module: siteDesign. Flow: user chooses a color/font set..

 * adiBuilderType - Type: string.
 *
 * designId - Type: string. Desc: id of the design
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * name - Type: string. Desc: sub panel name:  font set
 *
 * noOfSets - Type: numeric. Desc: how many color/font sets there are
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * setId - Type: string. Desc: unique identifier of the color/font set
 *
 * setNumber - Type: numeric. Desc: what's the number of the selected color/font set in the list: 1,2,…,35
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {siteDesignClickOnDesiredFontParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteDesignClickOnDesiredFont = function (params) {
    return { evid: 305, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} introGenericCategoryDialogIsShownParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} flow - main funnel/adi intro
* @property {string} mainCategory - the category from the 'vertical selector' category that the user chose
* @property {string} screenResolution - null
* @property {string} text - searched text
* @property {GUID} uuid - user id
**/
/**
 * Name: intro - Generic category dialog is shown. Evid: 118.
 * Event description: Module: intro. Flow: user types a 'missing' category and the generic business category dialog is shown.

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * flow - Type: string. Desc: main funnel/adi intro
 *
 * mainCategory - Type: string. Desc: the category from the 'vertical selector' category that the user chose
 *
 * screenResolution - Type: string.
 *
 * text - Type: string. Desc: searched text
 *
 * uuid - Type: guid. Desc: user id
 * @param {introGenericCategoryDialogIsShownParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var introGenericCategoryDialogIsShown = function (params) {
    return { evid: 118, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} appsAddNewTpaPageStartParams
* @property {string} adiBuilderType - desktop/mobile....
* @property {string} appId - in case of tpa: app_id/blog
* @property {string} appInstanceId - unique identifier of app (store, bookings, etc.) instance in site
* @property {string} appPageType - some app pages are added automaically by the app: by user / by app
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} nodeId - unique number per node
* @property {string} origin - apps panel / sections panel / biz manager
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - screen resolution
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: apps - Add new TPA page - start. Evid: 458.
 * Event description: Module: apps. Flow: when a new TPA page need to be added to the site.

 * adiBuilderType - Type: string. Desc: desktop/mobile....
 *
 * appId - Type: string. Desc: in case of tpa: app_id/blog
 *
 * appInstanceId - Type: string. Desc: unique identifier of app (store, bookings, etc.) instance in site
 *
 * appPageType - Type: string. Desc: some app pages are added automaically by the app: by user / by app
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * nodeId - Type: string. Desc: unique number per node
 *
 * origin - Type: string. Desc: apps panel / sections panel / biz manager
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {appsAddNewTpaPageStartParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appsAddNewTpaPageStart = function (params) {
    return { evid: 458, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} medBuilderStartsLoadingParams
* @property {string} adiBuilderType - MED
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {GUID} msid - metasite id
* @property {number} revision - -
* @property {string} screenResolution - screen_resolution
* @property {string} structureId - structure id
* @property {string} type - new / existing
* @property {GUID} uuid - user id
**/
/**
 * Name: MED - Builder - starts loading. Evid: 835.
 * Event description: Module: MED. Flow: builder application starts loading.

 * adiBuilderType - Type: string. Desc: MED
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * revision - Type: numeric. Desc: -
 *
 * screenResolution - Type: string. Desc: screen_resolution
 *
 * structureId - Type: string. Desc: structure id
 *
 * type - Type: string. Desc: new / existing
 *
 * uuid - Type: guid. Desc: user id
 * @param {medBuilderStartsLoadingParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var medBuilderStartsLoading = function (params) {
    return { evid: 835, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} appsClickOnEditAppTpaSettingsParams
* @property {string} adiBuilderType - null
* @property {GUID} appId - app_id, like: 61F33D50-3002-4882-AE86-D319C1A249AB = blog
* @property {string} appInstanceId - unique identifier of app (store, bookings, etc.) instance in site
* @property {string} appName - blog, Store, Booking
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} origin - panel / header
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} source - section / top-bar...
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: apps - Click on Edit App - TPA settings. Evid: 453.
 * Event description: Module: apps. Flow: user clicks on edit app button, which opens the TPA settings..

 * adiBuilderType - Type: string.
 *
 * appId - Type: guid. Desc: app_id, like: 61F33D50-3002-4882-AE86-D319C1A249AB = blog
 *
 * appInstanceId - Type: string. Desc: unique identifier of app (store, bookings, etc.) instance in site
 *
 * appName - Type: string. Desc: blog, Store, Booking
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * origin - Type: string. Desc: panel / header
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * source - Type: string. Desc: section / top-bar...
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {appsClickOnEditAppTpaSettingsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appsClickOnEditAppTpaSettings = function (params) {
    return { evid: 453, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} medBuilderPanelLoadedParams
* @property {string} adiBuilderType - MED
* @property {GUID} esi - editor session id, for every site editing session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} name - pages / add page / design / more / add section
* @property {string} nodeId - unique number per node, in case this is a list - this is the sectionNodeId
* @property {string} origin - how the panel was opened - main menu, other panel, button
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - screen resolution
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
**/
/**
 * Name: MED - Builder - Panel loaded. Evid: 820.
 * Event description: Module: MED. user opens a panel.

 * adiBuilderType - Type: string. Desc: MED
 *
 * esi - Type: guid. Desc: editor session id, for every site editing session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * name - Type: string. Desc: pages / add page / design / more / add section
 *
 * nodeId - Type: string. Desc: unique number per node, in case this is a list - this is the sectionNodeId
 *
 * origin - Type: string. Desc: how the panel was opened - main menu, other panel, button
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 * @param {medBuilderPanelLoadedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var medBuilderPanelLoaded = function (params) {
    return { evid: 820, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} mediaManagementPhotoStudioWindowIsLoadedParams
* @property {string} adiBuilderType - -
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} origin - OSI / media settings
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - -
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: mediaManagement - Photo studio window is loaded. Evid: 398.
 * Event description: Module: mediaManagement. Flow: photo studio is loaded.

 * adiBuilderType - Type: string. Desc: -
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * origin - Type: string. Desc: OSI / media settings
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string. Desc: -
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {mediaManagementPhotoStudioWindowIsLoadedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var mediaManagementPhotoStudioWindowIsLoaded = function (params) {
    return { evid: 398, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} siteDesignClickOnDesiredPaletteFromCustomizePalleteParams
* @property {string} adiBuilderType - null
* @property {string} colorationLevel - {plain, tinted,  colorful, vibrant, none}
* @property {string} designId - id of the design
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {number} noOfSets - The number of palettes to choose from, including Logo, Custom and Recommended Palettes
* @property {number} num_of_colors - number of colors in the palette
* @property {string} origin - welcomeTour / header-panel / clipart-settings-panel / customize-palette-panel
* @property {string} palleteCreator - server(magic), default,custom,calculated, logo
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {number} setNumber - The index of the chosen palette, where -1 means logo palette, and 0 or above means index in list of custom (if exists) or calculated palettes
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: siteDesign - Click on desired palette from customize pallete. Evid: 314.
 * Event description: Module: siteDesign. Flow: user chooses a palette in customize pallette panel.

 * adiBuilderType - Type: string.
 *
 * colorationLevel - Type: string. Desc: {plain, tinted,  colorful, vibrant, none}
 *
 * designId - Type: string. Desc: id of the design
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * noOfSets - Type: numeric. Desc: The number of palettes to choose from, including Logo, Custom and Recommended Palettes
 *
 * num_of_colors - Type: numeric. Desc: number of colors in the palette
 *
 * origin - Type: string. Desc: welcomeTour / header-panel / clipart-settings-panel / customize-palette-panel
 *
 * palleteCreator - Type: string. Desc: server(magic), default,custom,calculated, logo
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * setNumber - Type: numeric. Desc: The index of the chosen palette, where -1 means logo palette, and 0 or above means index in list of custom (if exists) or calculated palettes
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {siteDesignClickOnDesiredPaletteFromCustomizePalleteParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteDesignClickOnDesiredPaletteFromCustomizePallete = function (params) {
    return { evid: 314, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} sectionDesignSectionHeightButtonsDisappearedParams
* @property {string} adiBuilderType - desktop / mobile
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {number} revision - builder version
* @property {string} screenResolution - screen resolution
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: sectionDesign - Section Height buttons disappeared. Evid: 577.
 * Event description: Module: sectionDesign. Flow: section height buttons disappears (when user clicks on X).

 * adiBuilderType - Type: string. Desc: desktop / mobile
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {sectionDesignSectionHeightButtonsDisappearedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionDesignSectionHeightButtonsDisappeared = function (params) {
    return { evid: 577, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} siteDesignCustomizeDesignColorPaletteModeColorSelectSuccessParams
* @property {string} adiBuilderType - null
* @property {boolean} advancedEdit - did the pallete open from advanced settings mode or not
* @property {string} editMode - automatic / show me how / no-tour
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} loadTime - loading time between click to success
* @property {number} loading_time - loading time between click to Success
* @property {GUID} msid - metasite id
* @property {string} name - which panel the color from: regular,color picker, hex
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: siteDesign - Customize Design - color palette mode - color select success. Evid: 320.
 * Event description: Module: siteDesign. Flow: user chooses to change color - Success.

 * adiBuilderType - Type: string.
 *
 * advancedEdit - Type: bool. Desc: did the pallete open from advanced settings mode or not
 *
 * editMode - Type: string. Desc: automatic / show me how / no-tour
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * loadTime - Type: numeric. Desc: loading time between click to success
 *
 * loading_time - Type: numeric. Desc: loading time between click to Success
 *
 * msid - Type: guid. Desc: metasite id
 *
 * name - Type: string. Desc: which panel the color from: regular,color picker, hex
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {siteDesignCustomizeDesignColorPaletteModeColorSelectSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteDesignCustomizeDesignColorPaletteModeColorSelectSuccess = function (params) {
    return { evid: 320, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} formEditorEditButtonSuccessParams
* @property {string} adiBuilderType - MED /desktop /headless
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {number} fieldLength - length of text in the field
* @property {string} fieldName - which field is updated: title,subtitle,body,image,button,link, list description
* @property {string} fieldType - text/ dropdown/ link / long text
* @property {string} fieldValue - value selected - only for dropdown fields / empty when user clears field
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} nodeId - unique number per node, in case this is a list - this is the sectionNodeId
* @property {string} origin - stage / panel
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - -
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: formEditor - edit button - success. Evid: 481.
 * Event description: Module: contentEditor. Flow: user edits a field in the form.

 * adiBuilderType - Type: string. Desc: MED /desktop /headless
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * fieldLength - Type: numeric. Desc: length of text in the field
 *
 * fieldName - Type: string. Desc: which field is updated: title,subtitle,body,image,button,link, list description
 *
 * fieldType - Type: string. Desc: text/ dropdown/ link / long text
 *
 * fieldValue - Type: string. Desc: value selected - only for dropdown fields / empty when user clears field
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * nodeId - Type: string. Desc: unique number per node, in case this is a list - this is the sectionNodeId
 *
 * origin - Type: string. Desc: stage / panel
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string. Desc: -
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {formEditorEditButtonSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var formEditorEditButtonSuccess = function (params) {
    return { evid: 481, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderCoreLoadingLoadIframeStartParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} intervalLoadTime - loading time diff from previous phase
* @property {number} loadTime - loading time till this phase
* @property {GUID} msid - metasite id
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - core loading - load iframe (start). Evid: 20.
 * Event description: Module: builder. Flow: phase in loading the core.

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * intervalLoadTime - Type: numeric. Desc: loading time diff from previous phase
 *
 * loadTime - Type: numeric. Desc: loading time till this phase
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderCoreLoadingLoadIframeStartParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderCoreLoadingLoadIframeStart = function (params) {
    return { evid: 20, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} appsAppPanelOpenParams
* @property {string} adiBuilderType - mobile / desktop
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {number} revision - builder version
* @property {string} screenResolution - screen resolution
* @property {string} source - where the panel was opened from (add app dropdown, manage app dropdown)
* @property {string} structureId - structure id
**/
/**
 * Name: apps - App Panel open. Evid: 455.
 * Event description: Module: apps. Flow: user opens the app panel.

 * adiBuilderType - Type: string. Desc: mobile / desktop
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * source - Type: string. Desc: where the panel was opened from (add app dropdown, manage app dropdown)
 *
 * structureId - Type: string. Desc: structure id
 * @param {appsAppPanelOpenParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appsAppPanelOpen = function (params) {
    return { evid: 455, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} pagesManagerAddNewPageSuccessParams
* @property {string} adiBuilderType - null
* @property {string} appId - in case of tpa: app_id/blog
* @property {string} appInstanceId - unique identifier of app (store, bookings, etc.) instance in site
* @property {string} appPageType - some app pages are added automaically by the app: by user / by app
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {boolean} is_columns - flag for columns in selected layout
* @property {number} loadTime - time in ms
* @property {GUID} msid - metasite id
* @property {number} noOfSuggestions - int number that represents the number of suggested layouts that the user saw
* @property {string} nodeId - unique number per node
* @property {string} origin - pages panel / link dialog
* @property {string} pageId - number of page
* @property {string} place - where the group is placed: recommended / others / expanded list
* @property {number} placeOfSelected - int number that represents the place of the selected layout (1 for the first,…)
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} selectedLayout - layout id
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: pagesManager - Add new page - success. Evid: 354.
 * Event description: Module: pagesManager. Flow: user chooses a layout of the new page. .

 * adiBuilderType - Type: string.
 *
 * appId - Type: string. Desc: in case of tpa: app_id/blog
 *
 * appInstanceId - Type: string. Desc: unique identifier of app (store, bookings, etc.) instance in site
 *
 * appPageType - Type: string. Desc: some app pages are added automaically by the app: by user / by app
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * is_columns - Type: bool. Desc: flag for columns in selected layout
 *
 * loadTime - Type: numeric. Desc: time in ms
 *
 * msid - Type: guid. Desc: metasite id
 *
 * noOfSuggestions - Type: numeric. Desc: int number that represents the number of suggested layouts that the user saw
 *
 * nodeId - Type: string. Desc: unique number per node
 *
 * origin - Type: string. Desc: pages panel / link dialog
 *
 * pageId - Type: string. Desc: number of page
 *
 * place - Type: string. Desc: where the group is placed: recommended / others / expanded list
 *
 * placeOfSelected - Type: numeric. Desc: int number that represents the place of the selected layout (1 for the first,…)
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * selectedLayout - Type: string. Desc: layout id
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {pagesManagerAddNewPageSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pagesManagerAddNewPageSuccess = function (params) {
    return { evid: 354, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} loadingFirstTimeCreateStoryGetMetadataCompletedParams
* @property {string} adiBuilderType - desktop / mobile / headless / MED
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} intervalLoadTime - **deprecated**
* @property {number} loadTime - **deprecated**
* @property {GUID} msid - metasite id
* @property {number} numOfTpas - number of TPAS that changed their height
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - TPA height changed. Evid: 500.
 * Event description: Module: builder. Flow: TPA height changed (automatically by document services).

 * adiBuilderType - Type: string. Desc: desktop / mobile / headless / MED
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * intervalLoadTime - Type: numeric. Desc: **deprecated**
 *
 * loadTime - Type: numeric. Desc: **deprecated**
 *
 * msid - Type: guid. Desc: metasite id
 *
 * numOfTpas - Type: numeric. Desc: number of TPAS that changed their height
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {loadingFirstTimeCreateStoryGetMetadataCompletedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var loadingFirstTimeCreateStoryGetMetadataCompleted = function (params) {
    return { evid: 500, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} tourCloseAssistantParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} name - smart-assist,tours
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: tour - Close Assistant. Evid: 55.
 * Event description: Module: tour. Flow: user closes the assistant. .

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * name - Type: string. Desc: smart-assist,tours
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {tourCloseAssistantParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tourCloseAssistant = function (params) {
    return { evid: 55, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} introCreateSiteOnMedClickParams
* @property {string} adiBuilderType - MED
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} loadTime - --not relevant--
* @property {GUID} msid - metasite id
* @property {string} screenResolution - screen resolution
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: intro - create site on MED click. Evid: 25.
 * Event description: Module: intro. Flow: click 'Start' on 'Let's get you a website' page (last page of MED intro).

 * adiBuilderType - Type: string. Desc: MED
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * loadTime - Type: numeric. Desc: --not relevant--
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {introCreateSiteOnMedClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var introCreateSiteOnMedClick = function (params) {
    return { evid: 25, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} medHeadlessWrapperRequestTryParams
* @property {string} action - update's actions (relevant for name=update only)
* @property {string} adiBuilderType - headless
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {string} name - warmup/update/build/publish
* @property {number} revision - builder revision
* @property {string} screenResolution - screen resolution
* @property {string} structureId - structure id
* @property {number} updateRevision - update's revision (relevant for name=update only)
**/
/**
 * Name: MED - Headless Server Request Try. Evid: 810.
 * Event description: Module: MED. Flow: Headless Wrapper request (Warmup, Update, Build, Publish) sent.

 * action - Type: string. Desc: update's actions (relevant for name=update only)
 *
 * adiBuilderType - Type: string. Desc: headless
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * name - Type: string. Desc: warmup/update/build/publish
 *
 * revision - Type: numeric. Desc: builder revision
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * structureId - Type: string. Desc: structure id
 *
 * updateRevision - Type: numeric. Desc: update's revision (relevant for name=update only)
 * @param {medHeadlessWrapperRequestTryParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var medHeadlessWrapperRequestTry = function (params) {
    return { evid: 810, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderPublishTryParams
* @property {string} adiBuilderType - desktop / mobile
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {boolean} isFirst - is first publish
* @property {GUID} msid - metasite id
* @property {number} revision - -
* @property {string} screenResolution - screen resolution
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - publish try. Evid: 78.
 * Event description: Module: builder. Flow: publish started.

 * adiBuilderType - Type: string. Desc: desktop / mobile
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * isFirst - Type: bool. Desc: is first publish
 *
 * msid - Type: guid. Desc: metasite id
 *
 * revision - Type: numeric. Desc: -
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderPublishTryParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderPublishTry = function (params) {
    return { evid: 78, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderLoadingFirstTimeFirstStepCompleteParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} loadTime - loading time till this phase
* @property {GUID} msid - metasite id
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - loading - first time - first step complete. Evid: 176.
 * Event description: Module: builder. Flow: phase 6 in opening the builder (first time) completed..

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * loadTime - Type: numeric. Desc: loading time till this phase
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderLoadingFirstTimeFirstStepCompleteParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderLoadingFirstTimeFirstStepComplete = function (params) {
    return { evid: 176, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} tourWelcomeTourAddPagesInteractionsParams
* @property {string} action - add / remove
* @property {string} adiBuilderType - dekstop / MED / headless
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {GUID} msid - metasite id
* @property {string} pageName - about / contact / blog ...
* @property {string} screenResolution - -
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: tour - welcome tour - Add pages - interactions. Evid: 75.
 * Event description: Module: tour. Flow: when user choose a design kit in welcome tour.

 * action - Type: string. Desc: add / remove
 *
 * adiBuilderType - Type: string. Desc: dekstop / MED / headless
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * pageName - Type: string. Desc: about / contact / blog ...
 *
 * screenResolution - Type: string. Desc: -
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {tourWelcomeTourAddPagesInteractionsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tourWelcomeTourAddPagesInteractions = function (params) {
    return { evid: 75, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} sectionDesignChangeBackgroundImagePositionClickParams
* @property {string} adiBuilderType - null
* @property {string} designId - id of the design
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} name - regular/header/list background
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
* @property {string} value - selected position (top/center/bottom_right...)
**/
/**
 * Name: sectionDesign - change background image position - click. Evid: 568.
 * Event description: Module: sectionDesign. Flow: user changes image position in background image settings.

 * adiBuilderType - Type: string.
 *
 * designId - Type: string. Desc: id of the design
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * name - Type: string. Desc: regular/header/list background
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 *
 * value - Type: string. Desc: selected position (top/center/bottom_right...)
 * @param {sectionDesignChangeBackgroundImagePositionClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionDesignChangeBackgroundImagePositionClick = function (params) {
    return { evid: 568, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} pagesManagerClickOnDeletePageParams
* @property {string} adiBuilderType - null
* @property {string} appId - in case of tpa: app_id/blog
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: pagesManager - Click on Delete page . Evid: 359.
 * Event description: Module: pagesManager. Flow: user clicks on delete page. .

 * adiBuilderType - Type: string.
 *
 * appId - Type: string. Desc: in case of tpa: app_id/blog
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {pagesManagerClickOnDeletePageParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pagesManagerClickOnDeletePage = function (params) {
    return { evid: 359, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} loadingFirstTimeCreateStoryInitContentCompletedParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} intervalLoadTime - loading time diff from previous phase
* @property {number} loadTime - loading time till this phase
* @property {GUID} msid - metasite id
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: loading - first time - CreateStory: Init content completed. Evid: 129.
 * Event description: Module: builder. Flow: phase in opening the builder (first time) completed..

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * intervalLoadTime - Type: numeric. Desc: loading time diff from previous phase
 *
 * loadTime - Type: numeric. Desc: loading time till this phase
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {loadingFirstTimeCreateStoryInitContentCompletedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var loadingFirstTimeCreateStoryInitContentCompleted = function (params) {
    return { evid: 129, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} pagesManagerClickOnSettingsParams
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} pageId - number of page
* @property {string} pageName - page name
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: pagesManager - Click on settings. Evid: 369.
 * Event description: Module: pagesManager. Flow: user clicks on settings button of page, in pages manager.

 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * pageId - Type: string. Desc: number of page
 *
 * pageName - Type: string. Desc: page name
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {pagesManagerClickOnSettingsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pagesManagerClickOnSettings = function (params) {
    return { evid: 369, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} sectionManagementSwitchSectionTypeInTheAddSectionPanelParams
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} pageId - number of page
* @property {string} place - where the group is placed: recommended / others / expanded list
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: sectionManagement - Switch section type in the Add Section panel. Evid: 254.
 * Event description: Module: sectionManagement. Flow: user switches between section types..

 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * pageId - Type: string. Desc: number of page
 *
 * place - Type: string. Desc: where the group is placed: recommended / others / expanded list
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {sectionManagementSwitchSectionTypeInTheAddSectionPanelParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionManagementSwitchSectionTypeInTheAddSectionPanel = function (params) {
    return { evid: 254, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} contentEditorGalleryLayoutChangedParams
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} galleryType - which gallery layout selected: stripSlidshow/fullwidthCollage/…
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {string} layoutType - image / full width / shape
* @property {GUID} msid - metasite id
* @property {number} noOfSuggestions - int number that represents the number of suggested layouts
* @property {string} nodeId - unique number per node, in case this is a list - this is the sectionNodeId
* @property {string} pageId - number of page
* @property {number} placeOfSelected - int number that represents the place of the selected layout (1 for the first,…)
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: contentEditor - Gallery layout changed . Evid: 222.
 * Event description: Module: contentEditor. Flow: user selected a layout from the list & the galleries window is closed (no need to report the close event also). .

 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * galleryType - Type: string. Desc: which gallery layout selected: stripSlidshow/fullwidthCollage/…
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * layoutType - Type: string. Desc: image / full width / shape
 *
 * msid - Type: guid. Desc: metasite id
 *
 * noOfSuggestions - Type: numeric. Desc: int number that represents the number of suggested layouts
 *
 * nodeId - Type: string. Desc: unique number per node, in case this is a list - this is the sectionNodeId
 *
 * pageId - Type: string. Desc: number of page
 *
 * placeOfSelected - Type: numeric. Desc: int number that represents the place of the selected layout (1 for the first,…)
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {contentEditorGalleryLayoutChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var contentEditorGalleryLayoutChanged = function (params) {
    return { evid: 222, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} contentEditorGalleryLayoutWindowClosedParams
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} galleryType - which gallery layout selected: stripSlidshow/fullwidthCollage/…
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {string} layoutType - image / full width / shape
* @property {GUID} msid - metasite id
* @property {number} noOfSuggestions - int number that represents the number of suggested layouts
* @property {string} nodeId - unique number per node, in case this is a list - this is the sectionNodeId
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: contentEditor - Gallery layout window - closed. Evid: 224.
 * Event description: Module: contentEditor. Flow: user closed the layout panel without changing the layout. .

 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * galleryType - Type: string. Desc: which gallery layout selected: stripSlidshow/fullwidthCollage/…
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * layoutType - Type: string. Desc: image / full width / shape
 *
 * msid - Type: guid. Desc: metasite id
 *
 * noOfSuggestions - Type: numeric. Desc: int number that represents the number of suggested layouts
 *
 * nodeId - Type: string. Desc: unique number per node, in case this is a list - this is the sectionNodeId
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {contentEditorGalleryLayoutWindowClosedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var contentEditorGalleryLayoutWindowClosed = function (params) {
    return { evid: 224, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} loadExistingSiteTimeoutParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {number} lastPhase - last phase of the loading process after which timeout occured
* @property {GUID} msid - metasite id
* @property {string} screenResolution - null
* @property {number} secondsSinceLastPhase - how many seconds passed since last phase of the tour
* @property {GUID} uuid - user id
**/
/**
 * Name: Load Existing Site - TImeout. Evid: 173.
 * Event description: Module: builder. Flow: Timeout event.

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * lastPhase - Type: numeric. Desc: last phase of the loading process after which timeout occured
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string.
 *
 * secondsSinceLastPhase - Type: numeric. Desc: how many seconds passed since last phase of the tour
 *
 * uuid - Type: guid. Desc: user id
 * @param {loadExistingSiteTimeoutParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var loadExistingSiteTimeout = function (params) {
    return { evid: 173, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} itemManagerClickOnSetPageAsHomepageParams
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {string} item - pages / menu
* @property {string} itemType - page / section / document / external link etc.
* @property {GUID} msid - metasite id
* @property {string} origin - pages panel / menu panel
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: ItemManager - Click on Set page as homepage. Evid: 361.
 * Event description: Module: ItemManager. Flow: user clicks on 'set as homepage'..

 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * item - Type: string. Desc: pages / menu
 *
 * itemType - Type: string. Desc: page / section / document / external link etc.
 *
 * msid - Type: guid. Desc: metasite id
 *
 * origin - Type: string. Desc: pages panel / menu panel
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {itemManagerClickOnSetPageAsHomepageParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var itemManagerClickOnSetPageAsHomepage = function (params) {
    return { evid: 361, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderPagePresetPreviewLoadedParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} intervalLoadTime - time (in ms) elapsed since loading started
* @property {boolean} isFirstPage - deprecated
* @property {number} loadTime - time (in ms) elapsed since loading started
* @property {string} mode - builder/welcome tour
* @property {GUID} msid - metasite id
* @property {string} origin - fake browser / top bar
* @property {number} pageNumber - page number of fpd layouts
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
* @property {string} view - select a layout / choose your colors / ....
**/
/**
 * Name: builder - full page design loaded. Evid: 22.
 * Event description: Module: builder. Flow: page preset preview loaded after silent builder.

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * intervalLoadTime - Type: numeric. Desc: time (in ms) elapsed since loading started
 *
 * isFirstPage - Type: bool. Desc: deprecated
 *
 * loadTime - Type: numeric. Desc: time (in ms) elapsed since loading started
 *
 * mode - Type: string. Desc: builder/welcome tour
 *
 * msid - Type: guid. Desc: metasite id
 *
 * origin - Type: string. Desc: fake browser / top bar
 *
 * pageNumber - Type: numeric. Desc: page number of fpd layouts
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 *
 * view - Type: string. Desc: select a layout / choose your colors / ....
 * @param {builderPagePresetPreviewLoadedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderPagePresetPreviewLoaded = function (params) {
    return { evid: 22, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} sectionDesignChangeTextPositionSuccessParams
* @property {string} adiBuilderType - mobile or desktop editor
* @property {string} designId - id of the design
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {number} revision - builder version
* @property {string} screenResolution - screen resolution
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} setId - unique identifier of the font set
* @property {string} structureId - structure id
* @property {string} textPosition - text position: top_left,bottom_right,mid_right...
* @property {GUID} uuid - user id
**/
/**
 * Name: sectionDesign - change text position - success. Evid: 575.
 * Event description: Module: sectionDesign. Flow: user changes section text position.

 * adiBuilderType - Type: string. Desc: mobile or desktop editor
 *
 * designId - Type: string. Desc: id of the design
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * setId - Type: string. Desc: unique identifier of the font set
 *
 * structureId - Type: string. Desc: structure id
 *
 * textPosition - Type: string. Desc: text position: top_left,bottom_right,mid_right...
 *
 * uuid - Type: guid. Desc: user id
 * @param {sectionDesignChangeTextPositionSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionDesignChangeTextPositionSuccess = function (params) {
    return { evid: 575, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} contentEditorReorderItemInAListParams
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} nodeId - unique number per node, in case this is a list - this is the sectionNodeId
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: contentEditor - Reorder Item in a list. Evid: 217.
 * Event description: Module: contentEditor. Flow: user moves an item in list and changes its order. .

 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * nodeId - Type: string. Desc: unique number per node, in case this is a list - this is the sectionNodeId
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {contentEditorReorderItemInAListParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var contentEditorReorderItemInAList = function (params) {
    return { evid: 217, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} contentEditorDataInsertedToTpaAutomaticallyParams
* @property {string} adiBuilderType - null
* @property {string} appId - the TPA id
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} extraInfo - additional info for TPAs,e.g for Bookings private/group
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} nodeId - unique number per node, in case this is a list - this is the sectionNodeId
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: contentEditor - Data Inserted to TPA Automatically. Evid: 229.
 * Event description: Module: contentEditor. Flow: data from CMS is inserted to the TPA automatically. .

 * adiBuilderType - Type: string.
 *
 * appId - Type: string. Desc: the TPA id
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * extraInfo - Type: string. Desc: additional info for TPAs,e.g for Bookings private/group
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * nodeId - Type: string. Desc: unique number per node, in case this is a list - this is the sectionNodeId
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {contentEditorDataInsertedToTpaAutomaticallyParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var contentEditorDataInsertedToTpaAutomatically = function (params) {
    return { evid: 229, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} contentEditorChangeColorBehindImageParams
* @property {string} adiBuilderType - desktop / mobile / MED / headless
* @property {string} colorLocation - index of color position
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} nodeId - unique number per node, in case this is a list - this is the sectionNodeId
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - screen_resolution
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: contentEditor - Change Color Behind Image. Evid: 248.
 * Event description: Module: contentEditor. Flow: user changes the color behind image in the media settings panel.

 * adiBuilderType - Type: string. Desc: desktop / mobile / MED / headless
 *
 * colorLocation - Type: string. Desc: index of color position
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * nodeId - Type: string. Desc: unique number per node, in case this is a list - this is the sectionNodeId
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string. Desc: screen_resolution
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {contentEditorChangeColorBehindImageParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var contentEditorChangeColorBehindImage = function (params) {
    return { evid: 248, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderPagePresetPreviewCarouselClickParams
* @property {string} adiBuilderType - null
* @property {string} direction - left / right
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} loadTime - **deprecated**
* @property {string} mode - builder/welcome
* @property {GUID} msid - metasite id
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - full page design - click more. Evid: 29.
 * Event description: Module: builder. Flow: user clicks on left / right (arrows) on the fpd page.

 * adiBuilderType - Type: string.
 *
 * direction - Type: string. Desc: left / right
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * loadTime - Type: numeric. Desc: **deprecated**
 *
 * mode - Type: string. Desc: builder/welcome
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderPagePresetPreviewCarouselClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderPagePresetPreviewCarouselClick = function (params) {
    return { evid: 29, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} introTextManagerRequestForASpecificPageReturnedSuccessfullyParams
* @property {string} adiBuilderType - desktop / mobile / MED / headless
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} loadTime - time elapsed from start
* @property {GUID} msid - metasite id
* @property {number} pageIndex - page number in the site
* @property {string} url - page url
* @property {string} screenResolution - screen resolution
* @property {string} structureId - structure id
* @property {number} totalPages - total number of pages to import
* @property {GUID} uuid - user id
**/
/**
 * Name: intro - Text Manager - request for a specific page returned successfully. Evid: 32.
 * Event description: Module: intro. Flow: a request for a page returned successfully.

 * adiBuilderType - Type: string. Desc: desktop / mobile / MED / headless
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * loadTime - Type: numeric. Desc: time elapsed from start
 *
 * msid - Type: guid. Desc: metasite id
 *
 * pageIndex - Type: numeric. Desc: page number in the site
 *
 * url - Type: string. Desc: page url
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * structureId - Type: string. Desc: structure id
 *
 * totalPages - Type: numeric. Desc: total number of pages to import
 *
 * uuid - Type: guid. Desc: user id
 * @param {introTextManagerRequestForASpecificPageReturnedSuccessfullyParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var introTextManagerRequestForASpecificPageReturnedSuccessfully = function (params) {
    return { evid: 32, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} contentEditorPopupDialogIsClosedParams
* @property {string} adiBuilderType - desktop/mobile
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} name - dialog name
* @property {string} objectType - single / list
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - screen resolution
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} source - how the panel was opened - button/
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: contentEditor - Popup dialog is closed. Evid: 246.
 * Event description: Module: contentEditor. Flow: content editor popup dialog is loaded. E.g., button style dialog..

 * adiBuilderType - Type: string. Desc: desktop/mobile
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * name - Type: string. Desc: dialog name
 *
 * objectType - Type: string. Desc: single / list
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * source - Type: string. Desc: how the panel was opened - button/
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {contentEditorPopupDialogIsClosedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var contentEditorPopupDialogIsClosed = function (params) {
    return { evid: 246, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderTopBarUpgradeOpenOnHoverParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - Top Bar - Upgrade open on hover. Evid: 143.
 * Event description: Module: builder. Flow: user hovers on Upgrade in top bar for 2 seconds.

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderTopBarUpgradeOpenOnHoverParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderTopBarUpgradeOpenOnHover = function (params) {
    return { evid: 143, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} sectionManagementShowMoreSectionPageLayoutsOnScrollParams
* @property {string} adiBuilderType - null
* @property {string} context - context of loading more layouts: add section / replace section / add page
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} nodeId - unique number per node
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: sectionManagement - Show more section / page layouts (on scroll). Evid: 266.
 * Event description: Module: sectionManagement. Flow: user scrolls down and see more layout/pages designs (add / replace)..

 * adiBuilderType - Type: string.
 *
 * context - Type: string. Desc: context of loading more layouts: add section / replace section / add page
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * nodeId - Type: string. Desc: unique number per node
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {sectionManagementShowMoreSectionPageLayoutsOnScrollParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionManagementShowMoreSectionPageLayoutsOnScroll = function (params) {
    return { evid: 266, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} contentEditorChangeLogoSizeParams
* @property {string} adiBuilderType - desktop / mobile / MED / headless
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} nodeId - deprecated
* @property {string} origin - OSI / right click
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - screen_resolution
* @property {number} sizeValue - logo numeric size
* @property {string} structureId - structure id
**/
/**
 * Name: contentEditor - Change Logo Size. Evid: 199.
 * Event description: Module: contentEditor. Flow: user changes the size of the logo in the header.

 * adiBuilderType - Type: string. Desc: desktop / mobile / MED / headless
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * nodeId - Type: string. Desc: deprecated
 *
 * origin - Type: string. Desc: OSI / right click
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string. Desc: screen_resolution
 *
 * sizeValue - Type: numeric. Desc: logo numeric size
 *
 * structureId - Type: string. Desc: structure id
 * @param {contentEditorChangeLogoSizeParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var contentEditorChangeLogoSize = function (params) {
    return { evid: 199, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} contentEditorImageResolutionImproveDialogCancelParams
* @property {string} adiBuilderType - desktop / MED / ...
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} nodeId - unique number per node, in case this is a list - this is the sectionNodeId
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - screen resolution
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: contentEditor - Image Resolution Improve dialog cancel. Evid: 422.
 * Event description: Module: contentEditor. Flow: user closes the Image Resolution Improve dialog and does not approve.

 * adiBuilderType - Type: string. Desc: desktop / MED / ...
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * nodeId - Type: string. Desc: unique number per node, in case this is a list - this is the sectionNodeId
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {contentEditorImageResolutionImproveDialogCancelParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var contentEditorImageResolutionImproveDialogCancel = function (params) {
    return { evid: 422, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} medBuilderUpdateSectionStartParams
* @property {string} adiBuilderType - MED
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {number} revision - builder version
* @property {string} screenResolution - screen resolution
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} selectedLayout - layout id
* @property {string} structureId - structure id
* @property {string} type - single / list/ item
* @property {GUID} uuid - user id
**/
/**
 * Name: MED - Builder - Update Section Start. Evid: 826.
 * Event description: Module: MED. Flow: when user make several changes in the section panel and then clicks done.

 * adiBuilderType - Type: string. Desc: MED
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * selectedLayout - Type: string. Desc: layout id
 *
 * structureId - Type: string. Desc: structure id
 *
 * type - Type: string. Desc: single / list/ item
 *
 * uuid - Type: guid. Desc: user id
 * @param {medBuilderUpdateSectionStartParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var medBuilderUpdateSectionStart = function (params) {
    return { evid: 826, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} pagesManagerGoToPageSuccessParams
* @property {string} adiBuilderType - null
* @property {string} appId - in case of tpa: app_id/blog
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} loadTime - time in ms
* @property {GUID} msid - metasite id
* @property {string} pageId - number of page
* @property {string} pageName - page name
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} selectedLayout - layout id
* @property {string} source - second topbar/ pages panel
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: pagesManager -goTo page - success. Evid: 370.
 * Event description: Module: pagesManager. Flow: user chooses a page to navigate to.

 * adiBuilderType - Type: string.
 *
 * appId - Type: string. Desc: in case of tpa: app_id/blog
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * loadTime - Type: numeric. Desc: time in ms
 *
 * msid - Type: guid. Desc: metasite id
 *
 * pageId - Type: string. Desc: number of page
 *
 * pageName - Type: string. Desc: page name
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * selectedLayout - Type: string. Desc: layout id
 *
 * source - Type: string. Desc: second topbar/ pages panel
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {pagesManagerGoToPageSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pagesManagerGoToPageSuccess = function (params) {
    return { evid: 370, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} pagesManagerTransitionBetweenPagesUpdatedParams
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} pageId - number of page
* @property {string} prevTransitionType - previous transition type: none / horizontal / vertical / cross fade / out-in
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {string} transitionType - none / horizontal / vertical / cross fade / out-in
* @property {GUID} uuid - user id
**/
/**
 * Name: pagesManager - Transition between pages updated. Evid: 364.
 * Event description: Module: pagesManager. Flow: user changes the transition between pages. .

 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * pageId - Type: string. Desc: number of page
 *
 * prevTransitionType - Type: string. Desc: previous transition type: none / horizontal / vertical / cross fade / out-in
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * transitionType - Type: string. Desc: none / horizontal / vertical / cross fade / out-in
 *
 * uuid - Type: guid. Desc: user id
 * @param {pagesManagerTransitionBetweenPagesUpdatedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pagesManagerTransitionBetweenPagesUpdated = function (params) {
    return { evid: 364, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} medGatewayAllocationRequestFailedParams
* @property {string} adiBuilderType - MED
* @property {GUID} esi - editor session id, for every site editing session
* @property {string} instanceId - instance id
* @property {number} loadTime - time elapsed from trial
* @property {GUID} msid - metasite id
* @property {string} reason - reason for failure
* @property {string} screenResolution - null
**/
/**
 * Name: MED - Gateway Allocation Request Failed. Evid: 1802.
 * Event description: Module: MED. Flow: Gateway allocation request failed (allocation didn't succeed).

 * adiBuilderType - Type: string. Desc: MED
 *
 * esi - Type: guid. Desc: editor session id, for every site editing session
 *
 * instanceId - Type: string. Desc: instance id
 *
 * loadTime - Type: numeric. Desc: time elapsed from trial
 *
 * msid - Type: guid. Desc: metasite id
 *
 * reason - Type: string. Desc: reason for failure
 *
 * screenResolution - Type: string.
 * @param {medGatewayAllocationRequestFailedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var medGatewayAllocationRequestFailed = function (params) {
    return { evid: 1802, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} pagesManagerHideUnhidePageSuccessParams
* @property {string} action - hide/unhide
* @property {string} adiBuilderType - desktop/MED
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} pageId - number of page
* @property {string} pageName - page name
* @property {number} revision - builder version
* @property {string} screenResolution - user's device screen resolution
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: pagesManager - hide/unhide page success. Evid: 375.
 * Event description: Module: pagesManager. Flow: hide/unhide page in pages panel settings successful.

 * action - Type: string. Desc: hide/unhide
 *
 * adiBuilderType - Type: string. Desc: desktop/MED
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * pageId - Type: string. Desc: number of page
 *
 * pageName - Type: string. Desc: page name
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string. Desc: user's device screen resolution
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {pagesManagerHideUnhidePageSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pagesManagerHideUnhidePageSuccess = function (params) {
    return { evid: 375, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderUndoRedoLastChangeFetchFromServerParams
* @property {string} action - action type: undo/redo
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - Undo / Redo last change (fetch from server). Evid: 451.
 * Event description: Module: builder. Flow: user clicks the undo / redo many times and we have to go to server to retrieve the relevant revision.
Can't be fired without event 140 before..

 * action - Type: string. Desc: action type: undo/redo
 *
 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderUndoRedoLastChangeFetchFromServerParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderUndoRedoLastChangeFetchFromServer = function (params) {
    return { evid: 451, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderTopBarSiteHistoryClickParams
* @property {string} adiBuilderType - desktop/MED/headless
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} screenResolution - user device screen resolution
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - Top Bar - Site History click. Evid: 281.
 * Event description: Module: builder. Flow: user clicks on Site History in Site menu.

 * adiBuilderType - Type: string. Desc: desktop/MED/headless
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string. Desc: user device screen resolution
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderTopBarSiteHistoryClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderTopBarSiteHistoryClick = function (params) {
    return { evid: 281, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderTopBarWixLogoClickParams
* @property {string} adiBuilderType - type of builder editor: mobile / desktop
* @property {GUID} esi - editing session id
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - msid
* @property {string} screenResolution - screen resolution
* @property {string} structureId - structure id
* @property {GUID} uuid - uuid
**/
/**
 * Name: builder - Top Bar - Wix logo click. Evid: 190.
 * Event description: Module: builder. Flow: user clicks the wix logo in the builder.

 * adiBuilderType - Type: string. Desc: type of builder editor: mobile / desktop
 *
 * esi - Type: guid. Desc: editing session id
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: msid
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: uuid
 * @param {builderTopBarWixLogoClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderTopBarWixLogoClick = function (params) {
    return { evid: 190, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderTopBarAccountMenuDialogOpenParams
* @property {string} adiBuilderType - type of builder editor: mobile / desktop
* @property {GUID} esi - editing session id
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - msid
* @property {string} screenResolution - screen resolution
* @property {string} structureId - structure id
* @property {GUID} uuid - uuid
**/
/**
 * Name: builder - Top Bar - account menu dialog open. Evid: 184.
 * Event description: Module: builder. Flow: user hovers on the account menu at the top bar (and the menu opens).

 * adiBuilderType - Type: string. Desc: type of builder editor: mobile / desktop
 *
 * esi - Type: guid. Desc: editing session id
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: msid
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: uuid
 * @param {builderTopBarAccountMenuDialogOpenParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderTopBarAccountMenuDialogOpen = function (params) {
    return { evid: 184, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} contentEditorPanelClosedParams
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} nodeId - unique number per node, in case this is a list - this is the sectionNodeId
* @property {string} objectType - single / list / field
* @property {string} pageId - number of page
* @property {string} panelType - main / list item / social panel / media settings
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: contentEditor - Panel closed. Evid: 201.
 * Event description: Module: contentEditor. Flow: user clicks on x / cancel to close a window (for every panel in the content editor). .

 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * nodeId - Type: string. Desc: unique number per node, in case this is a list - this is the sectionNodeId
 *
 * objectType - Type: string. Desc: single / list / field
 *
 * pageId - Type: string. Desc: number of page
 *
 * panelType - Type: string. Desc: main / list item / social panel / media settings
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {contentEditorPanelClosedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var contentEditorPanelClosed = function (params) {
    return { evid: 201, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} loadingFirstTimeInitDataProvisionTpasParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} intervalLoadTime - loading time diff from previous phase
* @property {number} loadTime - loading time till this phase
* @property {GUID} msid - metasite id
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: loading - first time - Init Data: Provision TPAs. Evid: 172.
 * Event description: Module: builder. Flow: phase in opening the builder (first time) started.

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * intervalLoadTime - Type: numeric. Desc: loading time diff from previous phase
 *
 * loadTime - Type: numeric. Desc: loading time till this phase
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {loadingFirstTimeInitDataProvisionTpasParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var loadingFirstTimeInitDataProvisionTpas = function (params) {
    return { evid: 172, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderPublishSiteCongratsPageViewParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} pageView - --
* @property {string} referralAdditionalInfo - --
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - Publish Site - Congrats page view. Evid: 164.
 * Event description: Module: builder. Flow: post publish congrats page view. .

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * pageView - Type: string. Desc: --
 *
 * referralAdditionalInfo - Type: string. Desc: --
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderPublishSiteCongratsPageViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderPublishSiteCongratsPageView = function (params) {
    return { evid: 164, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderUndoRedoLastChangeParams
* @property {string} action - action type: undo/redo
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - Undo / Redo last change. Evid: 140.
 * Event description: Module: builder. Flow: user clicks the undo / redo. .

 * action - Type: string. Desc: action type: undo/redo
 *
 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderUndoRedoLastChangeParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderUndoRedoLastChange = function (params) {
    return { evid: 140, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} medBuilderWarmupRequestFailedParams
* @property {string} adiBuilderType - MED
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} loadTime - time elapsed from start
* @property {string} reason - reason for failure
* @property {number} revision - revision
* @property {string} screenResolution - screen resolution
* @property {string} structureId - structure id
**/
/**
 * Name: MED - Builder - Warmup Request Failed. Evid: 833.
 * Event description: Module: MED. Flow: Builder sends a watmup request failed.

 * adiBuilderType - Type: string. Desc: MED
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * loadTime - Type: numeric. Desc: time elapsed from start
 *
 * reason - Type: string. Desc: reason for failure
 *
 * revision - Type: numeric. Desc: revision
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * structureId - Type: string. Desc: structure id
 * @param {medBuilderWarmupRequestFailedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var medBuilderWarmupRequestFailed = function (params) {
    return { evid: 833, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderTopBarAddDropdownListOpenOnHoverParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} loadTime - loading time till this phase
* @property {GUID} msid - metasite id
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - Top Bar - Add dropdown list open on hover. Evid: 177.
 * Event description: Module: builder. Flow: user hovers (for 2 seconds) on the Add  button and the dropdown list is open.

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * loadTime - Type: numeric. Desc: loading time till this phase
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderTopBarAddDropdownListOpenOnHoverParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderTopBarAddDropdownListOpenOnHover = function (params) {
    return { evid: 177, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} tourPhaseDuringTourParams
* @property {string} adiBuilderType - null
* @property {string} assistType - tours / smart assist
* @property {string} designId - id of the design, only for the style dialog phase
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} name - name of tour: welcome / preview / design-entire website / design-fonts&colors / edit section / add section / add page
* @property {string} phaseName - name of phase
* @property {number} phaseNumber - number of phase in tour
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {number} totalPhases - number of total phases in tour
* @property {GUID} uuid - user id
**/
/**
 * Name: tour - Phase during Tour. Evid: 51.
 * Event description: Module: tour. Flow: a phase during the tour happened. .

 * adiBuilderType - Type: string.
 *
 * assistType - Type: string. Desc: tours / smart assist
 *
 * designId - Type: string. Desc: id of the design, only for the style dialog phase
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * name - Type: string. Desc: name of tour: welcome / preview / design-entire website / design-fonts&colors / edit section / add section / add page
 *
 * phaseName - Type: string. Desc: name of phase
 *
 * phaseNumber - Type: numeric. Desc: number of phase in tour
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * totalPhases - Type: numeric. Desc: number of total phases in tour
 *
 * uuid - Type: guid. Desc: user id
 * @param {tourPhaseDuringTourParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tourPhaseDuringTour = function (params) {
    return { evid: 51, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} pagesManagerDuplicatePageClickParams
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} originPageId - number of origin page
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: pagesManager - Duplicate page click. Evid: 367.
 * Event description: Module: pagesManager. Flow: user clicks on duplicate page - try to.

 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * originPageId - Type: string. Desc: number of origin page
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {pagesManagerDuplicatePageClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pagesManagerDuplicatePageClick = function (params) {
    return { evid: 367, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} contentEditorHideComponentFromSiteParams
* @property {string} action - hide/unhide
* @property {string} adiBuilderType - desktop / mobile
* @property {string} editMode - automatic / show me how / manual / smart assist
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} fieldName - which field is updated: title,subtitle,body,image,button,link, list description
* @property {string} fieldType - text/ dropdown/ link / long text
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} origin - smart assist
* @property {number} revision - builder version
* @property {string} screenResolution - screen resolution
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: contentEditor - hide component from site. Evid: 241.
 * Event description: Module: contentEditor. Flow: user clicks on 'hide Icons' in smart assist card tour.

 * action - Type: string. Desc: hide/unhide
 *
 * adiBuilderType - Type: string. Desc: desktop / mobile
 *
 * editMode - Type: string. Desc: automatic / show me how / manual / smart assist
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * fieldName - Type: string. Desc: which field is updated: title,subtitle,body,image,button,link, list description
 *
 * fieldType - Type: string. Desc: text/ dropdown/ link / long text
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * origin - Type: string. Desc: smart assist
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {contentEditorHideComponentFromSiteParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var contentEditorHideComponentFromSite = function (params) {
    return { evid: 241, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderTopBarCreateNewSiteParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - Top Bar - Create new site. Evid: 180.
 * Event description: Module: builder. Flow: user clicks on create new site from sites or account menu.

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderTopBarCreateNewSiteParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderTopBarCreateNewSite = function (params) {
    return { evid: 180, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderTopBarPublishSiteClickParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {string} mode - builder / preview in welcome tour / preview in builder
* @property {GUID} msid - metasite id
* @property {number} revision - -
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - Top Bar - Publish Site click. Evid: 163.
 * Event description: Module: builder. Flow: user clicks on publish site. .

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * mode - Type: string. Desc: builder / preview in welcome tour / preview in builder
 *
 * msid - Type: guid. Desc: metasite id
 *
 * revision - Type: numeric. Desc: -
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderTopBarPublishSiteClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderTopBarPublishSiteClick = function (params) {
    return { evid: 163, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderTopBarSiteSettingsMenuDialogOpenParams
* @property {string} adiBuilderType - type of builder editor: mobile / desktop
* @property {GUID} esi - editing session id
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - msid
* @property {string} screenResolution - screen resolution
* @property {string} structureId - structure id
* @property {GUID} uuid - uuid
**/
/**
 * Name: builder - Top Bar - Site/settings menu dialog open. Evid: 182.
 * Event description: Module: builder. Flow: user hovers on the site/settings  menu at the top bar (and the menu opens).

 * adiBuilderType - Type: string. Desc: type of builder editor: mobile / desktop
 *
 * esi - Type: guid. Desc: editing session id
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: msid
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: uuid
 * @param {builderTopBarSiteSettingsMenuDialogOpenParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderTopBarSiteSettingsMenuDialogOpen = function (params) {
    return { evid: 182, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderLoadingErrorParams
* @property {string} adiBuilderType - null
* @property {string} err - error message
* @property {GUID} esi - session id
* @property {string} instanceId - instance id
* @property {string} loadType - "new" for initial load / "existing" for exisitng load
* @property {GUID} msid - metasite id
* @property {string} screenResolution - null
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - loading - error. Evid: 167.
 * Event description: Module: builder. Flow: error during first / existing loading . .

 * adiBuilderType - Type: string.
 *
 * err - Type: string. Desc: error message
 *
 * esi - Type: guid. Desc: session id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * loadType - Type: string. Desc: "new" for initial load / "existing" for exisitng load
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string.
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderLoadingErrorParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderLoadingError = function (params) {
    return { evid: 167, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} sectionDesignOpenBackgroundImageSettingsParams
* @property {string} adiBuilderType - null
* @property {string} designId - id of the design
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} name - regular/header/list background
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: sectionDesign - open background image settings. Evid: 567.
 * Event description: Module: sectionDesign. Flow: user clicks on background image settings.

 * adiBuilderType - Type: string.
 *
 * designId - Type: string. Desc: id of the design
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * name - Type: string. Desc: regular/header/list background
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {sectionDesignOpenBackgroundImageSettingsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionDesignOpenBackgroundImageSettings = function (params) {
    return { evid: 567, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderTopBarGoToMyDashboardParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {number} revision - -
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - Top Bar - Go To My Dashboard. Evid: 148.
 * Event description: Module: builder. Flow: user clicks on site > my dashboard. .

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * revision - Type: numeric. Desc: -
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderTopBarGoToMyDashboardParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderTopBarGoToMyDashboard = function (params) {
    return { evid: 148, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} sectionManagementFetchImagesInAddSectionPanelParams
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {number} numOfImages - number of available images
* @property {string} pageId - number of page
* @property {string} place - where the group is placed: recommended / others / expanded list
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: sectionManagement - fetch images in add section panel. Evid: 272.
 * Event description: Module: sectionManagement. Flow: in add section imported images are fetched and inserted into draft sections.

 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * numOfImages - Type: numeric. Desc: number of available images
 *
 * pageId - Type: string. Desc: number of page
 *
 * place - Type: string. Desc: where the group is placed: recommended / others / expanded list
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {sectionManagementFetchImagesInAddSectionPanelParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionManagementFetchImagesInAddSectionPanel = function (params) {
    return { evid: 272, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} introSiteConverterPagesNavigationClickParams
* @property {string} adiBuilderType - NA
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} mainCategory - the category from the 'vertical selector' category that the user chose
* @property {string} navButton - name of navigation button: next / skip / back / escape
* @property {string} nextView - name of next page: business type / services selection / business name / location / search confirm / search results / edit info card / builder / pro editor
* @property {string} screenResolution - screen resolution
* @property {GUID} uuid - user id
* @property {string} view - page name
**/
/**
 * Name: intro - Site Converter pages - navigation click. Evid: 121.
 * Event description: Module: intro. Flow: user clicks on a navigation button on the pages of Site Converter.

 * adiBuilderType - Type: string. Desc: NA
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * mainCategory - Type: string. Desc: the category from the 'vertical selector' category that the user chose
 *
 * navButton - Type: string. Desc: name of navigation button: next / skip / back / escape
 *
 * nextView - Type: string. Desc: name of next page: business type / services selection / business name / location / search confirm / search results / edit info card / builder / pro editor
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * uuid - Type: guid. Desc: user id
 *
 * view - Type: string. Desc: page name
 * @param {introSiteConverterPagesNavigationClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var introSiteConverterPagesNavigationClick = function (params) {
    return { evid: 121, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderZoomInOutParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {number} scale - what is the scale after the click: 1,2,3,4,5
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
* @property {string} zoomType - zoom in / zoom out
**/
/**
 * Name: builder - Zoom in / out. Evid: 166.
 * Event description: Module: builder. Flow: user zooms in / out the site. .

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * scale - Type: numeric. Desc: what is the scale after the click: 1,2,3,4,5
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 *
 * zoomType - Type: string. Desc: zoom in / zoom out
 * @param {builderZoomInOutParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderZoomInOut = function (params) {
    return { evid: 166, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} loadingFirstTimeCreateStoryGetMetadataInitContentParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} intervalLoadTime - loading time diff from previous phase
* @property {number} loadTime - loading time till this phase
* @property {GUID} msid - metasite id
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: loading - first time - CreateStory: Get Metadata | Init content. Evid: 127.
 * Event description: Module: builder. Flow: phase in opening the builder (first time) started..

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * intervalLoadTime - Type: numeric. Desc: loading time diff from previous phase
 *
 * loadTime - Type: numeric. Desc: loading time till this phase
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {loadingFirstTimeCreateStoryGetMetadataInitContentParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var loadingFirstTimeCreateStoryGetMetadataInitContent = function (params) {
    return { evid: 127, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} loadingExistingSiteLoadStoryBackwardCompatibilityParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} intervalLoadTime - loading time diff from previous phase
* @property {number} loadTime - loading time till this phase
* @property {GUID} msid - metasite id
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: loading - existing site - LoadStory: Backward Compatibility. Evid: 513.
 * Event description: Module: builder. Flow: phase in opening the builder (existing site) started..

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * intervalLoadTime - Type: numeric. Desc: loading time diff from previous phase
 *
 * loadTime - Type: numeric. Desc: loading time till this phase
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {loadingExistingSiteLoadStoryBackwardCompatibilityParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var loadingExistingSiteLoadStoryBackwardCompatibility = function (params) {
    return { evid: 513, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} sectionDesignChangeHeaderTransparencySuccessParams
* @property {string} adiBuilderType - mobile or desktop editor
* @property {string} changeBy - user/system
* @property {string} designId - id of the design
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} loadTime - time for change suucces
* @property {GUID} msid - metasite id
* @property {string} pageId - page id
* @property {number} revision - builder version
* @property {string} screenResolution - screen resolution
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
* @property {string} value - value set: solid/transparent/freeze
**/
/**
 * Name: sectionDesign - change header transparency - success. Evid: 573.
 * Event description: Module: sectionDesign. Flow: homepage header transparency changed (by user or system initiated) - success.

 * adiBuilderType - Type: string. Desc: mobile or desktop editor
 *
 * changeBy - Type: string. Desc: user/system
 *
 * designId - Type: string. Desc: id of the design
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * loadTime - Type: numeric. Desc: time for change suucces
 *
 * msid - Type: guid. Desc: metasite id
 *
 * pageId - Type: string. Desc: page id
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 *
 * value - Type: string. Desc: value set: solid/transparent/freeze
 * @param {sectionDesignChangeHeaderTransparencySuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionDesignChangeHeaderTransparencySuccess = function (params) {
    return { evid: 573, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} loadingExistingSiteCompleteParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {number} focusOnTab - 1 - if the tab was focused during the loading time, 0 if switched tabs during loading
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} intervalLoadTime - loading time diff from previous phase
* @property {number} loadTime - loading time till this phase
* @property {string} loadType - existing site / template
* @property {string} loadingDetails - loading details json (# pages, # tpa pages, etc)
* @property {GUID} msid - metasite id
* @property {GUID} originalEsi - ESI generated by the server or passed via query param
* @property {string} screenResolution - null
* @property {number} storyGzipSize - story blob Gzip size (represents bytes), not arriving for all users
* @property {number} storySize - story blob size (represents bytes), not arriving for all users
* @property {string} structureId - structure id
* @property {number} timeInPage - time that user spent in ADI tab (in ms)
* @property {GUID} uuid - user id
* @property {string} validStory - true / false
**/
/**
 * Name: loading - existing site - complete. Evid: 139.
 * Event description: Module: builder. Flow: builder is loaded with existing site (NOT from the intro). .

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * focusOnTab - Type: numeric. Desc: 1 - if the tab was focused during the loading time, 0 if switched tabs during loading
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * intervalLoadTime - Type: numeric. Desc: loading time diff from previous phase
 *
 * loadTime - Type: numeric. Desc: loading time till this phase
 *
 * loadType - Type: string. Desc: existing site / template
 *
 * loadingDetails - Type: string. Desc: loading details json (# pages, # tpa pages, etc)
 *
 * msid - Type: guid. Desc: metasite id
 *
 * originalEsi - Type: guid. Desc: ESI generated by the server or passed via query param
 *
 * screenResolution - Type: string.
 *
 * storyGzipSize - Type: numeric. Desc: story blob Gzip size (represents bytes), not arriving for all users
 *
 * storySize - Type: numeric. Desc: story blob size (represents bytes), not arriving for all users
 *
 * structureId - Type: string. Desc: structure id
 *
 * timeInPage - Type: numeric. Desc: time that user spent in ADI tab (in ms)
 *
 * uuid - Type: guid. Desc: user id
 *
 * validStory - Type: string. Desc: true / false
 * @param {loadingExistingSiteCompleteParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var loadingExistingSiteComplete = function (params) {
    return { evid: 139, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderCoreLoadingWizardServiceMenuServiceInitializeParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} intervalLoadTime - loading time diff from previous phase
* @property {number} loadTime - loading time till this phase
* @property {string} loadType - new site / existing site
* @property {GUID} msid - metasite id
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - core loading - wizard service - menu service initialize. Evid: 14.
 * Event description: Module: builder. Flow: phase in loading the core.

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * intervalLoadTime - Type: numeric. Desc: loading time diff from previous phase
 *
 * loadTime - Type: numeric. Desc: loading time till this phase
 *
 * loadType - Type: string. Desc: new site / existing site
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderCoreLoadingWizardServiceMenuServiceInitializeParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderCoreLoadingWizardServiceMenuServiceInitialize = function (params) {
    return { evid: 14, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderMobileMenuBubbleShowParams
* @property {string} adiBuilderType - -
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} screenResolution - -
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - mobile menu - bubble show. Evid: 41.
 * Event description: Module: builder. Flow: when user make changes in mobile header and the 'show menu' toggle is off.

 * adiBuilderType - Type: string. Desc: -
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string. Desc: -
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderMobileMenuBubbleShowParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderMobileMenuBubbleShow = function (params) {
    return { evid: 41, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} sectionDesignChangeHeaderTransparencyStartParams
* @property {string} adiBuilderType - mobile or desktop editor
* @property {string} changeBy - user/system
* @property {string} designId - id of the design
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} pageId - page id
* @property {number} revision - builder version
* @property {string} screenResolution - screen resolution
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
* @property {string} value - value set: solid/transparent/freeze
**/
/**
 * Name: sectionDesign - change header transparency - start. Evid: 572.
 * Event description: Module: sectionDesign. Flow: homepage header transparency changed (by user or system initiated) - start.

 * adiBuilderType - Type: string. Desc: mobile or desktop editor
 *
 * changeBy - Type: string. Desc: user/system
 *
 * designId - Type: string. Desc: id of the design
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * pageId - Type: string. Desc: page id
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 *
 * value - Type: string. Desc: value set: solid/transparent/freeze
 * @param {sectionDesignChangeHeaderTransparencyStartParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionDesignChangeHeaderTransparencyStart = function (params) {
    return { evid: 572, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderSuggestedDomainApiRequestParams
* @property {string} adiBuilderType - ADI builder type
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {number} revision - revision
* @property {string} screenResolution - screen_resolution
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - suggested domain API request. Evid: 39.
 * Event description: Module: builder. Flow: suggest domain API is called.

 * adiBuilderType - Type: string. Desc: ADI builder type
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * revision - Type: numeric. Desc: revision
 *
 * screenResolution - Type: string. Desc: screen_resolution
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderSuggestedDomainApiRequestParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderSuggestedDomainApiRequest = function (params) {
    return { evid: 39, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} siteDesignDesignPanelIsLoadedParams
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} origin - how the panel is loaded: header / back from customize
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: siteDesign - Design panel is loaded. Evid: 300.
 * Event description: Module: siteDesign. Flow: user clicks on 'design' and the panel is loaded. also when the user clicks on 'back' from the customize design panel. .

 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * origin - Type: string. Desc: how the panel is loaded: header / back from customize
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {siteDesignDesignPanelIsLoadedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteDesignDesignPanelIsLoaded = function (params) {
    return { evid: 300, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} contentEditorUpdateEmbedSettingsSuccessParams
* @property {string} adiBuilderType - MED/ desktop
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {number} fieldLength - length of text in the field
* @property {string} fieldName - type / url / frame height /  frame width /
* @property {string} fieldValue - value selected
* @property {GUID} msid - metasite id
* @property {string} nodeId - unique number per node, in case this is a list - this is the sectionNodeId
* @property {string} origin - panel
* @property {number} revision - builder version
* @property {string} screenResolution - -
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - embed
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: contentEditor - update embed settings - success. Evid: 428.
 * Event description: Module: contentEditor. Flow: user edits a field inside a embed settings panel - success.

 * adiBuilderType - Type: string. Desc: MED/ desktop
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * fieldLength - Type: numeric. Desc: length of text in the field
 *
 * fieldName - Type: string. Desc: type / url / frame height /  frame width /
 *
 * fieldValue - Type: string. Desc: value selected
 *
 * msid - Type: guid. Desc: metasite id
 *
 * nodeId - Type: string. Desc: unique number per node, in case this is a list - this is the sectionNodeId
 *
 * origin - Type: string. Desc: panel
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string. Desc: -
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: embed
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {contentEditorUpdateEmbedSettingsSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var contentEditorUpdateEmbedSettingsSuccess = function (params) {
    return { evid: 428, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderPublishContinueClickFirstPublishFlowParams
* @property {string} adiBuilderType - --
* @property {string} domainOption - {Wix domain, Customize domain }
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} screenResolution - --
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - Publish & continue click (first publish flow). Evid: 183.
 * Event description: Module: builder. Flow: user clicks on publish & Continue in first publish..

 * adiBuilderType - Type: string. Desc: --
 *
 * domainOption - Type: string. Desc: {Wix domain, Customize domain }
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string. Desc: --
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderPublishContinueClickFirstPublishFlowParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderPublishContinueClickFirstPublishFlow = function (params) {
    return { evid: 183, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderSuggestedDomainIsDismissedParams
* @property {string} adiBuilderType - ADI builder type
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {number} revision - revision
* @property {string} screenResolution - screen_resolution
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - suggested domain is dismissed. Evid: 38.
 * Event description: Module: builder. Flow: a suggested domain is dismissed from fakebrowser.

 * adiBuilderType - Type: string. Desc: ADI builder type
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * revision - Type: numeric. Desc: revision
 *
 * screenResolution - Type: string. Desc: screen_resolution
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderSuggestedDomainIsDismissedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderSuggestedDomainIsDismissed = function (params) {
    return { evid: 38, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} builderLinkDialogIsLoadedParams
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {number} fieldLength - length of text in the field
* @property {string} fieldName - which field is updated: title,subtitle,body,image,button,link, list description
* @property {string} fieldType - text/ dropdown/ link / long text
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} nodeId - unique number per node, in case this is a list - this is the sectionNodeId
* @property {string} pageId - number of page
* @property {string} panelType - main / list item / social panel / media settings
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} source - from where the user opened the link dialog {button/richText/menu item}
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: builder - Link dialog is loaded. Evid: 212.
 * Event description: Module: builder. Flow: user clicks on the link property in the section or in the media settings and the dialog is shown..

 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * fieldLength - Type: numeric. Desc: length of text in the field
 *
 * fieldName - Type: string. Desc: which field is updated: title,subtitle,body,image,button,link, list description
 *
 * fieldType - Type: string. Desc: text/ dropdown/ link / long text
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * nodeId - Type: string. Desc: unique number per node, in case this is a list - this is the sectionNodeId
 *
 * pageId - Type: string. Desc: number of page
 *
 * panelType - Type: string. Desc: main / list item / social panel / media settings
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * source - Type: string. Desc: from where the user opened the link dialog {button/richText/menu item}
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {builderLinkDialogIsLoadedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var builderLinkDialogIsLoaded = function (params) {
    return { evid: 212, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} medBuilderWarmupRequestSuccessParams
* @property {string} adiBuilderType - MED
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} loadTime - time elapsed from start
* @property {number} revision - saved revision
* @property {string} screenResolution - screen resolution
* @property {string} structureId - structure id
* @property {string} type - warmup type
**/
/**
 * Name: MED - Builder - Warmup Request Success. Evid: 834.
 * Event description: Module: MED. Flow: Builder sends a watmup request success.

 * adiBuilderType - Type: string. Desc: MED
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * loadTime - Type: numeric. Desc: time elapsed from start
 *
 * revision - Type: numeric. Desc: saved revision
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * structureId - Type: string. Desc: structure id
 *
 * type - Type: string. Desc: warmup type
 * @param {medBuilderWarmupRequestSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var medBuilderWarmupRequestSuccess = function (params) {
    return { evid: 834, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} siteDesignCustomizeDesignOverrideSectionDesignDisplayedParams
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} name - font / element animation / scroll animation
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: siteDesign - Customize Design - override section design displayed. Evid: 330.
 * Event description: Module: siteDesign. Flow: user changes site design and has already set a section with a different animation/font. message is displayed to apply the new animation/font to all sections.

 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * name - Type: string. Desc: font / element animation / scroll animation
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {siteDesignCustomizeDesignOverrideSectionDesignDisplayedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteDesignCustomizeDesignOverrideSectionDesignDisplayed = function (params) {
    return { evid: 330, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} sectionDesignSectionHeightButtonsAreShownParams
* @property {string} adiBuilderType - desktop / mobile
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {number} revision - builder version
* @property {string} screenResolution - screen resolution
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: sectionDesign - Section Height buttons are shown. Evid: 576.
 * Event description: Module: sectionDesign. Flow: user clicks on section height on section customize design dropdown list.

 * adiBuilderType - Type: string. Desc: desktop / mobile
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string. Desc: screen resolution
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {sectionDesignSectionHeightButtonsAreShownParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionDesignSectionHeightButtonsAreShown = function (params) {
    return { evid: 576, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} introTypeBusinessNamePageNavigationClickParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} mainCategory - the category from the 'vertical selector' category that the user chose
* @property {string} navButton - name of navigation button: next / skip / back / escape
* @property {string} nextView - name of next page: business type / services selection / business name / location / search confirm / search results / edit info card / builder / pro editor
* @property {string} screenResolution - null
* @property {string} text - input text
* @property {GUID} uuid - user id
**/
/**
 * Name: intro - Type business name page - navigation click. Evid: 106.
 * Event description: Module: intro. Flow: user clicks on a navigation button in the name of business page (3rd page). .

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * mainCategory - Type: string. Desc: the category from the 'vertical selector' category that the user chose
 *
 * navButton - Type: string. Desc: name of navigation button: next / skip / back / escape
 *
 * nextView - Type: string. Desc: name of next page: business type / services selection / business name / location / search confirm / search results / edit info card / builder / pro editor
 *
 * screenResolution - Type: string.
 *
 * text - Type: string. Desc: input text
 *
 * uuid - Type: guid. Desc: user id
 * @param {introTypeBusinessNamePageNavigationClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var introTypeBusinessNamePageNavigationClick = function (params) {
    return { evid: 106, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} pagesManagerSeoPanelFieldWasUpdatedParams
* @property {string} adiBuilderType - null
* @property {string} appId - in case of tpa: app_id/blog
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {number} fieldLength - length of text in the field (when relevant)
* @property {string} fieldName - which field is updated: title,description,keywords,show in page results, page url
* @property {string} fieldType - text/ boolea button / link
* @property {string} fieldValue - value selected - only for show in seach results - true / false
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: pagesManager - SEO panel - field was updated. Evid: 363.
 * Event description: Module: pagesManager. Flow: field was updated in the seo page. .

 * adiBuilderType - Type: string.
 *
 * appId - Type: string. Desc: in case of tpa: app_id/blog
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * fieldLength - Type: numeric. Desc: length of text in the field (when relevant)
 *
 * fieldName - Type: string. Desc: which field is updated: title,description,keywords,show in page results, page url
 *
 * fieldType - Type: string. Desc: text/ boolea button / link
 *
 * fieldValue - Type: string. Desc: value selected - only for show in seach results - true / false
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {pagesManagerSeoPanelFieldWasUpdatedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pagesManagerSeoPanelFieldWasUpdated = function (params) {
    return { evid: 363, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} sectionManagementReplaceSectionDesignPanelIsLoadedParams
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {GUID} msid - metasite id
* @property {string} nodeId - unique number per node
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} sectionAlias - name of the section in the context of the structure/industry
* @property {string} sectionType - name of the section, about/general description/welcome, can repeat in site several times
* @property {string} source - where was the panel opened from {section/content - bg hidden}
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: sectionManagement - Replace Section design panel is loaded. Evid: 250.
 * Event description: Module: sectionManagement. Flow: user opens replace section design panel.

 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * nodeId - Type: string. Desc: unique number per node
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * sectionAlias - Type: string. Desc: name of the section in the context of the structure/industry
 *
 * sectionType - Type: string. Desc: name of the section, about/general description/welcome, can repeat in site several times
 *
 * source - Type: string. Desc: where was the panel opened from {section/content - bg hidden}
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {sectionManagementReplaceSectionDesignPanelIsLoadedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionManagementReplaceSectionDesignPanelIsLoaded = function (params) {
    return { evid: 250, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} itemManagerPagesMenuPanelIsLoadedParams
* @property {string} adiBuilderType - null
* @property {string} editMode - automatic / show me how / manual
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {string} item - menu / pages
* @property {GUID} msid - metasite id
* @property {string} pageId - number of page
* @property {number} revision - builder version
* @property {string} screenResolution - null
* @property {string} source - origin of opening the pages panel: top bar / second topbar/ header_menu / site pages / manage pages /footer panel
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: itemManager - Pages/menu panel is loaded. Evid: 350.
 * Event description: Module: itemManager. Flow: user clicks on the pages/menu button/manage pages and the pages panel is loaded..

 * adiBuilderType - Type: string.
 *
 * editMode - Type: string. Desc: automatic / show me how / manual
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * item - Type: string. Desc: menu / pages
 *
 * msid - Type: guid. Desc: metasite id
 *
 * pageId - Type: string. Desc: number of page
 *
 * revision - Type: numeric. Desc: builder version
 *
 * screenResolution - Type: string.
 *
 * source - Type: string. Desc: origin of opening the pages panel: top bar / second topbar/ header_menu / site pages / manage pages /footer panel
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {itemManagerPagesMenuPanelIsLoadedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var itemManagerPagesMenuPanelIsLoaded = function (params) {
    return { evid: 350, src: 66, endpoint: 'onboarding', params: params };
};
/**
* @typedef {Object} loadingExistingSiteLoadStoryRecalculatePagesParams
* @property {string} adiBuilderType - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {string} industryId - industry id
* @property {string} instanceId - instance id
* @property {number} intervalLoadTime - loading time diff from previous phase
* @property {number} loadTime - loading time till this phase
* @property {GUID} msid - metasite id
* @property {string} screenResolution - null
* @property {string} structureId - structure id
* @property {GUID} uuid - user id
**/
/**
 * Name: loading - existing site - LoadStory: Recalculate Pages. Evid: 512.
 * Event description: Module: builder. Flow: phase in opening the builder (existing site) started..

 * adiBuilderType - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * industryId - Type: string. Desc: industry id
 *
 * instanceId - Type: string. Desc: instance id
 *
 * intervalLoadTime - Type: numeric. Desc: loading time diff from previous phase
 *
 * loadTime - Type: numeric. Desc: loading time till this phase
 *
 * msid - Type: guid. Desc: metasite id
 *
 * screenResolution - Type: string.
 *
 * structureId - Type: string. Desc: structure id
 *
 * uuid - Type: guid. Desc: user id
 * @param {loadingExistingSiteLoadStoryRecalculatePagesParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var loadingExistingSiteLoadStoryRecalculatePages = function (params) {
    return { evid: 512, src: 66, endpoint: 'onboarding', params: params };
};
//# sourceMappingURL=index.js.map